import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  JSONObject: { input: any; output: any };
};

export type AwxConnectedAccount = {
  __typename?: "AWXConnectedAccount";
  id: Scalars["ID"]["output"];
};

export type Account = {
  __typename?: "Account";
  accountOpenDate: Scalars["DateTime"]["output"];
  apr: Scalars["Float"]["output"];
  billingCycleDay: Scalars["Int"]["output"];
  chaUrl: Scalars["String"]["output"];
  creditLimit: Scalars["Float"]["output"];
  currentBalance: Scalars["Float"]["output"];
  daysPastDueDate: Scalars["Int"]["output"];
  dueAmount: Scalars["Float"]["output"];
  dueDate: Scalars["Date"]["output"];
  dueDateUtc: Scalars["DateTime"]["output"];
  highestCreditUtilised: Scalars["Float"]["output"];
  minimumPayment: Scalars["Float"]["output"];
  overLimitCredit: Scalars["Float"]["output"];
  reason?: Maybe<AccountStatusReason>;
  remainingMinimumPaymentDue: Scalars["Float"]["output"];
  remainingStatementBalance: Scalars["Float"]["output"];
  statementBalance: Scalars["Float"]["output"];
  status?: Maybe<AccountStatus>;
};

export enum AccountStatus {
  Active = "active",
  Closed = "closed",
  Suspended = "suspended",
  Terminated = "terminated",
}

export enum AccountStatusReason {
  Active = "active",
  Bankruptcy = "bankruptcy",
  ChargedOff = "chargedOff",
  CustomerInitiated = "customerInitiated",
  DebtManagementPlan = "debtManagementPlan",
  Deceased = "deceased",
  Delinquent = "delinquent",
  DisasterRecovery = "disasterRecovery",
  DisasterRecoveryCustomerInitiated = "disasterRecoveryCustomerInitiated",
  DisasterRecoveryGenericRestricted = "disasterRecoveryGenericRestricted",
  DisasterRecoveryIssuerInitiated = "disasterRecoveryIssuerInitiated",
  FirstPartyFraud = "firstPartyFraud",
  GenericRestricted = "genericRestricted",
  Hardship = "hardship",
  IssuerInitiated = "issuerInitiated",
  OfacConfirmed = "ofacConfirmed",
  Overlimit = "overlimit",
  PendingBankruptcy = "pendingBankruptcy",
  PendingSettlement = "pendingSettlement",
  ReturnedEmail = "returnedEmail",
  Settled = "settled",
  SuspectedFirstPartyFraud = "suspectedFirstPartyFraud",
  SuspectedOfac = "suspectedOfac",
  SuspectedThirdPartyFraud = "suspectedThirdPartyFraud",
  Terminated = "terminated",
  TermsOfUseViolation = "termsOfUseViolation",
  ThirdPartyFraud = "thirdPartyFraud",
}

export type Address = {
  __typename?: "Address";
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  formattedAddress?: Maybe<Scalars["String"]["output"]>;
  googlePlaceId?: Maybe<Scalars["String"]["output"]>;
  lat?: Maybe<Scalars["Float"]["output"]>;
  line1?: Maybe<Scalars["String"]["output"]>;
  line2?: Maybe<Scalars["String"]["output"]>;
  lng?: Maybe<Scalars["Float"]["output"]>;
  postalCode?: Maybe<Scalars["String"]["output"]>;
  rawAddress: Scalars["String"]["output"];
  state?: Maybe<Scalars["String"]["output"]>;
};

export enum AddressType {
  Residence = "residence",
  Shipping = "shipping",
}

export type AdminDepartmentFilterInput = {
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type AdminExpenseReportFilterInput = {
  createdAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdBefore?: InputMaybe<Scalars["DateTime"]["input"]>;
  departmentId?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  employeeId?: InputMaybe<Array<Scalars["String"]["input"]>>;
  expenseReportStatus?: InputMaybe<Array<ExpenseReportStatus>>;
  managerEmployeeId?: InputMaybe<Array<Scalars["String"]["input"]>>;
  maxEmployeeHeirarchyDepth?: InputMaybe<Scalars["Int"]["input"]>;
  reviewerEmployeeId?: InputMaybe<Array<Scalars["String"]["input"]>>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type AdminOrManagerEmployeeProfileCreateInput = {
  departmentId: Scalars["Int"]["input"];
  managerEmployeeProfileId?: InputMaybe<Scalars["String"]["input"]>;
  workEmail: Scalars["String"]["input"];
};

export type AdminOrManagerEmployeeProfileUpdateInput = {
  departmentId?: InputMaybe<Scalars["Int"]["input"]>;
  managerEmployeeProfileId?: InputMaybe<Scalars["String"]["input"]>;
};

export type AdminOrManagerUserEmployeeCreateInput = {
  employeeProfile: AdminOrManagerEmployeeProfileCreateInput;
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  roles: Array<UserRole>;
};

export type AdminOrManagerUserEmployeeUpdateInput = {
  employeeProfile?: InputMaybe<AdminOrManagerEmployeeProfileUpdateInput>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  roles?: InputMaybe<Array<UserRole>>;
};

export type AdminReportExpenseFilterInput = {
  createdAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdBefore?: InputMaybe<Scalars["DateTime"]["input"]>;
  customField?: InputMaybe<Array<ExpenseCustomFieldFilterInput>>;
  departmentId?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  employeeId?: InputMaybe<Array<Scalars["String"]["input"]>>;
  expenseAmountLessThan?: InputMaybe<Scalars["Float"]["input"]>;
  expenseAmountMoreThan?: InputMaybe<Scalars["Float"]["input"]>;
  expenseCategoryGLId?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  expenseReportId?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  expenseReportStatus?: InputMaybe<Array<ExpenseReportStatus>>;
  expenseStatus?: InputMaybe<Array<ExpenseStatus>>;
  managerEmployeeId?: InputMaybe<Array<Scalars["String"]["input"]>>;
  maxEmployeeHeirarchyDepth?: InputMaybe<Scalars["Int"]["input"]>;
  merchantName?: InputMaybe<Array<Scalars["String"]["input"]>>;
  paymentMethod?: InputMaybe<Array<ExpensePaymentMethod>>;
  policyStatus?: InputMaybe<Array<ExpensePolicyStatus>>;
  reviewerEmployeeId?: InputMaybe<Array<Scalars["String"]["input"]>>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  transactedAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
  transactedBefore?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type AdminStipendExpenseFilterInput = {
  createdAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdBefore?: InputMaybe<Scalars["DateTime"]["input"]>;
  departmentId?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  employeeId?: InputMaybe<Array<Scalars["String"]["input"]>>;
  expenseAmountLessThan?: InputMaybe<Scalars["Float"]["input"]>;
  expenseAmountMoreThan?: InputMaybe<Scalars["Float"]["input"]>;
  managerEmployeeId?: InputMaybe<Array<Scalars["String"]["input"]>>;
  maxEmployeeHeirarchyDepth?: InputMaybe<Scalars["Int"]["input"]>;
  merchantName?: InputMaybe<Array<Scalars["String"]["input"]>>;
  paymentMethod?: InputMaybe<Array<ExpensePaymentMethod>>;
  policyStatus?: InputMaybe<Array<ExpensePolicyStatus>>;
  reviewerEmployeeId?: InputMaybe<Array<Scalars["String"]["input"]>>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  stipendExpenseStatus?: InputMaybe<Array<StipendExpenseStatus>>;
  stipendRuleId?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  transactedAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
  transactedBefore?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type ApplicationAddressInput = {
  city: Scalars["String"]["input"];
  line1: Scalars["String"]["input"];
  line2: Scalars["String"]["input"];
  state: Scalars["String"]["input"];
  zip: Scalars["String"]["input"];
};

export type ApplicationContext = {
  __typename?: "ApplicationContext";
  state: ApplicationState;
  statusInfo?: Maybe<ApplicationStatusInfo>;
};

export type ApplicationDemographicInput = {
  dateOfBirth: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  personalEmail: Scalars["String"]["input"];
  phoneNumber: Scalars["String"]["input"];
  residentialAddress: ApplicationAddressInput;
  shippingAddress?: InputMaybe<ApplicationAddressInput>;
  ssn: Scalars["String"]["input"];
  workEmail?: InputMaybe<Scalars["String"]["input"]>;
};

export enum ApplicationDocumentType {
  AddressProof = "addressProof",
  IdProof = "idProof",
  Other = "other",
}

export type ApplicationFinancialInfoInput = {
  annualIncome: Scalars["Int"]["input"];
  employmentStatus: EmploymentStatus;
  sourceOfIncome: SourceOfIncome;
};

export type ApplicationPendingDocumentRequest = {
  __typename?: "ApplicationPendingDocumentRequest";
  documentType: ApplicationDocumentType;
  reasons: Array<Scalars["String"]["output"]>;
};

export type ApplicationProductInfo = {
  __typename?: "ApplicationProductInfo";
  apr: Scalars["Float"]["output"];
  cashAdvanceApr: Scalars["Float"]["output"];
  chaUrl: Scalars["String"]["output"];
  creditLimit: Scalars["Float"]["output"];
  pricingDisclosureUrl: Scalars["String"]["output"];
};

export enum ApplicationState {
  Approved = "approved",
  DocumentsRequired = "documentsRequired",
  Duplicate = "duplicate",
  Error = "error",
  InProgress = "inProgress",
  InReview = "inReview",
  NotSubmitted = "notSubmitted",
  ProductAcceptance = "productAcceptance",
  Rejected = "rejected",
  UnfreezeBureau = "unfreezeBureau",
}

export type ApplicationStatusInfo = {
  __typename?: "ApplicationStatusInfo";
  lastUpdatedAt: Scalars["DateTime"]["output"];
  pendingDocumentRequests: Array<ApplicationPendingDocumentRequest>;
  productInfo?: Maybe<ApplicationProductInfo>;
};

export enum AttendeeState {
  Hidden = "hidden",
  Optional = "optional",
  Required = "required",
}

export enum AuthProvider {
  Authkit = "authkit",
  GoogleOAuth = "googleOAuth",
}

export enum AuthSourceContext {
  Impersonation = "impersonation",
  Mobile = "mobile",
  Onboarding = "onboarding",
  Web = "web",
}

export type AuthTokenResponse = {
  __typename?: "AuthTokenResponse";
  accessToken: Scalars["String"]["output"];
  accessTokenExpiresAt: Scalars["DateTime"]["output"];
  refreshToken: Scalars["String"]["output"];
  refreshTokenExpiresAt: Scalars["DateTime"]["output"];
  userId?: Maybe<Scalars["String"]["output"]>;
};

export type AuthenticationInitationResponse = {
  __typename?: "AuthenticationInitationResponse";
  authenticationUrl?: Maybe<Scalars["String"]["output"]>;
  isOTPSent?: Maybe<Scalars["Boolean"]["output"]>;
};

export type AwxAuthorizeBeneficiaryAccount = {
  __typename?: "AwxAuthorizeBeneficiaryAccount";
  authorizationCode: Scalars["String"]["output"];
};

export type AwxAuthorizeConnectedAccount = {
  __typename?: "AwxAuthorizeConnectedAccount";
  authorizationCode: Scalars["String"]["output"];
};

export type AwxAuthorizeConnectedAccountInput = {
  accountId: Scalars["String"]["input"];
  codeChallenge: Scalars["String"]["input"];
  scope?: InputMaybe<Array<AwxScopeEnum>>;
};

export enum AwxConnectedAccountStatus {
  ActionRequired = "actionRequired",
  Active = "active",
  Created = "created",
  Inactive = "inactive",
  Submitted = "submitted",
  Suspended = "suspended",
}

export type AwxLinkedAccount = {
  __typename?: "AwxLinkedAccount";
  id: Scalars["String"]["output"];
  status: AwxLinkedAccountStatus;
  usBank?: Maybe<Bank>;
};

export type AwxLinkedAccountCreateInput = {
  accountId: Scalars["String"]["input"];
  accountMask: Scalars["String"]["input"];
  accountName: Scalars["String"]["input"];
  institutionId: Scalars["String"]["input"];
  institutionName: Scalars["String"]["input"];
  publicToken: Scalars["String"]["input"];
  signatoryEmail: Scalars["String"]["input"];
};

export enum AwxLinkedAccountStatus {
  Failed = "failed",
  Pending = "pending",
  Processing = "processing",
  RequiresAction = "requiresAction",
  Succeeded = "succeeded",
  Suspended = "suspended",
}

export type AwxOrganizationState = {
  __typename?: "AwxOrganizationState";
  connectedAccountId: Scalars["String"]["output"];
  connectedAccountStatus?: Maybe<AwxConnectedAccountStatus>;
  createdAt: Scalars["DateTime"]["output"];
  isEligibleToAddBeneficiary: Scalars["Boolean"]["output"];
  linkedAccountId?: Maybe<Scalars["String"]["output"]>;
  linkedAccountStatus?: Maybe<AwxLinkedAccountStatus>;
  organizationId: Scalars["String"]["output"];
  rfiStatus?: Maybe<AwxRfiStatus>;
  updatedAt: Scalars["DateTime"]["output"];
};

export enum AwxRfiStatus {
  ActionRequired = "actionRequired",
  Answered = "answered",
  Closed = "closed",
}

export enum AwxScopeEnum {
  Kyb = "kyb",
  Onboarding = "onboarding",
  RfiEdit = "rfiEdit",
  RfiView = "rfiView",
  TransfersEdit = "transfersEdit",
}

export type Bank = {
  __typename?: "Bank";
  accountName?: Maybe<Scalars["String"]["output"]>;
  accountNumberLastFour?: Maybe<Scalars["String"]["output"]>;
};

export enum BankAccountType {
  Checking = "checking",
  Savings = "savings",
}

export type BankDetails = {
  __typename?: "BankDetails";
  accountCurrency: Scalars["String"]["output"];
  accountName: Scalars["String"]["output"];
  accountNumberLastFour?: Maybe<Scalars["String"]["output"]>;
  accountRoutingType1: Scalars["String"]["output"];
  accountRoutingValue1: Scalars["String"]["output"];
  bankCountryCode: Scalars["String"]["output"];
  localClearingSystem?: Maybe<Scalars["String"]["output"]>;
};

export type BaseError = Error & {
  __typename?: "BaseError";
  code: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type Beneficiary = {
  __typename?: "Beneficiary";
  beneficiary: BeneficiaryDetails;
  beneficiaryId: Scalars["String"]["output"];
  nickname?: Maybe<Scalars["String"]["output"]>;
  paymentMethods: Array<Scalars["String"]["output"]>;
};

export type BeneficiaryAddress = {
  __typename?: "BeneficiaryAddress";
  city: Scalars["String"]["output"];
  countryCode: Scalars["String"]["output"];
  postcode: Scalars["String"]["output"];
  state: Scalars["String"]["output"];
  streetAddress: Scalars["String"]["output"];
};

export type BeneficiaryAddressInput = {
  city: Scalars["String"]["input"];
  countryCode: Scalars["String"]["input"];
  postcode: Scalars["String"]["input"];
  state: Scalars["String"]["input"];
  streetAddress: Scalars["String"]["input"];
};

export type BeneficiaryDetails = {
  __typename?: "BeneficiaryDetails";
  address?: Maybe<BeneficiaryAddress>;
  bankDetails: BankDetails;
  dateOfBirth?: Maybe<Scalars["String"]["output"]>;
  entityType: BeneficiaryEntityType;
  firstName?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
};

export type BeneficiaryDetailsInput = {
  additionalInfo?: InputMaybe<Scalars["String"]["input"]>;
  address: BeneficiaryAddressInput;
  bankDetails: Scalars["String"]["input"];
  dateOfBirth?: InputMaybe<Scalars["String"]["input"]>;
  entityType?: InputMaybe<BeneficiaryEntityType>;
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
};

export enum BeneficiaryEntityType {
  Company = "COMPANY",
  Personal = "PERSONAL",
}

export type Card = {
  __typename?: "Card";
  activatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  cardDesign: Scalars["String"]["output"];
  cardNumber: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  cvv: Scalars["String"]["output"];
  expirationDate: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  last4Digits: Scalars["String"]["output"];
  physicalCard: Scalars["Boolean"]["output"];
  status: CardStatus;
  updatedAt: Scalars["DateTime"]["output"];
};

export type CardArt = {
  __typename?: "CardArt";
  backImageUrl: Scalars["String"]["output"];
  frontImageUrl: Scalars["String"]["output"];
};

export enum CardArtType {
  Hypercard = "hypercard",
  Organization = "organization",
}

export enum CardCancelReason {
  Breach = "breach",
  Lost = "lost",
  Stolen = "stolen",
}

export type CardDesign = {
  __typename?: "CardDesign";
  cardPreviewImageUrl: Scalars["String"]["output"];
  cost: Scalars["Float"]["output"];
  displayCost: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  isMetal: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  primaryHexColor: Scalars["String"]["output"];
  quantityLeft?: Maybe<Scalars["Int"]["output"]>;
};

export type CardReplacement = {
  __typename?: "CardReplacement";
  newCard: ShortCard;
  note: Scalars["String"]["output"];
  oldCard: ShortCard;
};

export enum CardReplacementReason {
  Fraud = "fraud",
  LostOrStolen = "lostOrStolen",
}

export enum CardStatus {
  Active = "active",
  Canceled = "canceled",
  Closed = "closed",
  Failed = "failed",
  Fraud = "fraud",
  Frozen = "frozen",
  LostOrStolen = "lostOrStolen",
  Pending = "pending",
  ReplacementRequested = "replacementRequested",
  Transferred = "transferred",
}

/** Publicly accessible cardholder profile, excludes any sensitive information. This is used for returning display properties of other employees when an employee logs in. */
export type CardholderProfile = {
  __typename?: "CardholderProfile";
  cardholderId: Scalars["String"]["output"];
  dateOfBirth?: Maybe<Scalars["String"]["output"]>;
  delegateHasTransactionAccess?: Maybe<Scalars["Boolean"]["output"]>;
  nameOnCard?: Maybe<Scalars["String"]["output"]>;
  paperlessStatement?: Maybe<Scalars["Boolean"]["output"]>;
  personalEmail: Scalars["String"]["output"];
  phoneNumber: Scalars["String"]["output"];
  residentialAddress?: Maybe<Address>;
  /** If null, residential address is the shipping address. */
  shippingAddress?: Maybe<Address>;
};

export enum CatalogCategory {
  All = "all",
  Popular = "popular",
  Premium = "premium",
}

export type Category = {
  __typename?: "Category";
  coverImage: Scalars["String"]["output"];
  iconImage: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  merchantImage: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type CreateAchPaymentMethodInput = {
  accountNumber: Scalars["String"]["input"];
  accountType: BankAccountType;
  bankName: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  routingNumber: Scalars["String"]["input"];
};

export type CreateDisputeInput = {
  amount: Scalars["String"]["input"];
  merchantContactedDate?: InputMaybe<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  productCancelledDate?: InputMaybe<Scalars["String"]["input"]>;
  productReturnedDate?: InputMaybe<Scalars["String"]["input"]>;
  reason: DisputeReason;
  transactionId: Scalars["Int"]["input"];
};

export type CreateInstantPaymentInput = {
  amount?: InputMaybe<Scalars["String"]["input"]>;
  methodId: Scalars["String"]["input"];
  type: PaymentType;
};

export type CreateStipendRuleInput = {
  amount: Scalars["Float"]["input"];
  category: Scalars["String"]["input"];
  departmentIds?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  expiresAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  frequency: StipendRuleFrequency;
  isBalanceForwardable?: InputMaybe<Scalars["Boolean"]["input"]>;
  isEnabled?: Scalars["Boolean"]["input"];
  isSingleUsage?: InputMaybe<Scalars["Boolean"]["input"]>;
  longDetails?: InputMaybe<Scalars["String"]["input"]>;
  maximumWorkPeriodInDays?: InputMaybe<Scalars["Int"]["input"]>;
  minimumWorkPeriodInDays?: InputMaybe<Scalars["Int"]["input"]>;
  name: Scalars["String"]["input"];
  startsAt: Scalars["DateTime"]["input"];
  terms?: InputMaybe<Scalars["String"]["input"]>;
};

export type Credential = {
  __typename?: "Credential";
  credentialType: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  type: CredentialType;
  value: Scalars["String"]["output"];
};

export enum CredentialType {
  Barcode = "BARCODE",
  Date = "DATE",
  Text = "TEXT",
  Url = "URL",
}

export enum CreditIndicator {
  Credit = "credit",
  Debit = "debit",
}

export type CustomFieldEntities = {
  __typename?: "CustomFieldEntities";
  customFields: Array<CustomFieldEntity>;
};

export type CustomFieldEntity = {
  __typename?: "CustomFieldEntity";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["Int"]["output"];
  listOptions?: Maybe<Array<CustomFieldListOption>>;
  name: Scalars["String"]["output"];
  organizationId: Scalars["String"]["output"];
  parentEntityUuid?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  type: CustomFieldType;
  updatedAt: Scalars["DateTime"]["output"];
  uuid: Scalars["String"]["output"];
};

export type CustomFieldEntityFilterInput = {
  notInState?: InputMaybe<Array<CustomFieldEntityState>>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<Array<CustomFieldEntityState>>;
  type?: InputMaybe<Array<CustomFieldType>>;
};

export type CustomFieldEntityInput = {
  name: Scalars["String"]["input"];
  parentEntityUuid?: InputMaybe<Scalars["String"]["input"]>;
  state: CustomFieldEntityState;
  type: CustomFieldType;
  uuid?: InputMaybe<Scalars["String"]["input"]>;
};

export enum CustomFieldEntityState {
  Deleted = "deleted",
  Hidden = "hidden",
  Optional = "optional",
  Required = "required",
}

export type CustomFieldListOption = {
  __typename?: "CustomFieldListOption";
  createdAt: Scalars["DateTime"]["output"];
  customFieldEntityId: Scalars["Int"]["output"];
  id: Scalars["Int"]["output"];
  isDeleted: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parentFieldOptionUuid?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
  uuid: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type CustomFieldListOptionFilterInput = {
  parentFieldOptionUuid?: InputMaybe<Scalars["String"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type CustomFieldListOptionInput = {
  customFieldEntityId: Scalars["Int"]["input"];
  isDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["String"]["input"];
  parentFieldOptionUuid?: InputMaybe<Scalars["String"]["input"]>;
  uuid?: InputMaybe<Scalars["String"]["input"]>;
  value: Scalars["String"]["input"];
};

export type CustomFieldListOptions = {
  __typename?: "CustomFieldListOptions";
  hasMore: Scalars["Boolean"]["output"];
  listOptions: Array<CustomFieldListOption>;
  nextPageOffset?: Maybe<Scalars["Int"]["output"]>;
};

export enum CustomFieldType {
  Checkbox = "checkbox",
  List = "list",
  MultiLevelList = "multiLevelList",
  ShortText = "shortText",
}

export type Department = {
  __typename?: "Department";
  createdAt: Scalars["DateTime"]["output"];
  displaySpendThisMonth: Scalars["String"]["output"];
  displaySubtitle: Scalars["String"]["output"];
  effectiveAt: Scalars["DateTime"]["output"];
  id: Scalars["Int"]["output"];
  isShown: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  organizationId: Scalars["String"]["output"];
  spendThisMonth: Scalars["Float"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  userRoleCounts: UserRoleCounts;
  uuid: Scalars["String"]["output"];
};

export type DepartmentInput = {
  isShown?: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["String"]["input"];
  /** Used to update a department by a reference uuid. If not provided, a new unique department will be created. */
  uuid?: InputMaybe<Scalars["String"]["input"]>;
};

export type Departments = {
  __typename?: "Departments";
  departments: Array<Department>;
  hasMore: Scalars["Boolean"]["output"];
  nextPageOffset?: Maybe<Scalars["Int"]["output"]>;
};

export enum DigitalWallet {
  ApplePay = "applePay",
  GooglePay = "googlePay",
}

export type Dispute = {
  __typename?: "Dispute";
  activity?: Maybe<Array<DisputeActivity>>;
  /** Use this amount (Not transaction amount) in Dispute Detail Screen */
  amount: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Title for the dispute cell in the Transaction Details screen */
  displayCellTitle: Scalars["String"]["output"];
  /** Status for the dispute cell in the Transaction Details screen, and in the Dispute Details screen */
  displayStatus: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  merchantContactedDate?: Maybe<Scalars["Date"]["output"]>;
  notes: Scalars["String"]["output"];
  productCancelledDate?: Maybe<Scalars["Date"]["output"]>;
  productReturnedDate?: Maybe<Scalars["Date"]["output"]>;
  reason: DisputeReason;
  /** Use resolution along with status to show the right color for dispute status. status=withdrawn -> gray, status=pending -> yellow, status,resolution=resolved,inFavor = green, status,resolution=resolved,against = red */
  resolution?: Maybe<DisputeResolution>;
  /** Use this for `Resolution` field on Dispute Details screen */
  resolutionDescription?: Maybe<DisputeResolutionDescription>;
  /** Use resolution along with status to show the right color for dispute status. status=withdrawn -> gray, status=pending -> yellow, status,resolution=resolved,inFavor = green, status,resolution=resolved,against = red */
  status: DisputeStatus;
  statusIconUrl: Scalars["String"]["output"];
};

export type DisputeActivity = {
  __typename?: "DisputeActivity";
  code: DisputeActivityCode;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  details: DisputeActivityDetail;
  id: Scalars["String"]["output"];
};

export enum DisputeActivityCode {
  Created = "created",
  CustomerEnquiry = "customerEnquiry",
  EvidenceProvided = "evidenceProvided",
  Initiated = "initiated",
  ReceiveSecondPresentment = "receiveSecondPresentment",
  ReportedCardLost = "reportedCardLost",
  ReportedCardStolen = "reportedCardStolen",
  ReportedFraud = "reportedFraud",
  Resolved = "resolved",
  Reversal = "reversal",
  SendArbitrationChargeback = "sendArbitrationChargeback",
  SendChargebackToMc = "sendChargebackToMC",
  Withdrawn = "withdrawn",
}

export type DisputeActivityDetail = {
  __typename?: "DisputeActivityDetail";
  amount?: Maybe<Scalars["String"]["output"]>;
  merchantContactedDate?: Maybe<Scalars["Date"]["output"]>;
  notes?: Maybe<Scalars["String"]["output"]>;
  oldStatus?: Maybe<DisputeStatus>;
  productCancelledDate?: Maybe<Scalars["Date"]["output"]>;
  productReturnedDate?: Maybe<Scalars["Date"]["output"]>;
  reason?: Maybe<DisputeReason>;
  transactionAmount?: Maybe<Scalars["String"]["output"]>;
  transactionId?: Maybe<Scalars["String"]["output"]>;
  transactionMerchantName?: Maybe<Scalars["String"]["output"]>;
};

export enum DisputeReason {
  CompromisedCard = "compromisedCard",
  LostCard = "lostCard",
  Other = "other",
  ProductCancelled = "productCancelled",
  ProductDefective = "productDefective",
  ProductNotAsDescribed = "productNotAsDescribed",
  ProductNotReceived = "productNotReceived",
  ProductReturned = "productReturned",
  StolenCard = "stolenCard",
  WrongAmount = "wrongAmount",
}

export enum DisputeResolution {
  Against = "against",
  InFavor = "inFavor",
  Reversal = "reversal",
}

export enum DisputeResolutionDescription {
  LostAndDebitTransaction = "lostAndDebitTransaction",
  LostAndDebitTransactionAndInterest = "lostAndDebitTransactionAndInterest",
  RebilledCurrentDate = "rebilledCurrentDate",
  RebilledPresentmentDate = "rebilledPresentmentDate",
  Won = "won",
  WrittenOffFraud = "writtenOffFraud",
  WrittenOffNonFraud = "writtenOffNonFraud",
}

export enum DisputeStatus {
  Pending = "pending",
  Resolved = "resolved",
  Withdrawn = "withdrawn",
}

export type EmployeeApplicationStartedContext = {
  __typename?: "EmployeeApplicationStartedContext";
  applicationId: Scalars["String"]["output"];
  employee: OnboardingAutocompleteEmployee;
};

export type EmployeeProfile = {
  __typename?: "EmployeeProfile";
  awxBeneficiaryId?: Maybe<Scalars["String"]["output"]>;
  /** Users that are delegated access to the root user */
  delegateUsers: Array<PublicUser>;
  department: Department;
  departmentId: Scalars["Int"]["output"];
  displayStatus: Scalars["String"]["output"];
  employeeId: Scalars["String"]["output"];
  employmentStartDate?: Maybe<Scalars["Date"]["output"]>;
  /** Users that can be impersonated by this user */
  impersonatableDelegateUsers: Array<PublicUser>;
  manager?: Maybe<PublicUser>;
  managerEmployeeId?: Maybe<Scalars["String"]["output"]>;
  organization: Organization;
  organizationId: Scalars["String"]["output"];
  status: EmployeeProfileStatus;
  workEmail: Scalars["String"]["output"];
};

export enum EmployeeProfileStatus {
  Active = "active",
  Terminated = "terminated",
}

export enum EmploymentStatus {
  CollegeStudent = "collegeStudent",
  FullTime = "fullTime",
  Other = "other",
  PartTime = "partTime",
  Retired = "retired",
  SelfEmployed = "selfEmployed",
  Unemployed = "unemployed",
}

export type Error = {
  code: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type Expense = {
  __typename?: "Expense";
  amount: Scalars["Float"]["output"];
  attendeeEmails: Array<Scalars["String"]["output"]>;
  attendees: Array<PublicEmployee>;
  createdAt: Scalars["DateTime"]["output"];
  customFieldEntries: Array<ExpenseCustomFieldEntry>;
  displayPayoutMethod?: Maybe<Scalars["String"]["output"]>;
  employeeId: Scalars["String"]["output"];
  expenseCategory?: Maybe<ExpenseCategoryGlPairing>;
  expenseCategoryGLId?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["Int"]["output"];
  idempotencyKey: Scalars["String"]["output"];
  merchantName: Scalars["String"]["output"];
  mileageDistance?: Maybe<Scalars["Float"]["output"]>;
  mileageDistanceUnit?: Maybe<MileageDistanceUnit>;
  mileageLocations?: Maybe<Array<Scalars["String"]["output"]>>;
  notes?: Maybe<Scalars["String"]["output"]>;
  paymentMethod: ExpensePaymentMethod;
  payoutMethod?: Maybe<ExpensePayoutMethod>;
  receiptFileUrl?: Maybe<Scalars["String"]["output"]>;
  report: ExpenseReport;
  reportId: Scalars["Int"]["output"];
  status: ExpenseStatus;
  transaction?: Maybe<Transaction>;
  transactionCategoryIconUrl: Scalars["String"]["output"];
  transactionDate: Scalars["Date"]["output"];
  transactionId?: Maybe<Scalars["Int"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
  user: User;
};

export type ExpenseAutofillInfo = {
  __typename?: "ExpenseAutofillInfo";
  amount?: Maybe<Scalars["Float"]["output"]>;
  customFields?: Maybe<Array<ExpenseCustomFieldAutofillInfo>>;
  expenseCategoryGLId?: Maybe<Scalars["Int"]["output"]>;
  merchantName?: Maybe<Scalars["String"]["output"]>;
  transactionDate?: Maybe<Scalars["Date"]["output"]>;
};

export type ExpenseCategoryGlPairing = {
  __typename?: "ExpenseCategoryGLPairing";
  categoryName: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  effectiveAt: Scalars["DateTime"]["output"];
  fieldMapping: FieldMapping;
  glAccount?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["Int"]["output"];
  isShown: Scalars["Boolean"]["output"];
  organizationId: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  uuid: Scalars["String"]["output"];
};

export type ExpenseCategoryGlPairingInput = {
  categoryName: Scalars["String"]["input"];
  fieldMapping?: InputMaybe<FieldMappingInput>;
  glAccount?: InputMaybe<Scalars["String"]["input"]>;
  isShown?: InputMaybe<Scalars["Boolean"]["input"]>;
  uuid: Scalars["String"]["input"];
};

export type ExpenseCategoryGlPairings = {
  __typename?: "ExpenseCategoryGLPairings";
  categories: Array<ExpenseCategoryGlPairing>;
};

export type ExpenseCustomFieldAutofillInfo = {
  __typename?: "ExpenseCustomFieldAutofillInfo";
  booleanValue?: Maybe<Scalars["Boolean"]["output"]>;
  customFieldEntityId: Scalars["Int"]["output"];
  customFieldEntityType: CustomFieldType;
  customFieldListOptionId?: Maybe<Scalars["Int"]["output"]>;
  rawValue?: Maybe<Scalars["String"]["output"]>;
};

export type ExpenseCustomFieldEntry = {
  __typename?: "ExpenseCustomFieldEntry";
  booleanValue?: Maybe<Scalars["Boolean"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  customFieldEntity: CustomFieldEntity;
  customFieldEntityId: Scalars["Int"]["output"];
  customFieldEntityType: CustomFieldType;
  customFieldListOptionId?: Maybe<Scalars["Int"]["output"]>;
  expenseId: Scalars["Int"]["output"];
  id: Scalars["Int"]["output"];
  organizationId: Scalars["String"]["output"];
  rawValue?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ExpenseCustomFieldEntryUpsertInput = {
  booleanValue?: InputMaybe<Scalars["Boolean"]["input"]>;
  customFieldEntityId: Scalars["Int"]["input"];
  customFieldListOptionId?: InputMaybe<Scalars["Int"]["input"]>;
  rawValue?: InputMaybe<Scalars["String"]["input"]>;
};

export type ExpenseCustomFieldFilterInput = {
  customFieldBooleanValue?: InputMaybe<Array<Scalars["Boolean"]["input"]>>;
  customFieldEntityId: Scalars["Int"]["input"];
  customFieldListOptionId?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export enum ExpensePaymentMethod {
  HypercardBusiness = "HYPERCARD_BUSINESS",
  HypercardPersonal = "HYPERCARD_PERSONAL",
  Manual = "MANUAL",
}

export enum ExpensePayoutMethod {
  Ach = "ach",
  External = "external",
  Manual = "manual",
  StatementTransaction = "statementTransaction",
}

export type ExpensePolicies = {
  __typename?: "ExpensePolicies";
  policies: Array<ExpensePolicy>;
};

export type ExpensePolicy = {
  __typename?: "ExpensePolicy";
  departmentIds: Array<Scalars["Int"]["output"]>;
  departments: Array<Department>;
  id: Scalars["Int"]["output"];
  isActive: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  policy: Scalars["String"]["output"];
  updatedByEmployee?: Maybe<User>;
  uuid: Scalars["String"]["output"];
};

export type ExpensePolicyCreateInput = {
  departmentIds?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["String"]["input"];
  policy: Scalars["String"]["input"];
  uuid?: InputMaybe<Scalars["String"]["input"]>;
};

export enum ExpensePolicyStatus {
  InPolicy = "inPolicy",
  MissingInformation = "missingInformation",
  NeedsManualReview = "needsManualReview",
  OutOfPolicy = "outOfPolicy",
}

export type ExpenseReport = {
  __typename?: "ExpenseReport";
  approvedOrRejectedAt?: Maybe<Scalars["DateTime"]["output"]>;
  approvedOrRejectedBy?: Maybe<PublicUser>;
  approvedOrRejectedByEmployeeId?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  designatedApprover?: Maybe<PublicUser>;
  displayPayoutMethod?: Maybe<Scalars["String"]["output"]>;
  displayStatus: Scalars["String"]["output"];
  displayTotalDollarAmount: Scalars["String"]["output"];
  employeeId: Scalars["String"]["output"];
  employerNotes?: Maybe<Scalars["String"]["output"]>;
  expenses: Array<Expense>;
  id: Scalars["Int"]["output"];
  isAutoApproved: Scalars["Boolean"]["output"];
  isInstantReimbursed: Scalars["Boolean"]["output"];
  notes?: Maybe<Scalars["String"]["output"]>;
  status: ExpenseReportStatus;
  statusIconUrl: Scalars["String"]["output"];
  submittedAt?: Maybe<Scalars["DateTime"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  user: User;
};

export enum ExpenseReportAnalyticGroup {
  Category = "CATEGORY",
  CustomField = "CUSTOM_FIELD",
  Department = "DEPARTMENT",
  Employee = "EMPLOYEE",
  ExpenseStatus = "EXPENSE_STATUS",
  Manager = "MANAGER",
  Merchant = "MERCHANT",
  PaymentMethod = "PAYMENT_METHOD",
  PolicyStatus = "POLICY_STATUS",
  ReportStatus = "REPORT_STATUS",
  Reviewer = "REVIEWER",
}

export type ExpenseReportAutoApprovalMetadata = {
  __typename?: "ExpenseReportAutoApprovalMetadata";
  reason?: Maybe<Scalars["String"]["output"]>;
};

export type ExpenseReportCreateInput = {
  notes?: InputMaybe<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
};

export type ExpenseReportEmployeeSpendAnalytic = {
  __typename?: "ExpenseReportEmployeeSpendAnalytic";
  employeeId: Scalars["String"]["output"];
  expenseCount: Scalars["Int"]["output"];
  reportCount: Scalars["Int"]["output"];
  totalExpenseAmount: Scalars["Float"]["output"];
  user: User;
};

export enum ExpenseReportStatus {
  Approved = "approved",
  Draft = "draft",
  PartiallyApproved = "partiallyApproved",
  Pending = "pending",
  Rejected = "rejected",
}

export type ExpenseReportStatusCounts = {
  __typename?: "ExpenseReportStatusCounts";
  approved: Scalars["Int"]["output"];
  draft: Scalars["Int"]["output"];
  partiallyApproved: Scalars["Int"]["output"];
  pending: Scalars["Int"]["output"];
  rejected: Scalars["Int"]["output"];
};

export type ExpenseReports = {
  __typename?: "ExpenseReports";
  hasMore: Scalars["Boolean"]["output"];
  nextPageOffset?: Maybe<Scalars["Int"]["output"]>;
  reportStatusCounts: ExpenseReportStatusCounts;
  reports: Array<ExpenseReport>;
};

export type ExpenseReportsFilterInput = {
  expenseReportStatus?: InputMaybe<Array<ExpenseReportStatus>>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type ExpenseReportsTimeSaved = {
  __typename?: "ExpenseReportsTimeSaved";
  timeSavedPerReportInDays: Scalars["Int"]["output"];
  totalTimeSavedInDays: Scalars["Int"]["output"];
};

export enum ExpenseStatus {
  Approved = "approved",
  Draft = "draft",
  Pending = "pending",
  Rejected = "rejected",
}

export type ExpenseUnionItem = Expense | StipendExpense;

export type ExpenseUpdateInput = {
  amount: Scalars["Float"]["input"];
  attendeeEmails?: InputMaybe<Array<Scalars["String"]["input"]>>;
  customFieldEntries?: InputMaybe<Array<ExpenseCustomFieldEntryUpsertInput>>;
  expenseCategoryGLId?: InputMaybe<Scalars["Int"]["input"]>;
  merchantName: Scalars["String"]["input"];
  mileageDistance?: InputMaybe<Scalars["Float"]["input"]>;
  mileageDistanceUnit?: InputMaybe<MileageDistanceUnit>;
  mileageLocations?: InputMaybe<Array<Scalars["String"]["input"]>>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  transactionDate: Scalars["Date"]["input"];
};

export type ExpenseUpsertInput = {
  amount: Scalars["Float"]["input"];
  attendeeEmails?: InputMaybe<Array<Scalars["String"]["input"]>>;
  customFieldEntries?: InputMaybe<Array<ExpenseCustomFieldEntryUpsertInput>>;
  expenseCategoryGLId?: InputMaybe<Scalars["Int"]["input"]>;
  idempotencyKey: Scalars["String"]["input"];
  merchantName: Scalars["String"]["input"];
  mileageDistance?: InputMaybe<Scalars["Float"]["input"]>;
  mileageDistanceUnit?: InputMaybe<MileageDistanceUnit>;
  mileageLocations?: InputMaybe<Array<Scalars["String"]["input"]>>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  transactionDate: Scalars["Date"]["input"];
  transactionId?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum ExpenseViolationType {
  MissingInformation = "missingInformation",
  NeedsManualReview = "needsManualReview",
  OutOfPolicy = "outOfPolicy",
}

export type Expenses = {
  __typename?: "Expenses";
  expenses: Array<Expense>;
};

export type ExternalMerchant = {
  __typename?: "ExternalMerchant";
  addressDetails?: Maybe<Scalars["String"]["output"]>;
  category: Category;
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  coverImage?: Maybe<Scalars["String"]["output"]>;
  displayName?: Maybe<Scalars["String"]["output"]>;
  formattedAddress?: Maybe<Scalars["String"]["output"]>;
  googleMapUrl?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  latitude?: Maybe<Scalars["String"]["output"]>;
  longitude?: Maybe<Scalars["String"]["output"]>;
  merchantType: Scalars["String"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
  streetName?: Maybe<Scalars["String"]["output"]>;
  streetNumber?: Maybe<Scalars["String"]["output"]>;
  website?: Maybe<Scalars["String"]["output"]>;
  zipcode?: Maybe<Scalars["String"]["output"]>;
};

export enum FeatureFlag {
  HypercardDelegatesShown = "hypercardDelegatesShown",
  HypercardExpenseManagementShown = "hypercardExpenseManagementShown",
  HypercardMileageShown = "hypercardMileageShown",
  HypercardStipendShown = "hypercardStipendShown",
  ProxyExpenseManagementShown = "proxyExpenseManagementShown",
}

export type FeatureFlags = {
  __typename?: "FeatureFlags";
  hypercardDelegatesShown: Scalars["Boolean"]["output"];
  hypercardExpenseManagementShown: Scalars["Boolean"]["output"];
  hypercardMileageShown: Scalars["Boolean"]["output"];
  hypercardStipendShown: Scalars["Boolean"]["output"];
  proxyExpenseManagementShown: Scalars["Boolean"]["output"];
};

export type FieldMapping = {
  __typename?: "FieldMapping";
  attendeeState?: Maybe<Scalars["String"]["output"]>;
  externalReferenceId?: Maybe<Scalars["String"]["output"]>;
};

export type FieldMappingInput = {
  attendeeState: AttendeeState;
  externalReferenceId: Scalars["String"]["input"];
};

export enum FilterCategoryEnum {
  CustomField = "customField",
  Department = "department",
  Employee = "employee",
  ExpenseCategory = "expenseCategory",
  ExpenseStatus = "expenseStatus",
  Merchant = "merchant",
  PolicyStatus = "policyStatus",
  ReportStatus = "reportStatus",
  Reviewer = "reviewer",
  StipendExpenseStatus = "stipendExpenseStatus",
  StipendRule = "stipendRule",
}

export type FilterOption = {
  __typename?: "FilterOption";
  category: FilterCategoryEnum;
  displaySubtitle: Scalars["String"]["output"];
  displayTitle: Scalars["String"]["output"];
  iconUrl?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  secondaryId?: Maybe<Scalars["String"]["output"]>;
};

export type FilterOptions = {
  __typename?: "FilterOptions";
  hasMore: Scalars["Boolean"]["output"];
  nextPageOffset?: Maybe<Scalars["Int"]["output"]>;
  options: Array<FilterOption>;
};

export type GiftCardBrand = {
  __typename?: "GiftCardBrand";
  alwaysShowDisclaimer: Scalars["Boolean"]["output"];
  brandKey: Scalars["String"]["output"];
  brandName: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  disclaimer: Scalars["String"]["output"];
  disclaimerInstructions?: Maybe<Scalars["String"]["output"]>;
  displayInstructions?: Maybe<Scalars["String"]["output"]>;
  effectiveDollarPerPointsValue: Scalars["Float"]["output"];
  hexColor?: Maybe<Scalars["String"]["output"]>;
  imageUrls: ImageUrls;
  /** List of gift card details for the brand */
  items: Array<GiftCardItem>;
  popularityRank: Scalars["Int"]["output"];
  shortDescription: Scalars["String"]["output"];
  terms: Scalars["String"]["output"];
  termsAndConditionsInstructions?: Maybe<Scalars["String"]["output"]>;
};

export type GiftCardCatalog = {
  __typename?: "GiftCardCatalog";
  /** List of brands in the catalog */
  brandList: Array<GiftCardBrand>;
  category: CatalogCategory;
  maximumRedemptionValue: Scalars["Float"]["output"];
  minimumRedemptionValue: Scalars["Float"]["output"];
};

export type GiftCardCreateOrderInput = {
  dollarValue: Scalars["Int"]["input"];
  idempotencyKey?: InputMaybe<Scalars["String"]["input"]>;
  utid: Scalars["String"]["input"];
};

export type GiftCardItem = {
  __typename?: "GiftCardItem";
  faceValue: Scalars["Float"]["output"];
  isWholeAmountValueRequired: Scalars["Boolean"]["output"];
  pointsValue: Scalars["Float"]["output"];
  redemptionInstructions: Scalars["String"]["output"];
  rewardName: Scalars["String"]["output"];
  rewardType: Scalars["String"]["output"];
  utid: Scalars["String"]["output"];
  valueType: Scalars["String"]["output"];
};

export type GiftCardOrder = {
  __typename?: "GiftCardOrder";
  message: Scalars["String"]["output"];
  redemptionInstructions?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
};

export type GiftCardWallet = {
  __typename?: "GiftCardWallet";
  brandName: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  /** List of credentials */
  credentialList: Array<Credential>;
  /** Gift Card credentials */
  credentials: Array<Scalars["JSONObject"]["output"]>;
  externalRefID: Scalars["String"]["output"];
  faceValue: Scalars["Float"]["output"];
  hexColor?: Maybe<Scalars["String"]["output"]>;
  imageUrl: Scalars["String"]["output"];
  redemptionInstructions?: Maybe<Scalars["String"]["output"]>;
};

export type GiftCardWallets = {
  __typename?: "GiftCardWallets";
  giftCardWallets: Array<GiftCardWallet>;
};

export type GraphAnalyticGroupedEntity =
  | Department
  | ExpenseCategoryGlPairing
  | User;

export enum GraphAnalyticInterval {
  Daily = "DAILY",
  Monthly = "MONTHLY",
  Weekly = "WEEKLY",
}

export type GraphAnalyticMetric = {
  __typename?: "GraphAnalyticMetric";
  countPercentageChange?: Maybe<Scalars["Float"]["output"]>;
  displayCountPercentageChange?: Maybe<Scalars["String"]["output"]>;
  displayValuePercentageChange?: Maybe<Scalars["String"]["output"]>;
  groupedEntity?: Maybe<GraphAnalyticGroupedEntity>;
  groupedEntityName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  previous: GraphAnalyticPreviousMetric;
  totalCount: Scalars["Int"]["output"];
  totalValue: Scalars["Float"]["output"];
  valuePercentageChange?: Maybe<Scalars["Float"]["output"]>;
  values: Array<GraphAnalyticMetricValue>;
};

export type GraphAnalyticMetricValue = {
  __typename?: "GraphAnalyticMetricValue";
  count: Scalars["Int"]["output"];
  date: Scalars["Date"]["output"];
  value: Scalars["Float"]["output"];
};

export type GraphAnalyticPreviousMetric = {
  __typename?: "GraphAnalyticPreviousMetric";
  totalCount: Scalars["Int"]["output"];
  totalValue: Scalars["Float"]["output"];
  values: Array<GraphAnalyticMetricValue>;
};

export type GraphAnalyticResponse = {
  __typename?: "GraphAnalyticResponse";
  metrics: Array<GraphAnalyticMetric>;
};

export type GroupedExpenseAggregate = {
  __typename?: "GroupedExpenseAggregate";
  displayPercentage: Scalars["String"]["output"];
  displayTotalAmount: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  percentage: Scalars["Float"]["output"];
  percentageChange: Scalars["Float"]["output"];
  totalAmount: Scalars["Float"]["output"];
};

export type GroupedExpenseSummary = {
  __typename?: "GroupedExpenseSummary";
  displayTotalExpensesAmount: Scalars["String"]["output"];
  groupedExpenseAggregates: Array<GroupedExpenseAggregate>;
  totalExpensesAmount: Scalars["Float"]["output"];
};

export type HypercardMerchant = {
  __typename?: "HypercardMerchant";
  id: Scalars["Int"]["output"];
  logoImageUrl: Scalars["String"]["output"];
};

export type HypercardOwnedGiftCard = {
  __typename?: "HypercardOwnedGiftCard";
  brandName: Scalars["String"]["output"];
  effectiveDiscountPercentage: Scalars["Float"]["output"];
  externalRefID: Scalars["String"]["output"];
  faceValue: Scalars["Float"]["output"];
  hexColor?: Maybe<Scalars["String"]["output"]>;
  imageUrl: Scalars["String"]["output"];
};

export type HypercardOwnedGiftCards = {
  __typename?: "HypercardOwnedGiftCards";
  giftCards: Array<HypercardOwnedGiftCard>;
};

export type ImageUrls = {
  __typename?: "ImageUrls";
  w80_326ppi: Scalars["String"]["output"];
  w130_326ppi: Scalars["String"]["output"];
  w200_326ppi: Scalars["String"]["output"];
  w278_326ppi: Scalars["String"]["output"];
  w300_326ppi: Scalars["String"]["output"];
  w1200_326ppi: Scalars["String"]["output"];
};

export type Insurance = {
  __typename?: "Insurance";
  collectContactNumber: Scalars["String"]["output"];
  contactNumber: Scalars["String"]["output"];
  flair: Scalars["String"]["output"];
  iconUrl: Scalars["String"]["output"];
  longDetails?: Maybe<Scalars["String"]["output"]>;
  shortDetails: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  tollFreeContactNumber: Scalars["String"]["output"];
};

export type Insurances = {
  __typename?: "Insurances";
  insurances: Array<Insurance>;
};

export type IntegerCursorPaginationInput = {
  cursor?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type LinkFeatureFlags = {
  __typename?: "LinkFeatureFlags";
  categoryVisible: Scalars["Boolean"]["output"];
  customFieldVisible: Scalars["Boolean"]["output"];
  departmentVisible: Scalars["Boolean"]["output"];
  invitePeopleVisible: Scalars["Boolean"]["output"];
  projectVisible: Scalars["Boolean"]["output"];
  travelVisible: Scalars["Boolean"]["output"];
};

export type LinkedAccount = {
  __typename?: "LinkedAccount";
  awxLinkedAccount?: Maybe<AwxLinkedAccount>;
  institutionName?: Maybe<Scalars["String"]["output"]>;
};

export type Mileage = {
  __typename?: "Mileage";
  createdAt: Scalars["DateTime"]["output"];
  currency: Scalars["String"]["output"];
  distanceUnit: MileageDistanceUnit;
  effectiveAt: Scalars["DateTime"]["output"];
  id: Scalars["Int"]["output"];
  organizationId: Scalars["String"]["output"];
  rate: Scalars["Float"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  uuid: Scalars["String"]["output"];
};

export enum MileageDistanceUnit {
  Kilometers = "kilometers",
  Miles = "miles",
}

export type MileageInput = {
  currency?: InputMaybe<Scalars["String"]["input"]>;
  distanceUnit?: InputMaybe<MileageDistanceUnit>;
  rate?: InputMaybe<Scalars["Float"]["input"]>;
};

export type MinimumStableVersion = {
  __typename?: "MinimumStableVersion";
  android: Scalars["String"]["output"];
  ios: Scalars["String"]["output"];
};

export type Mutation = {
  __typename?: "Mutation";
  activateCard: MutationActivateCardResult;
  /** Upserts expense to an existing report. Does not affect other expenses in the report. Use case: Web app side drawer expense creation. */
  addExpenseToReport: MutationAddExpenseToReportResult;
  adminUpdateOrganizationalFeatureFlag: MutationAdminUpdateOrganizationalFeatureFlagResult;
  adminUpsertDepartment: MutationAdminUpsertDepartmentResult;
  adminUpsertExpenseCategoryGLPairing: MutationAdminUpsertExpenseCategoryGlPairingResult;
  adminUpsertMileage: MutationAdminUpsertMileageResult;
  approveOrRejectExpenseReport: MutationApproveOrRejectExpenseReportResult;
  approveOrRejectStipendExpense: MutationApproveOrRejectStipendExpenseResult;
  /** Used to authorize a beneficiary account when using the embedded form */
  awxAuthorizeBeneficiaryAccount: MutationAwxAuthorizeBeneficiaryAccountResult;
  awxConnectLinkedAccount: MutationAwxConnectLinkedAccountResult;
  awxCreateAndAuthorizeAccount: MutationAwxCreateAndAuthorizeAccountResult;
  completePersonalEmailUpdate: MutationCompletePersonalEmailUpdateResult;
  createACHPaymentMethod: MutationCreateAchPaymentMethodResult;
  createDispute: MutationCreateDisputeResult;
  createGiftCardOrder: MutationCreateGiftCardOrderResult;
  createHypercardGiftCardOrder: MutationCreateHypercardGiftCardOrderResult;
  createInstantPayment: MutationCreateInstantPaymentResult;
  /** Used to create a new stipend rule. */
  createStipendRule: MutationCreateStipendRuleResult;
  /** Delete a beneficiary account for an organization */
  deleteAwxBeneficiaryAccount: MutationDeleteAwxBeneficiaryAccountResult;
  deleteDraftExpenseReport: MutationDeleteDraftExpenseReportResult;
  deletePaymentMethod: MutationDeletePaymentMethodResult;
  hideGiftCardFromWallet: MutationHideGiftCardFromWalletResult;
  /** Initializes card switch session and returns the sessionId */
  initializeCardSwitch: MutationInitializeCardSwitchResult;
  initiateAuthentication: MutationInitiateAuthenticationResult;
  invalidateRefreshToken: MutationInvalidateRefreshTokenResult;
  inviteEmployee: MutationInviteEmployeeResult;
  /** Parses a receipt image with OCR and returns the populated fields. */
  parseReceiptWithOCR: MutationParseReceiptWithOcrResult;
  /** Process expense report download and get a presigned URL for downloading approved expense report to a CSV file for accounting */
  processExpenseReportDownloadAndGetUrl: MutationProcessExpenseReportDownloadAndGetUrlResult;
  provisionAppleWallet: MutationProvisionAppleWalletResult;
  provisionGoogleWallet: MutationProvisionGoogleWalletResult;
  redeemPointsForCashback: MutationRedeemPointsForCashbackResult;
  referColleagues: MutationReferColleaguesResult;
  refreshAccessToken: MutationRefreshAccessTokenResult;
  registerNotifyMeForFeature: MutationRegisterNotifyMeForFeatureResult;
  registerOfferAnalytic: MutationRegisterOfferAnalyticResult;
  removeAutoPaymentSchedule: MutationRemoveAutoPaymentScheduleResult;
  removeExpenseFromReport: MutationRemoveExpenseFromReportResult;
  replaceCard: MutationReplaceCardResult;
  sendEmailOTP: MutationSendEmailOtpResult;
  simulateTransaction: MutationSimulateTransactionResult;
  startEmployeeApplication: MutationStartEmployeeApplicationResult;
  startPersonalEmailUpdate: MutationStartPersonalEmailUpdateResult;
  startWaitlistUserApplication: MutationStartWaitlistUserApplicationResult;
  submitDraftExpenseReport: MutationSubmitDraftExpenseReportResult;
  submitEmployeeApplication: MutationSubmitEmployeeApplicationResult;
  submitFeedback: MutationSubmitFeedbackResult;
  /** @deprecated Use submitStipendExpenseV2 instead */
  submitStipendExpense: MutationSubmitStipendExpenseResult;
  submitStipendExpenseV2: MutationSubmitStipendExpenseV2Result;
  submitWaitlistUserApplication: MutationSubmitWaitlistUserApplicationResult;
  suspendLinkedAccount: MutationSuspendLinkedAccountResult;
  terminateEmployeeProfile: MutationTerminateEmployeeProfileResult;
  /** Allows users to test a given policy */
  testExpensePolicy: MutationTestExpensePolicyResult;
  unfreezeCreditBureau: MutationUnfreezeCreditBureauResult;
  updateCardPin: MutationUpdateCardPinResult;
  updateCurrentUserEmployeeDelegates: MutationUpdateCurrentUserEmployeeDelegatesResult;
  updateDelegateTransactionAccess: MutationUpdateDelegateTransactionAccessResult;
  updateEmployee: MutationUpdateEmployeeResult;
  updateEmployeesToDepartment: MutationUpdateEmployeesToDepartmentResult;
  updateExpense: MutationUpdateExpenseResult;
  updateFreezeStatus: MutationUpdateFreezeStatusResult;
  updateNotificationSettings: MutationUpdateNotificationSettingsResult;
  updateProductAcceptance: MutationUpdateProductAcceptanceResult;
  updateSAPConnection: MutationUpdateSapConnectionResult;
  /**
   *
   *       Use this mutation carefully. If it finds an existing stipend rule with the same identifier, it will deactivate it and create a new one.
   *       This means that existing stipend wallets will be deemed unusable and can only be used for the new stipend rule in the next cycle.
   *
   */
  updateStipendRule: MutationUpdateStipendRuleResult;
  updateUserAddress: MutationUpdateUserAddressResult;
  updateUserPreferences: MutationUpdateUserPreferencesResult;
  /**
   * Upserts and removes expenses from a report.
   *       If an expense is not in the selected list, it will be removed from the report. If an expense is in the selected list, it will be upserted to the report.
   *       Expenses not part of the list will be removed from the report
   *       USE CASE: Mobile selecting and deselecting multiple expenses to update to a report
   */
  upsertAndRemoveReportExpenses: MutationUpsertAndRemoveReportExpensesResult;
  upsertAutoPaymentSchedule: MutationUpsertAutoPaymentScheduleResult;
  /** Create or update a beneficiary account for an organization */
  upsertAwxBeneficiaryAccount: MutationUpsertAwxBeneficiaryAccountResult;
  /** Upserts a custom field. Can be used to add, update, or delete a custom field. */
  upsertCustomField: MutationUpsertCustomFieldResult;
  /** Upserts a custom field list option. Can be used to add, update, or delete a custom field list option. */
  upsertCustomFieldListOption: MutationUpsertCustomFieldListOptionResult;
  upsertExpenseReport: MutationUpsertExpenseReportResult;
  /** Allow the admin to create an expense policy. */
  upsertPolicy: MutationUpsertPolicyResult;
  validateSAPConnectionAndStoreToken: MutationValidateSapConnectionAndStoreTokenResult;
  /** Validates a stipend rule. */
  validateStipendRule: MutationValidateStipendRuleResult;
  verifyAuthCode: MutationVerifyAuthCodeResult;
  verifyOTPCode: MutationVerifyOtpCodeResult;
  withdrawDispute: MutationWithdrawDisputeResult;
};

export type MutationActivateCardArgs = {
  last4Digits: Scalars["String"]["input"];
};

export type MutationAddExpenseToReportArgs = {
  input: ExpenseUpsertInput;
  receiptFileData?: InputMaybe<Scalars["String"]["input"]>;
  reportId: Scalars["Int"]["input"];
};

export type MutationAdminUpdateOrganizationalFeatureFlagArgs = {
  enabled: Scalars["Boolean"]["input"];
  flag: FeatureFlag;
  organizationId: Scalars["String"]["input"];
};

export type MutationAdminUpsertDepartmentArgs = {
  input: DepartmentInput;
};

export type MutationAdminUpsertExpenseCategoryGlPairingArgs = {
  input: ExpenseCategoryGlPairingInput;
};

export type MutationAdminUpsertMileageArgs = {
  input: MileageInput;
};

export type MutationApproveOrRejectExpenseReportArgs = {
  approvedExpenseIds: Array<Scalars["Int"]["input"]>;
  employeeId: Scalars["String"]["input"];
  employerNotes?: InputMaybe<Scalars["String"]["input"]>;
  reportId: Scalars["Int"]["input"];
};

export type MutationApproveOrRejectStipendExpenseArgs = {
  employeeId: Scalars["String"]["input"];
  employerNotes?: InputMaybe<Scalars["String"]["input"]>;
  isApproved: Scalars["Boolean"]["input"];
  stipendExpenseId: Scalars["String"]["input"];
};

export type MutationAwxAuthorizeBeneficiaryAccountArgs = {
  codeChallenge: Scalars["String"]["input"];
};

export type MutationAwxConnectLinkedAccountArgs = {
  input: AwxLinkedAccountCreateInput;
};

export type MutationAwxCreateAndAuthorizeAccountArgs = {
  codeChallenge: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
};

export type MutationCompletePersonalEmailUpdateArgs = {
  code: Scalars["String"]["input"];
  newPersonalEmail: Scalars["String"]["input"];
  source: AuthSourceContext;
};

export type MutationCreateAchPaymentMethodArgs = {
  paymentMethodInput: CreateAchPaymentMethodInput;
};

export type MutationCreateDisputeArgs = {
  input: CreateDisputeInput;
};

export type MutationCreateGiftCardOrderArgs = {
  input: GiftCardCreateOrderInput;
};

export type MutationCreateHypercardGiftCardOrderArgs = {
  externalRefIDs: Array<Scalars["String"]["input"]>;
};

export type MutationCreateInstantPaymentArgs = {
  input: CreateInstantPaymentInput;
};

export type MutationCreateStipendRuleArgs = {
  input: CreateStipendRuleInput;
};

export type MutationDeleteDraftExpenseReportArgs = {
  id: Scalars["Int"]["input"];
};

export type MutationDeletePaymentMethodArgs = {
  methodId: Scalars["String"]["input"];
};

export type MutationHideGiftCardFromWalletArgs = {
  externalRefID: Scalars["String"]["input"];
};

export type MutationInitiateAuthenticationArgs = {
  email: Scalars["String"]["input"];
  redirectUri: Scalars["String"]["input"];
  shouldUserExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  shouldWaitlistUserExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationInviteEmployeeArgs = {
  input: AdminOrManagerUserEmployeeCreateInput;
};

export type MutationParseReceiptWithOcrArgs = {
  receiptFileData: Scalars["String"]["input"];
};

export type MutationProcessExpenseReportDownloadAndGetUrlArgs = {
  filters?: InputMaybe<AdminExpenseReportFilterInput>;
};

export type MutationProvisionAppleWalletArgs = {
  certificates: Array<Scalars["String"]["input"]>;
  nonce: Scalars["String"]["input"];
  nonceSignature: Scalars["String"]["input"];
};

export type MutationProvisionGoogleWalletArgs = {
  deviceId: Scalars["String"]["input"];
  walletId: Scalars["String"]["input"];
};

export type MutationRedeemPointsForCashbackArgs = {
  amount: Scalars["Int"]["input"];
};

export type MutationReferColleaguesArgs = {
  inviteeEmails: Array<Scalars["String"]["input"]>;
};

export type MutationRegisterNotifyMeForFeatureArgs = {
  feature: UserFeatureNotification;
  rewardRuleId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationRegisterOfferAnalyticArgs = {
  rewardRuleId: Scalars["Int"]["input"];
};

export type MutationRemoveExpenseFromReportArgs = {
  expenseId: Scalars["Int"]["input"];
  reportId: Scalars["Int"]["input"];
};

export type MutationReplaceCardArgs = {
  cardDesignId?: InputMaybe<Scalars["Int"]["input"]>;
  newShippingAddress?: InputMaybe<UpdateCardholderAddressInput>;
  reason: CardReplacementReason;
};

export type MutationSendEmailOtpArgs = {
  email: Scalars["String"]["input"];
  shouldUserExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  shouldWaitlistUserExist?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationSimulateTransactionArgs = {
  amount?: InputMaybe<Scalars["Float"]["input"]>;
  merchantId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationStartEmployeeApplicationArgs = {
  workEmailToken: Scalars["String"]["input"];
};

export type MutationStartPersonalEmailUpdateArgs = {
  newPersonalEmail: Scalars["String"]["input"];
};

export type MutationSubmitDraftExpenseReportArgs = {
  id: Scalars["Int"]["input"];
  skipPolicyCheck?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationSubmitEmployeeApplicationArgs = {
  applicationId: Scalars["String"]["input"];
  cardDesignId: Scalars["Int"]["input"];
  demographic: ApplicationDemographicInput;
  financialInfo: ApplicationFinancialInfoInput;
};

export type MutationSubmitFeedbackArgs = {
  feedback: Scalars["String"]["input"];
};

export type MutationSubmitStipendExpenseArgs = {
  input: StipendExpenseCreateInput;
  receiptFileData?: InputMaybe<Scalars["String"]["input"]>;
  stipendWalletId: Scalars["Int"]["input"];
};

export type MutationSubmitStipendExpenseV2Args = {
  input: StipendExpenseCreateInput;
  receiptFileData?: InputMaybe<Scalars["String"]["input"]>;
  skipPolicyCheck?: InputMaybe<Scalars["Boolean"]["input"]>;
  stipendWalletId: Scalars["Int"]["input"];
};

export type MutationSubmitWaitlistUserApplicationArgs = {
  applicationId: Scalars["String"]["input"];
  demographic: ApplicationDemographicInput;
  financialInfo: ApplicationFinancialInfoInput;
};

export type MutationTerminateEmployeeProfileArgs = {
  userId: Scalars["String"]["input"];
};

export type MutationTestExpensePolicyArgs = {
  input: TestExpensePolicyInput;
};

export type MutationUpdateCardPinArgs = {
  pin: Scalars["String"]["input"];
};

export type MutationUpdateCurrentUserEmployeeDelegatesArgs = {
  delegateEmployeeProfileIds: Array<Scalars["String"]["input"]>;
};

export type MutationUpdateDelegateTransactionAccessArgs = {
  toggleDelegateTransactionAccess: Scalars["Boolean"]["input"];
};

export type MutationUpdateEmployeeArgs = {
  input: AdminOrManagerUserEmployeeUpdateInput;
  userId: Scalars["String"]["input"];
};

export type MutationUpdateEmployeesToDepartmentArgs = {
  departmentId: Scalars["Int"]["input"];
  userIds: Array<Scalars["String"]["input"]>;
};

export type MutationUpdateExpenseArgs = {
  expenseId: Scalars["Int"]["input"];
  input: ExpenseUpdateInput;
  receiptFileData?: InputMaybe<Scalars["String"]["input"]>;
  reportId: Scalars["Int"]["input"];
};

export type MutationUpdateFreezeStatusArgs = {
  shouldFreeze: Scalars["Boolean"]["input"];
};

export type MutationUpdateNotificationSettingsArgs = {
  settings: NotificationSettingsInput;
};

export type MutationUpdateProductAcceptanceArgs = {
  isProductAccepted: Scalars["Boolean"]["input"];
  referralCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateSapConnectionArgs = {
  geolocation: Scalars["String"]["input"];
  refreshToken: Scalars["String"]["input"];
  sapCompanyUuid: Scalars["String"]["input"];
};

export type MutationUpdateStipendRuleArgs = {
  input: UpdateStipendRuleInput;
  stipendRuleId: Scalars["Int"]["input"];
};

export type MutationUpdateUserAddressArgs = {
  address: UpdateCardholderAddressInput;
};

export type MutationUpdateUserPreferencesArgs = {
  paperlessStatement: Scalars["Boolean"]["input"];
};

export type MutationUpsertAndRemoveReportExpensesArgs = {
  reportId: Scalars["Int"]["input"];
  selected: Array<ExpenseUpsertInput>;
};

export type MutationUpsertAutoPaymentScheduleArgs = {
  input: UpsertAutoPaymentScheduleInput;
};

export type MutationUpsertAwxBeneficiaryAccountArgs = {
  input: UpsertBeneficiaryInput;
};

export type MutationUpsertCustomFieldArgs = {
  input: CustomFieldEntityInput;
};

export type MutationUpsertCustomFieldListOptionArgs = {
  input: CustomFieldListOptionInput;
};

export type MutationUpsertExpenseReportArgs = {
  expense?: InputMaybe<ExpenseUpsertInput>;
  input: ExpenseReportCreateInput;
  reportId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationUpsertPolicyArgs = {
  input: ExpensePolicyCreateInput;
};

export type MutationValidateSapConnectionAndStoreTokenArgs = {
  accessToken: Scalars["String"]["input"];
  connectionId: Scalars["String"]["input"];
  requestToken: Scalars["String"]["input"];
};

export type MutationValidateStipendRuleArgs = {
  input: CreateStipendRuleInput;
};

export type MutationVerifyAuthCodeArgs = {
  code: Scalars["String"]["input"];
  shouldUserExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  source: AuthSourceContext;
};

export type MutationVerifyOtpCodeArgs = {
  code: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  shouldUserExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  source: AuthSourceContext;
};

export type MutationWithdrawDisputeArgs = {
  disputeId: Scalars["String"]["input"];
};

export type MutationActivateCardResult =
  | BaseError
  | MutationActivateCardSuccess
  | ValidationError;

export type MutationActivateCardSuccess = {
  __typename?: "MutationActivateCardSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationAddExpenseToReportResult =
  | BaseError
  | MutationAddExpenseToReportSuccess
  | ValidationError;

export type MutationAddExpenseToReportSuccess = {
  __typename?: "MutationAddExpenseToReportSuccess";
  data: Expense;
};

export type MutationAdminUpdateOrganizationalFeatureFlagResult =
  | BaseError
  | MutationAdminUpdateOrganizationalFeatureFlagSuccess
  | ValidationError;

export type MutationAdminUpdateOrganizationalFeatureFlagSuccess = {
  __typename?: "MutationAdminUpdateOrganizationalFeatureFlagSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationAdminUpsertDepartmentResult =
  | BaseError
  | MutationAdminUpsertDepartmentSuccess
  | ValidationError;

export type MutationAdminUpsertDepartmentSuccess = {
  __typename?: "MutationAdminUpsertDepartmentSuccess";
  data: Department;
};

export type MutationAdminUpsertExpenseCategoryGlPairingResult =
  | BaseError
  | MutationAdminUpsertExpenseCategoryGlPairingSuccess
  | ValidationError;

export type MutationAdminUpsertExpenseCategoryGlPairingSuccess = {
  __typename?: "MutationAdminUpsertExpenseCategoryGLPairingSuccess";
  data: ExpenseCategoryGlPairing;
};

export type MutationAdminUpsertMileageResult =
  | BaseError
  | MutationAdminUpsertMileageSuccess
  | ValidationError;

export type MutationAdminUpsertMileageSuccess = {
  __typename?: "MutationAdminUpsertMileageSuccess";
  data: Mileage;
};

export type MutationApproveOrRejectExpenseReportResult =
  | BaseError
  | MutationApproveOrRejectExpenseReportSuccess
  | ValidationError;

export type MutationApproveOrRejectExpenseReportSuccess = {
  __typename?: "MutationApproveOrRejectExpenseReportSuccess";
  data: ExpenseReport;
};

export type MutationApproveOrRejectStipendExpenseResult =
  | BaseError
  | MutationApproveOrRejectStipendExpenseSuccess
  | ValidationError;

export type MutationApproveOrRejectStipendExpenseSuccess = {
  __typename?: "MutationApproveOrRejectStipendExpenseSuccess";
  data: StipendExpense;
};

export type MutationAwxAuthorizeBeneficiaryAccountResult =
  | BaseError
  | MutationAwxAuthorizeBeneficiaryAccountSuccess
  | ValidationError;

export type MutationAwxAuthorizeBeneficiaryAccountSuccess = {
  __typename?: "MutationAwxAuthorizeBeneficiaryAccountSuccess";
  data: AwxAuthorizeBeneficiaryAccount;
};

export type MutationAwxConnectLinkedAccountResult =
  | BaseError
  | MutationAwxConnectLinkedAccountSuccess
  | ValidationError;

export type MutationAwxConnectLinkedAccountSuccess = {
  __typename?: "MutationAwxConnectLinkedAccountSuccess";
  data: LinkedAccount;
};

export type MutationAwxCreateAndAuthorizeAccountResult =
  | BaseError
  | MutationAwxCreateAndAuthorizeAccountSuccess
  | ValidationError;

export type MutationAwxCreateAndAuthorizeAccountSuccess = {
  __typename?: "MutationAwxCreateAndAuthorizeAccountSuccess";
  data: AwxAuthorizeConnectedAccount;
};

export type MutationCompletePersonalEmailUpdateResult =
  | BaseError
  | MutationCompletePersonalEmailUpdateSuccess
  | ValidationError;

export type MutationCompletePersonalEmailUpdateSuccess = {
  __typename?: "MutationCompletePersonalEmailUpdateSuccess";
  data: AuthTokenResponse;
};

export type MutationCreateAchPaymentMethodResult =
  | BaseError
  | MutationCreateAchPaymentMethodSuccess
  | ValidationError;

export type MutationCreateAchPaymentMethodSuccess = {
  __typename?: "MutationCreateACHPaymentMethodSuccess";
  data: PaymentMethod;
};

export type MutationCreateDisputeResult =
  | BaseError
  | MutationCreateDisputeSuccess
  | ValidationError;

export type MutationCreateDisputeSuccess = {
  __typename?: "MutationCreateDisputeSuccess";
  data: Dispute;
};

export type MutationCreateGiftCardOrderResult =
  | BaseError
  | MutationCreateGiftCardOrderSuccess
  | ValidationError;

export type MutationCreateGiftCardOrderSuccess = {
  __typename?: "MutationCreateGiftCardOrderSuccess";
  data: GiftCardOrder;
};

export type MutationCreateHypercardGiftCardOrderResult =
  | BaseError
  | MutationCreateHypercardGiftCardOrderSuccess
  | ValidationError;

export type MutationCreateHypercardGiftCardOrderSuccess = {
  __typename?: "MutationCreateHypercardGiftCardOrderSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationCreateInstantPaymentResult =
  | BaseError
  | MutationCreateInstantPaymentSuccess
  | ValidationError;

export type MutationCreateInstantPaymentSuccess = {
  __typename?: "MutationCreateInstantPaymentSuccess";
  data: PaymentSchedule;
};

export type MutationCreateStipendRuleResult =
  | BaseError
  | MutationCreateStipendRuleSuccess
  | ValidationError;

export type MutationCreateStipendRuleSuccess = {
  __typename?: "MutationCreateStipendRuleSuccess";
  data: StipendDetail;
};

export type MutationDeleteAwxBeneficiaryAccountResult =
  | BaseError
  | MutationDeleteAwxBeneficiaryAccountSuccess
  | ValidationError;

export type MutationDeleteAwxBeneficiaryAccountSuccess = {
  __typename?: "MutationDeleteAwxBeneficiaryAccountSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationDeleteDraftExpenseReportResult =
  | BaseError
  | MutationDeleteDraftExpenseReportSuccess
  | ValidationError;

export type MutationDeleteDraftExpenseReportSuccess = {
  __typename?: "MutationDeleteDraftExpenseReportSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationDeletePaymentMethodResult =
  | BaseError
  | MutationDeletePaymentMethodSuccess
  | ValidationError;

export type MutationDeletePaymentMethodSuccess = {
  __typename?: "MutationDeletePaymentMethodSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationHideGiftCardFromWalletResult =
  | BaseError
  | MutationHideGiftCardFromWalletSuccess
  | ValidationError;

export type MutationHideGiftCardFromWalletSuccess = {
  __typename?: "MutationHideGiftCardFromWalletSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationInitializeCardSwitchResult =
  | BaseError
  | MutationInitializeCardSwitchSuccess
  | ValidationError;

export type MutationInitializeCardSwitchSuccess = {
  __typename?: "MutationInitializeCardSwitchSuccess";
  data: Scalars["String"]["output"];
};

export type MutationInitiateAuthenticationResult =
  | BaseError
  | MutationInitiateAuthenticationSuccess
  | ValidationError;

export type MutationInitiateAuthenticationSuccess = {
  __typename?: "MutationInitiateAuthenticationSuccess";
  data: AuthenticationInitationResponse;
};

export type MutationInvalidateRefreshTokenResult =
  | BaseError
  | MutationInvalidateRefreshTokenSuccess
  | ValidationError;

export type MutationInvalidateRefreshTokenSuccess = {
  __typename?: "MutationInvalidateRefreshTokenSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationInviteEmployeeResult =
  | BaseError
  | MutationInviteEmployeeSuccess
  | ValidationError;

export type MutationInviteEmployeeSuccess = {
  __typename?: "MutationInviteEmployeeSuccess";
  data: User;
};

export type MutationParseReceiptWithOcrResult =
  | BaseError
  | MutationParseReceiptWithOcrSuccess
  | ValidationError;

export type MutationParseReceiptWithOcrSuccess = {
  __typename?: "MutationParseReceiptWithOCRSuccess";
  data: ExpenseAutofillInfo;
};

export type MutationProcessExpenseReportDownloadAndGetUrlResult =
  | BaseError
  | MutationProcessExpenseReportDownloadAndGetUrlSuccess
  | ValidationError;

export type MutationProcessExpenseReportDownloadAndGetUrlSuccess = {
  __typename?: "MutationProcessExpenseReportDownloadAndGetUrlSuccess";
  data: Scalars["String"]["output"];
};

export type MutationProvisionAppleWalletResult =
  | BaseError
  | MutationProvisionAppleWalletSuccess
  | ValidationError;

export type MutationProvisionAppleWalletSuccess = {
  __typename?: "MutationProvisionAppleWalletSuccess";
  data: ProvisionAppleWallet;
};

export type MutationProvisionGoogleWalletResult =
  | BaseError
  | MutationProvisionGoogleWalletSuccess
  | ValidationError;

export type MutationProvisionGoogleWalletSuccess = {
  __typename?: "MutationProvisionGoogleWalletSuccess";
  data: ProvisionGoogleWallet;
};

export type MutationRedeemPointsForCashbackResult =
  | BaseError
  | MutationRedeemPointsForCashbackSuccess
  | ValidationError;

export type MutationRedeemPointsForCashbackSuccess = {
  __typename?: "MutationRedeemPointsForCashbackSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationReferColleaguesResult =
  | BaseError
  | MutationReferColleaguesSuccess
  | ValidationError;

export type MutationReferColleaguesSuccess = {
  __typename?: "MutationReferColleaguesSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationRefreshAccessTokenResult =
  | BaseError
  | MutationRefreshAccessTokenSuccess
  | ValidationError;

export type MutationRefreshAccessTokenSuccess = {
  __typename?: "MutationRefreshAccessTokenSuccess";
  data: AuthTokenResponse;
};

export type MutationRegisterNotifyMeForFeatureResult =
  | BaseError
  | MutationRegisterNotifyMeForFeatureSuccess
  | ValidationError;

export type MutationRegisterNotifyMeForFeatureSuccess = {
  __typename?: "MutationRegisterNotifyMeForFeatureSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationRegisterOfferAnalyticResult =
  | BaseError
  | MutationRegisterOfferAnalyticSuccess
  | ValidationError;

export type MutationRegisterOfferAnalyticSuccess = {
  __typename?: "MutationRegisterOfferAnalyticSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationRemoveAutoPaymentScheduleResult =
  | BaseError
  | MutationRemoveAutoPaymentScheduleSuccess
  | ValidationError;

export type MutationRemoveAutoPaymentScheduleSuccess = {
  __typename?: "MutationRemoveAutoPaymentScheduleSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationRemoveExpenseFromReportResult =
  | BaseError
  | MutationRemoveExpenseFromReportSuccess
  | ValidationError;

export type MutationRemoveExpenseFromReportSuccess = {
  __typename?: "MutationRemoveExpenseFromReportSuccess";
  data: Expense;
};

export type MutationReplaceCardResult =
  | BaseError
  | MutationReplaceCardSuccess
  | ValidationError;

export type MutationReplaceCardSuccess = {
  __typename?: "MutationReplaceCardSuccess";
  data: CardReplacement;
};

export type MutationSendEmailOtpResult =
  | BaseError
  | MutationSendEmailOtpSuccess
  | ValidationError;

export type MutationSendEmailOtpSuccess = {
  __typename?: "MutationSendEmailOTPSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationSimulateTransactionResult =
  | BaseError
  | MutationSimulateTransactionSuccess
  | ValidationError;

export type MutationSimulateTransactionSuccess = {
  __typename?: "MutationSimulateTransactionSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationStartEmployeeApplicationResult =
  | BaseError
  | MutationStartEmployeeApplicationSuccess
  | ValidationError;

export type MutationStartEmployeeApplicationSuccess = {
  __typename?: "MutationStartEmployeeApplicationSuccess";
  data: EmployeeApplicationStartedContext;
};

export type MutationStartPersonalEmailUpdateResult =
  | BaseError
  | MutationStartPersonalEmailUpdateSuccess
  | ValidationError;

export type MutationStartPersonalEmailUpdateSuccess = {
  __typename?: "MutationStartPersonalEmailUpdateSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationStartWaitlistUserApplicationResult =
  | BaseError
  | MutationStartWaitlistUserApplicationSuccess
  | ValidationError;

export type MutationStartWaitlistUserApplicationSuccess = {
  __typename?: "MutationStartWaitlistUserApplicationSuccess";
  data: WaitlistUserApplicationStartedContext;
};

export type MutationSubmitDraftExpenseReportResult =
  | BaseError
  | MutationSubmitDraftExpenseReportSuccess
  | ValidationError;

export type MutationSubmitDraftExpenseReportSuccess = {
  __typename?: "MutationSubmitDraftExpenseReportSuccess";
  data: SubmitDraftExpenseReportResult;
};

export type MutationSubmitEmployeeApplicationResult =
  | BaseError
  | MutationSubmitEmployeeApplicationSuccess
  | ValidationError;

export type MutationSubmitEmployeeApplicationSuccess = {
  __typename?: "MutationSubmitEmployeeApplicationSuccess";
  data: ApplicationContext;
};

export type MutationSubmitFeedbackResult =
  | BaseError
  | MutationSubmitFeedbackSuccess
  | ValidationError;

export type MutationSubmitFeedbackSuccess = {
  __typename?: "MutationSubmitFeedbackSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationSubmitStipendExpenseResult =
  | BaseError
  | MutationSubmitStipendExpenseSuccess
  | ValidationError;

export type MutationSubmitStipendExpenseSuccess = {
  __typename?: "MutationSubmitStipendExpenseSuccess";
  data: StipendExpense;
};

export type MutationSubmitStipendExpenseV2Result =
  | BaseError
  | MutationSubmitStipendExpenseV2Success
  | ValidationError;

export type MutationSubmitStipendExpenseV2Success = {
  __typename?: "MutationSubmitStipendExpenseV2Success";
  data: SubmitStipendExpenseV2Result;
};

export type MutationSubmitWaitlistUserApplicationResult =
  | BaseError
  | MutationSubmitWaitlistUserApplicationSuccess
  | ValidationError;

export type MutationSubmitWaitlistUserApplicationSuccess = {
  __typename?: "MutationSubmitWaitlistUserApplicationSuccess";
  data: ApplicationContext;
};

export type MutationSuspendLinkedAccountResult =
  | BaseError
  | MutationSuspendLinkedAccountSuccess
  | ValidationError;

export type MutationSuspendLinkedAccountSuccess = {
  __typename?: "MutationSuspendLinkedAccountSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationTerminateEmployeeProfileResult =
  | BaseError
  | MutationTerminateEmployeeProfileSuccess
  | ValidationError;

export type MutationTerminateEmployeeProfileSuccess = {
  __typename?: "MutationTerminateEmployeeProfileSuccess";
  data: User;
};

export type MutationTestExpensePolicyResult =
  | BaseError
  | MutationTestExpensePolicySuccess
  | ValidationError;

export type MutationTestExpensePolicySuccess = {
  __typename?: "MutationTestExpensePolicySuccess";
  data: TestExpensePolicyResult;
};

export type MutationUnfreezeCreditBureauResult =
  | BaseError
  | MutationUnfreezeCreditBureauSuccess
  | ValidationError;

export type MutationUnfreezeCreditBureauSuccess = {
  __typename?: "MutationUnfreezeCreditBureauSuccess";
  data: ApplicationContext;
};

export type MutationUpdateCardPinResult =
  | BaseError
  | MutationUpdateCardPinSuccess
  | ValidationError;

export type MutationUpdateCardPinSuccess = {
  __typename?: "MutationUpdateCardPinSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationUpdateCurrentUserEmployeeDelegatesResult =
  | BaseError
  | MutationUpdateCurrentUserEmployeeDelegatesSuccess
  | ValidationError;

export type MutationUpdateCurrentUserEmployeeDelegatesSuccess = {
  __typename?: "MutationUpdateCurrentUserEmployeeDelegatesSuccess";
  data: User;
};

export type MutationUpdateDelegateTransactionAccessResult =
  | BaseError
  | MutationUpdateDelegateTransactionAccessSuccess
  | ValidationError;

export type MutationUpdateDelegateTransactionAccessSuccess = {
  __typename?: "MutationUpdateDelegateTransactionAccessSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationUpdateEmployeeResult =
  | BaseError
  | MutationUpdateEmployeeSuccess
  | ValidationError;

export type MutationUpdateEmployeeSuccess = {
  __typename?: "MutationUpdateEmployeeSuccess";
  data: User;
};

export type MutationUpdateEmployeesToDepartmentResult =
  | BaseError
  | MutationUpdateEmployeesToDepartmentSuccess
  | ValidationError;

export type MutationUpdateEmployeesToDepartmentSuccess = {
  __typename?: "MutationUpdateEmployeesToDepartmentSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationUpdateExpenseResult =
  | BaseError
  | MutationUpdateExpenseSuccess
  | ValidationError;

export type MutationUpdateExpenseSuccess = {
  __typename?: "MutationUpdateExpenseSuccess";
  data: Expense;
};

export type MutationUpdateFreezeStatusResult =
  | BaseError
  | MutationUpdateFreezeStatusSuccess
  | ValidationError;

export type MutationUpdateFreezeStatusSuccess = {
  __typename?: "MutationUpdateFreezeStatusSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationUpdateNotificationSettingsResult =
  | BaseError
  | MutationUpdateNotificationSettingsSuccess
  | ValidationError;

export type MutationUpdateNotificationSettingsSuccess = {
  __typename?: "MutationUpdateNotificationSettingsSuccess";
  data: NotificationSettings;
};

export type MutationUpdateProductAcceptanceResult =
  | BaseError
  | MutationUpdateProductAcceptanceSuccess
  | ValidationError;

export type MutationUpdateProductAcceptanceSuccess = {
  __typename?: "MutationUpdateProductAcceptanceSuccess";
  data: ApplicationContext;
};

export type MutationUpdateSapConnectionResult =
  | BaseError
  | MutationUpdateSapConnectionSuccess
  | ValidationError;

export type MutationUpdateSapConnectionSuccess = {
  __typename?: "MutationUpdateSAPConnectionSuccess";
  data: SapConnectionDetail;
};

export type MutationUpdateStipendRuleResult =
  | BaseError
  | MutationUpdateStipendRuleSuccess
  | ValidationError;

export type MutationUpdateStipendRuleSuccess = {
  __typename?: "MutationUpdateStipendRuleSuccess";
  data: StipendDetail;
};

export type MutationUpdateUserAddressResult =
  | BaseError
  | MutationUpdateUserAddressSuccess
  | ValidationError;

export type MutationUpdateUserAddressSuccess = {
  __typename?: "MutationUpdateUserAddressSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationUpdateUserPreferencesResult =
  | BaseError
  | MutationUpdateUserPreferencesSuccess
  | ValidationError;

export type MutationUpdateUserPreferencesSuccess = {
  __typename?: "MutationUpdateUserPreferencesSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationUpsertAndRemoveReportExpensesResult =
  | BaseError
  | MutationUpsertAndRemoveReportExpensesSuccess
  | ValidationError;

export type MutationUpsertAndRemoveReportExpensesSuccess = {
  __typename?: "MutationUpsertAndRemoveReportExpensesSuccess";
  data: Array<Expense>;
};

export type MutationUpsertAutoPaymentScheduleResult =
  | BaseError
  | MutationUpsertAutoPaymentScheduleSuccess
  | ValidationError;

export type MutationUpsertAutoPaymentScheduleSuccess = {
  __typename?: "MutationUpsertAutoPaymentScheduleSuccess";
  data: PaymentSchedule;
};

export type MutationUpsertAwxBeneficiaryAccountResult =
  | BaseError
  | MutationUpsertAwxBeneficiaryAccountSuccess
  | ValidationError;

export type MutationUpsertAwxBeneficiaryAccountSuccess = {
  __typename?: "MutationUpsertAwxBeneficiaryAccountSuccess";
  data: Beneficiary;
};

export type MutationUpsertCustomFieldListOptionResult =
  | BaseError
  | MutationUpsertCustomFieldListOptionSuccess
  | ValidationError;

export type MutationUpsertCustomFieldListOptionSuccess = {
  __typename?: "MutationUpsertCustomFieldListOptionSuccess";
  data: CustomFieldListOption;
};

export type MutationUpsertCustomFieldResult =
  | BaseError
  | MutationUpsertCustomFieldSuccess
  | ValidationError;

export type MutationUpsertCustomFieldSuccess = {
  __typename?: "MutationUpsertCustomFieldSuccess";
  data: CustomFieldEntity;
};

export type MutationUpsertExpenseReportResult =
  | BaseError
  | MutationUpsertExpenseReportSuccess
  | ValidationError;

export type MutationUpsertExpenseReportSuccess = {
  __typename?: "MutationUpsertExpenseReportSuccess";
  data: ExpenseReport;
};

export type MutationUpsertPolicyResult =
  | BaseError
  | MutationUpsertPolicySuccess
  | ValidationError;

export type MutationUpsertPolicySuccess = {
  __typename?: "MutationUpsertPolicySuccess";
  data: ExpensePolicy;
};

export type MutationValidateSapConnectionAndStoreTokenResult =
  | BaseError
  | MutationValidateSapConnectionAndStoreTokenSuccess
  | ValidationError;

export type MutationValidateSapConnectionAndStoreTokenSuccess = {
  __typename?: "MutationValidateSAPConnectionAndStoreTokenSuccess";
  data: Scalars["Boolean"]["output"];
};

export type MutationValidateStipendRuleResult =
  | BaseError
  | MutationValidateStipendRuleSuccess
  | ValidationError;

export type MutationValidateStipendRuleSuccess = {
  __typename?: "MutationValidateStipendRuleSuccess";
  data: StipendRuleValidationResult;
};

export type MutationVerifyAuthCodeResult =
  | BaseError
  | MutationVerifyAuthCodeSuccess
  | ValidationError;

export type MutationVerifyAuthCodeSuccess = {
  __typename?: "MutationVerifyAuthCodeSuccess";
  data: AuthTokenResponse;
};

export type MutationVerifyOtpCodeResult =
  | BaseError
  | MutationVerifyOtpCodeSuccess
  | ValidationError;

export type MutationVerifyOtpCodeSuccess = {
  __typename?: "MutationVerifyOTPCodeSuccess";
  data: AuthTokenResponse;
};

export type MutationWithdrawDisputeResult =
  | BaseError
  | MutationWithdrawDisputeSuccess
  | ValidationError;

export type MutationWithdrawDisputeSuccess = {
  __typename?: "MutationWithdrawDisputeSuccess";
  data: Dispute;
};

export type NotificationSettings = {
  __typename?: "NotificationSettings";
  expenses: Scalars["Boolean"]["output"];
  payments: Scalars["Boolean"]["output"];
  promotions: Scalars["Boolean"]["output"];
  rewards: Scalars["Boolean"]["output"];
  transactions: Scalars["Boolean"]["output"];
};

export type NotificationSettingsInput = {
  expenses?: InputMaybe<Scalars["Boolean"]["input"]>;
  payments?: InputMaybe<Scalars["Boolean"]["input"]>;
  promotions?: InputMaybe<Scalars["Boolean"]["input"]>;
  rewards?: InputMaybe<Scalars["Boolean"]["input"]>;
  transactions?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type Offer = {
  __typename?: "Offer";
  caption?: Maybe<Scalars["String"]["output"]>;
  category?: Maybe<OfferCategory>;
  details: Scalars["String"]["output"];
  displayDetailsForLimitReached?: Maybe<Scalars["String"]["output"]>;
  displayTitleForLimitReached?: Maybe<Scalars["String"]["output"]>;
  flair?: Maybe<OfferFlair>;
  hypercardMerchant?: Maybe<HypercardMerchant>;
  iconImageUrl?: Maybe<Scalars["String"]["output"]>;
  isUsageLimitReached: Scalars["Boolean"]["output"];
  landingPageUrl?: Maybe<Scalars["String"]["output"]>;
  longDetails?: Maybe<Scalars["String"]["output"]>;
  maxUsageCount?: Maybe<Scalars["Int"]["output"]>;
  restaurantOffer?: Maybe<RestaurantOffer>;
  rewardRuleId: Scalars["Int"]["output"];
  shortRewardDescriptor: Scalars["String"]["output"];
  terms?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  trigger: OfferTrigger;
  usageCount: Scalars["Int"]["output"];
};

export enum OfferCategory {
  Dining = "dining",
  KFactor = "kFactor",
  Lifestyle = "lifestyle",
  Other = "other",
  Wellness = "wellness",
}

export enum OfferFlair {
  New = "new",
  Trending = "trending",
}

export enum OfferTrigger {
  AffiliateLink = "affiliateLink",
  AutoPay = "autoPay",
  GiftCard = "giftCard",
  Knot = "knot",
  Manual = "manual",
  Referral = "referral",
  Transaction = "transaction",
}

export type Offers = {
  __typename?: "Offers";
  offers: Array<Offer>;
};

export type OffsetPaginationInput = {
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OnboardingAutocompleteEmployee = {
  __typename?: "OnboardingAutocompleteEmployee";
  annualIncome?: Maybe<Scalars["Float"]["output"]>;
  dateOfBirth?: Maybe<Scalars["Date"]["output"]>;
  employmentStatus?: Maybe<EmploymentStatus>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  formattedDateOfBirth?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  organizationId: Scalars["String"]["output"];
  personalEmail?: Maybe<Scalars["String"]["output"]>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  residentialAddress?: Maybe<Address>;
  ssn?: Maybe<Scalars["String"]["output"]>;
  workEmail: Scalars["String"]["output"];
};

export type Organization = {
  __typename?: "Organization";
  cardApplicationPageUrl: Scalars["String"]["output"];
  domains: Array<Scalars["String"]["output"]>;
  homePageCardImageUrl: Scalars["String"]["output"];
  landingPageUrl: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  organizationId: Scalars["String"]["output"];
  primaryCardHexColor: Scalars["String"]["output"];
  workOSOrganizationId?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationalFeatureFlags = {
  __typename?: "OrganizationalFeatureFlags";
  hypercardDelegatesShown: Scalars["Boolean"]["output"];
  hypercardExpenseManagementShown: Scalars["Boolean"]["output"];
  hypercardMileageShown: Scalars["Boolean"]["output"];
  hypercardStipendShown: Scalars["Boolean"]["output"];
  proxyExpenseManagementShown: Scalars["Boolean"]["output"];
};

export type PaymentMethod = {
  __typename?: "PaymentMethod";
  accountLast4Digits: Scalars["String"]["output"];
  accountType: BankAccountType;
  bankLogoUrl: Scalars["String"]["output"];
  bankName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  routingNumber: Scalars["String"]["output"];
  status: PaymentMethodStatus;
};

export enum PaymentMethodStatus {
  Active = "active",
  Deleted = "deleted",
  Invalid = "invalid",
  PendingValidation = "pendingValidation",
  ValidationInProgress = "validationInProgress",
}

export type PaymentMethods = {
  __typename?: "PaymentMethods";
  paymentMethods: Array<PaymentMethod>;
};

export enum PaymentProcessType {
  Ach = "ach",
  Check = "check",
  Manual = "manual",
}

export type PaymentSchedule = {
  __typename?: "PaymentSchedule";
  amount?: Maybe<Scalars["String"]["output"]>;
  day?: Maybe<Scalars["Int"]["output"]>;
  dayOfMonth?: Maybe<Scalars["String"]["output"]>;
  frequency: PaymentScheduleFrequency;
  id: Scalars["String"]["output"];
  methodId: Scalars["String"]["output"];
  methodType: Scalars["String"]["output"];
  nextPaymentAmount?: Maybe<Scalars["Float"]["output"]>;
  paymentDate?: Maybe<Scalars["Date"]["output"]>;
  reason?: Maybe<Scalars["String"]["output"]>;
  status: PaymentScheduleStatus;
  type: PaymentType;
};

export enum PaymentScheduleFrequency {
  DueDate = "dueDate",
  Instant = "instant",
  Monthly = "monthly",
}

export enum PaymentScheduleStatus {
  Active = "active",
  Completed = "completed",
  Deleted = "deleted",
  Failed = "failed",
  Skipped = "skipped",
}

export type PaymentTransaction = {
  __typename?: "PaymentTransaction";
  amountInDollars: Scalars["Float"]["output"];
  cardholderId: Scalars["String"]["output"];
  completedAt?: Maybe<Scalars["DateTime"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  displayDollarAmount: Scalars["String"]["output"];
  displayFlair?: Maybe<Scalars["String"]["output"]>;
  displayTitle: Scalars["String"]["output"];
  frequency?: Maybe<Scalars["String"]["output"]>;
  hypercardCategoryIconUrl: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  initiatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  paymentProcessType: PaymentProcessType;
  reason?: Maybe<Scalars["String"]["output"]>;
  refundedAt?: Maybe<Scalars["DateTime"]["output"]>;
  returnedAt?: Maybe<Scalars["DateTime"]["output"]>;
  status: PaymentTransactionStatus;
  transactedAt: Scalars["DateTime"]["output"];
  type: PaymentTransactionType;
};

export enum PaymentTransactionStatus {
  Cancelled = "cancelled",
  Completed = "completed",
  Initiated = "initiated",
  Processing = "processing",
  Refunded = "refunded",
  Refunding = "refunding",
  Returned = "returned",
  Returning = "returning",
}

export enum PaymentTransactionType {
  Regular = "regular",
  Reversal = "reversal",
}

export enum PaymentType {
  CurrentBalance = "currentBalance",
  FixedAmount = "fixedAmount",
  MinimumPayment = "minimumPayment",
  StatementBalance = "statementBalance",
}

export type PointsMultiplier = {
  __typename?: "PointsMultiplier";
  multiplier: Scalars["Int"]["output"];
  offer: Offer;
};

export enum PosType {
  Online = "online",
  Physical = "physical",
  Recurring = "recurring",
  Unknown = "unknown",
}

export type ProvisionAppleWallet = {
  __typename?: "ProvisionAppleWallet";
  activationData: Scalars["String"]["output"];
  encryptedPayload: Scalars["String"]["output"];
  ephemeralPublicKey: Scalars["String"]["output"];
};

export type ProvisionGoogleWallet = {
  __typename?: "ProvisionGoogleWallet";
  opc: Scalars["String"]["output"];
};

export type PublicCardholderProfile = {
  __typename?: "PublicCardholderProfile";
  cardholderId: Scalars["String"]["output"];
  personalEmail: Scalars["String"]["output"];
};

export type PublicEmployee = {
  __typename?: "PublicEmployee";
  firstName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  workEmail: Scalars["String"]["output"];
};

/** Publicly accessible employee profile, excludes any sensitive information. This is used for returning display properties of other employees when an employee logs in. */
export type PublicEmployeeProfile = {
  __typename?: "PublicEmployeeProfile";
  displayStatus: Scalars["String"]["output"];
  employeeId: Scalars["String"]["output"];
  status: EmployeeProfileStatus;
  workEmail: Scalars["String"]["output"];
};

export type PublicEmployees = {
  __typename?: "PublicEmployees";
  employees: Array<PublicEmployee>;
};

/** Publicly accessible user, excludes any sensitive information. This is used for returning display properties of other employees when an employee logs in. */
export type PublicUser = {
  __typename?: "PublicUser";
  cardholder?: Maybe<PublicCardholderProfile>;
  displayName: Scalars["String"]["output"];
  employee?: Maybe<PublicEmployeeProfile>;
  /** The highest employee role. Throws errors if our friends and family cardholders try to get this value. */
  employeeDisplayRole: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  userId: Scalars["String"]["output"];
};

export type Query = {
  __typename?: "Query";
  account: QueryAccountResult;
  achAuthLinkToken: QueryAchAuthLinkTokenResult;
  activeAutoPayment?: Maybe<QueryActiveAutoPaymentResult>;
  /** By default returns a list of 5 recommended employees that are active on the dashboard */
  activeEmployeeProfileRecommendations: QueryActiveEmployeeProfileRecommendationsResult;
  activePointsMultiplier: QueryActivePointsMultiplierResult;
  adminCustomFieldListOptions: QueryAdminCustomFieldListOptionsResult;
  adminCustomFields: QueryAdminCustomFieldsResult;
  adminExpenseCategories?: Maybe<QueryAdminExpenseCategoriesResult>;
  adminExpenseSummaryByGroup?: Maybe<QueryAdminExpenseSummaryByGroupResult>;
  adminOrganizationExpenses: QueryAdminOrganizationExpensesResult;
  adminReimbursementsTimeSavedInSeconds?: Maybe<QueryAdminReimbursementsTimeSavedInSecondsResult>;
  adminReportCountsPerStatus?: Maybe<QueryAdminReportCountsPerStatusResult>;
  adminReportGraphMetrics: QueryAdminReportGraphMetricsResult;
  adminSpendAnalyticsPerStipend: QueryAdminSpendAnalyticsPerStipendResult;
  adminStipendGraphMetrics?: Maybe<QueryAdminStipendGraphMetricsResult>;
  adminStipendSummary?: Maybe<QueryAdminStipendSummaryResult>;
  adminTopReimbursersForExpenseReports: QueryAdminTopReimbursersForExpenseReportsResult;
  adminTopReimbursersForStipends: QueryAdminTopReimbursersForStipendsResult;
  /**
   * statusInfo populates the context once an application is in progress and the cardholder has submitted their data.
   *     It is used to display the application status in the onboarding flow.
   */
  applicationContext: QueryApplicationContextResult;
  authenticationUrl: QueryAuthenticationUrlResult;
  awxOrganizationState?: Maybe<QueryAwxOrganizationStateResult>;
  beneficiary?: Maybe<QueryBeneficiaryResult>;
  cardArt: QueryCardArtResult;
  cardholder?: Maybe<QueryCardholderResult>;
  currentUser?: Maybe<QueryCurrentUserResult>;
  customFieldVisibleListOptions: QueryCustomFieldVisibleListOptionsResult;
  department?: Maybe<QueryDepartmentResult>;
  departments?: Maybe<QueryDepartmentsResult>;
  /** By default returns a list of 5 recommended attendees */
  employeeAttendeeRecommendations: QueryEmployeeAttendeeRecommendationsResult;
  /** By default returns a list of 5 recommended referrals */
  employeeReferralRecommendations: QueryEmployeeReferralRecommendationsResult;
  expensePolicies?: Maybe<QueryExpensePoliciesResult>;
  expenseReport: QueryExpenseReportResult;
  /** Returns expense reports for the current user */
  expenseReports: QueryExpenseReportsResult;
  /** Uses viewing as role header to determine which expense reports to return */
  expenseReportsByView: QueryExpenseReportsByViewResult;
  /**
   *
   *        Client can request what categories of filters to return.
   *        To request custom field filters, provide the custom field entity ids.
   *
   */
  filterOptions: QueryFilterOptionsResult;
  giftCardCatalog: QueryGiftCardCatalogResult;
  giftCardWallet: QueryGiftCardWalletResult;
  healthCheck: Scalars["String"]["output"];
  hypercardGiftCardCatalog: QueryHypercardGiftCardCatalogResult;
  /** Check if the IDP integration code is valid and SSO integration is successful */
  idpStatusCheck: QueryIdpStatusCheckResult;
  insurances: QueryInsurancesResult;
  linkFeatureFlags?: Maybe<QueryLinkFeatureFlagsResult>;
  linkedAccount: QueryLinkedAccountResult;
  mileage: QueryMileageResult;
  minimumStableVersion: QueryMinimumStableVersionResult;
  netSavingsThisMonth: QueryNetSavingsThisMonthResult;
  notificationSettings: QueryNotificationSettingsResult;
  offers: QueryOffersResult;
  organization: QueryOrganizationResult;
  organizationCardDesigns: QueryOrganizationCardDesignsResult;
  organizationOnboardingContextByLandingPagePrefix?: Maybe<QueryOrganizationOnboardingContextByLandingPagePrefixResult>;
  organizationUser: QueryOrganizationUserResult;
  organizationUsers: QueryOrganizationUsersResult;
  organizationalFeatureFlags: QueryOrganizationalFeatureFlagsResult;
  paymentMethods: QueryPaymentMethodsResult;
  pointToDollarConversion: QueryPointToDollarConversionResult;
  primaryCard: QueryPrimaryCardResult;
  recentExpenseActivities: QueryRecentExpenseActivitiesResult;
  referralOffer?: Maybe<QueryReferralOfferResult>;
  reward: QueryRewardResult;
  rewards: QueryRewardsResult;
  statement: QueryStatementResult;
  statements: QueryStatementsResult;
  stipendExpense: QueryStipendExpenseResult;
  stipendExpensesByView: QueryStipendExpensesByViewResult;
  stipendRules: QueryStipendRulesResult;
  stipendWallet?: Maybe<QueryStipendWalletResult>;
  stipendWallets: QueryStipendWalletsResult;
  totalPendingReimbursementAmount?: Maybe<QueryTotalPendingReimbursementAmountResult>;
  totalPoints?: Maybe<QueryTotalPointsResult>;
  totalReimbursedAmount?: Maybe<QueryTotalReimbursedAmountResult>;
  transaction: QueryTransactionResult;
  transactionSum: QueryTransactionSumResult;
  transactions: QueryTransactionsResult;
  userFeatureFlags: QueryUserFeatureFlagsResult;
  visibleCustomFields: QueryVisibleCustomFieldsResult;
  visibleExpenseCategories?: Maybe<QueryVisibleExpenseCategoriesResult>;
};

export type QueryActiveEmployeeProfileRecommendationsArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAdminCustomFieldListOptionsArgs = {
  customFieldEntityId: Scalars["Int"]["input"];
  filters?: InputMaybe<CustomFieldListOptionFilterInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryAdminCustomFieldsArgs = {
  filters?: InputMaybe<CustomFieldEntityFilterInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryAdminExpenseSummaryByGroupArgs = {
  filters?: InputMaybe<AdminReportExpenseFilterInput>;
  group: ExpenseReportAnalyticGroup;
  groupByCustomFieldEntityId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryAdminOrganizationExpensesArgs = {
  filters?: InputMaybe<AdminReportExpenseFilterInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryAdminReimbursementsTimeSavedInSecondsArgs = {
  filters?: InputMaybe<AdminExpenseReportFilterInput>;
};

export type QueryAdminReportCountsPerStatusArgs = {
  filters: TimePeriodFilter;
};

export type QueryAdminReportGraphMetricsArgs = {
  computePrevious?: InputMaybe<Scalars["Boolean"]["input"]>;
  filters?: InputMaybe<AdminReportExpenseFilterInput>;
  groupByCustomFieldEntityId?: InputMaybe<Scalars["Int"]["input"]>;
  groupedBy: ExpenseReportAnalyticGroup;
  interval: GraphAnalyticInterval;
};

export type QueryAdminSpendAnalyticsPerStipendArgs = {
  filters?: InputMaybe<AdminStipendExpenseFilterInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryAdminStipendGraphMetricsArgs = {
  computePrevious?: InputMaybe<Scalars["Boolean"]["input"]>;
  filters?: InputMaybe<AdminStipendExpenseFilterInput>;
  groupedBy: StipendExpenseAnalyticGroup;
  interval: GraphAnalyticInterval;
};

export type QueryAdminStipendSummaryArgs = {
  filters: TimePeriodFilter;
};

export type QueryAdminTopReimbursersForExpenseReportsArgs = {
  filters?: InputMaybe<AdminReportExpenseFilterInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryAdminTopReimbursersForStipendsArgs = {
  filters?: InputMaybe<AdminStipendExpenseFilterInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryAuthenticationUrlArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  provider?: InputMaybe<AuthProvider>;
  redirectUri: Scalars["String"]["input"];
  state?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryCustomFieldVisibleListOptionsArgs = {
  customFieldEntityId: Scalars["Int"]["input"];
  filters?: InputMaybe<CustomFieldListOptionFilterInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryDepartmentArgs = {
  id: Scalars["Int"]["input"];
};

export type QueryDepartmentsArgs = {
  filters?: InputMaybe<AdminDepartmentFilterInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryEmployeeAttendeeRecommendationsArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryEmployeeReferralRecommendationsArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryExpenseReportArgs = {
  id: Scalars["Int"]["input"];
};

export type QueryExpenseReportsArgs = {
  filters?: InputMaybe<ExpenseReportsFilterInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryExpenseReportsByViewArgs = {
  filters?: InputMaybe<AdminExpenseReportFilterInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryFilterOptionsArgs = {
  categories: Array<FilterCategoryEnum>;
  customFieldEntityIds?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryHypercardGiftCardCatalogArgs = {
  brandName?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryIdpStatusCheckArgs = {
  code: Scalars["String"]["input"];
};

export type QueryOffersArgs = {
  categories?: InputMaybe<Array<OfferCategory>>;
  restaurantCity?: InputMaybe<RestaurantCity>;
};

export type QueryOrganizationCardDesignsArgs = {
  organizationId: Scalars["String"]["input"];
};

export type QueryOrganizationOnboardingContextByLandingPagePrefixArgs = {
  prefix: Scalars["String"]["input"];
};

export type QueryOrganizationUserArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryOrganizationUsersArgs = {
  filters?: InputMaybe<UserFilterInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryOrganizationalFeatureFlagsArgs = {
  organizationId: Scalars["String"]["input"];
};

export type QueryPrimaryCardArgs = {
  detokenized?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryRecentExpenseActivitiesArgs = {
  employeeId: Scalars["String"]["input"];
};

export type QueryRewardArgs = {
  id: Scalars["Int"]["input"];
};

export type QueryRewardsArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryStatementArgs = {
  statementId: Scalars["String"]["input"];
};

export type QueryStatementsArgs = {
  pagination?: InputMaybe<StringCursorPaginationInput>;
};

export type QueryStipendExpenseArgs = {
  stipendExpenseId: Scalars["String"]["input"];
};

export type QueryStipendExpensesByViewArgs = {
  filters?: InputMaybe<AdminStipendExpenseFilterInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  sort?: InputMaybe<StipendExpensesSortInput>;
};

export type QueryStipendRulesArgs = {
  filters?: InputMaybe<StipendRuleFilterInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryStipendWalletArgs = {
  id: Scalars["Int"]["input"];
};

export type QueryStipendWalletsArgs = {
  filters?: InputMaybe<StipendWalletsFilterInput>;
};

export type QueryTransactionArgs = {
  transactionId: Scalars["Int"]["input"];
};

export type QueryTransactionsArgs = {
  filters?: InputMaybe<TransactionsFilterInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  sort?: InputMaybe<TransactionsSortInput>;
};

export type QueryVisibleCustomFieldsArgs = {
  filters?: InputMaybe<CustomFieldEntityFilterInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryAccountResult =
  | BaseError
  | QueryAccountSuccess
  | ValidationError;

export type QueryAccountSuccess = {
  __typename?: "QueryAccountSuccess";
  data: Account;
};

export type QueryAchAuthLinkTokenResult =
  | BaseError
  | QueryAchAuthLinkTokenSuccess
  | ValidationError;

export type QueryAchAuthLinkTokenSuccess = {
  __typename?: "QueryAchAuthLinkTokenSuccess";
  data: Scalars["String"]["output"];
};

export type QueryActiveAutoPaymentResult =
  | BaseError
  | QueryActiveAutoPaymentSuccess
  | ValidationError;

export type QueryActiveAutoPaymentSuccess = {
  __typename?: "QueryActiveAutoPaymentSuccess";
  data: PaymentSchedule;
};

export type QueryActiveEmployeeProfileRecommendationsResult =
  | BaseError
  | QueryActiveEmployeeProfileRecommendationsSuccess
  | ValidationError;

export type QueryActiveEmployeeProfileRecommendationsSuccess = {
  __typename?: "QueryActiveEmployeeProfileRecommendationsSuccess";
  data: PublicEmployees;
};

export type QueryActivePointsMultiplierResult =
  | BaseError
  | QueryActivePointsMultiplierSuccess
  | ValidationError;

export type QueryActivePointsMultiplierSuccess = {
  __typename?: "QueryActivePointsMultiplierSuccess";
  data: PointsMultiplier;
};

export type QueryAdminCustomFieldListOptionsResult =
  | BaseError
  | QueryAdminCustomFieldListOptionsSuccess
  | ValidationError;

export type QueryAdminCustomFieldListOptionsSuccess = {
  __typename?: "QueryAdminCustomFieldListOptionsSuccess";
  data: CustomFieldListOptions;
};

export type QueryAdminCustomFieldsResult =
  | BaseError
  | QueryAdminCustomFieldsSuccess
  | ValidationError;

export type QueryAdminCustomFieldsSuccess = {
  __typename?: "QueryAdminCustomFieldsSuccess";
  data: CustomFieldEntities;
};

export type QueryAdminExpenseCategoriesResult =
  | BaseError
  | QueryAdminExpenseCategoriesSuccess
  | ValidationError;

export type QueryAdminExpenseCategoriesSuccess = {
  __typename?: "QueryAdminExpenseCategoriesSuccess";
  data: ExpenseCategoryGlPairings;
};

export type QueryAdminExpenseSummaryByGroupResult =
  | BaseError
  | QueryAdminExpenseSummaryByGroupSuccess
  | ValidationError;

export type QueryAdminExpenseSummaryByGroupSuccess = {
  __typename?: "QueryAdminExpenseSummaryByGroupSuccess";
  data: GroupedExpenseSummary;
};

export type QueryAdminOrganizationExpensesResult =
  | BaseError
  | QueryAdminOrganizationExpensesSuccess
  | ValidationError;

export type QueryAdminOrganizationExpensesSuccess = {
  __typename?: "QueryAdminOrganizationExpensesSuccess";
  data: Expenses;
};

export type QueryAdminReimbursementsTimeSavedInSecondsResult =
  | BaseError
  | QueryAdminReimbursementsTimeSavedInSecondsSuccess
  | ValidationError;

export type QueryAdminReimbursementsTimeSavedInSecondsSuccess = {
  __typename?: "QueryAdminReimbursementsTimeSavedInSecondsSuccess";
  data: Scalars["Float"]["output"];
};

export type QueryAdminReportCountsPerStatusResult =
  | BaseError
  | QueryAdminReportCountsPerStatusSuccess
  | ValidationError;

export type QueryAdminReportCountsPerStatusSuccess = {
  __typename?: "QueryAdminReportCountsPerStatusSuccess";
  data: ReportCountsPerStatusWithPercentageChange;
};

export type QueryAdminReportGraphMetricsResult =
  | BaseError
  | QueryAdminReportGraphMetricsSuccess
  | ValidationError;

export type QueryAdminReportGraphMetricsSuccess = {
  __typename?: "QueryAdminReportGraphMetricsSuccess";
  data: GraphAnalyticResponse;
};

export type QueryAdminSpendAnalyticsPerStipendResult =
  | BaseError
  | QueryAdminSpendAnalyticsPerStipendSuccess
  | ValidationError;

export type QueryAdminSpendAnalyticsPerStipendSuccess = {
  __typename?: "QueryAdminSpendAnalyticsPerStipendSuccess";
  data: Array<StipendRuleSpendAnalytic>;
};

export type QueryAdminStipendGraphMetricsResult =
  | BaseError
  | QueryAdminStipendGraphMetricsSuccess
  | ValidationError;

export type QueryAdminStipendGraphMetricsSuccess = {
  __typename?: "QueryAdminStipendGraphMetricsSuccess";
  data: GraphAnalyticResponse;
};

export type QueryAdminStipendSummaryResult =
  | BaseError
  | QueryAdminStipendSummarySuccess
  | ValidationError;

export type QueryAdminStipendSummarySuccess = {
  __typename?: "QueryAdminStipendSummarySuccess";
  data: StipendSummaryWithPercentageChange;
};

export type QueryAdminTopReimbursersForExpenseReportsResult =
  | BaseError
  | QueryAdminTopReimbursersForExpenseReportsSuccess
  | ValidationError;

export type QueryAdminTopReimbursersForExpenseReportsSuccess = {
  __typename?: "QueryAdminTopReimbursersForExpenseReportsSuccess";
  data: Array<ExpenseReportEmployeeSpendAnalytic>;
};

export type QueryAdminTopReimbursersForStipendsResult =
  | BaseError
  | QueryAdminTopReimbursersForStipendsSuccess
  | ValidationError;

export type QueryAdminTopReimbursersForStipendsSuccess = {
  __typename?: "QueryAdminTopReimbursersForStipendsSuccess";
  data: Array<StipendEmployeeSpendAnalytic>;
};

export type QueryApplicationContextResult =
  | BaseError
  | QueryApplicationContextSuccess
  | ValidationError;

export type QueryApplicationContextSuccess = {
  __typename?: "QueryApplicationContextSuccess";
  data: ApplicationContext;
};

export type QueryAuthenticationUrlResult =
  | BaseError
  | QueryAuthenticationUrlSuccess
  | ValidationError;

export type QueryAuthenticationUrlSuccess = {
  __typename?: "QueryAuthenticationUrlSuccess";
  data: Scalars["String"]["output"];
};

export type QueryAwxOrganizationStateResult =
  | BaseError
  | QueryAwxOrganizationStateSuccess
  | ValidationError;

export type QueryAwxOrganizationStateSuccess = {
  __typename?: "QueryAwxOrganizationStateSuccess";
  data: AwxOrganizationState;
};

export type QueryBeneficiaryResult =
  | BaseError
  | QueryBeneficiarySuccess
  | ValidationError;

export type QueryBeneficiarySuccess = {
  __typename?: "QueryBeneficiarySuccess";
  data: Beneficiary;
};

export type QueryCardArtResult =
  | BaseError
  | QueryCardArtSuccess
  | ValidationError;

export type QueryCardArtSuccess = {
  __typename?: "QueryCardArtSuccess";
  data: CardArt;
};

export type QueryCardholderResult =
  | BaseError
  | QueryCardholderSuccess
  | ValidationError;

export type QueryCardholderSuccess = {
  __typename?: "QueryCardholderSuccess";
  data: CardholderProfile;
};

export type QueryCurrentUserResult =
  | BaseError
  | QueryCurrentUserSuccess
  | ValidationError;

export type QueryCurrentUserSuccess = {
  __typename?: "QueryCurrentUserSuccess";
  data: User;
};

export type QueryCustomFieldVisibleListOptionsResult =
  | BaseError
  | QueryCustomFieldVisibleListOptionsSuccess
  | ValidationError;

export type QueryCustomFieldVisibleListOptionsSuccess = {
  __typename?: "QueryCustomFieldVisibleListOptionsSuccess";
  data: CustomFieldListOptions;
};

export type QueryDepartmentResult =
  | BaseError
  | QueryDepartmentSuccess
  | ValidationError;

export type QueryDepartmentSuccess = {
  __typename?: "QueryDepartmentSuccess";
  data: Department;
};

export type QueryDepartmentsResult =
  | BaseError
  | QueryDepartmentsSuccess
  | ValidationError;

export type QueryDepartmentsSuccess = {
  __typename?: "QueryDepartmentsSuccess";
  data: Departments;
};

export type QueryEmployeeAttendeeRecommendationsResult =
  | BaseError
  | QueryEmployeeAttendeeRecommendationsSuccess
  | ValidationError;

export type QueryEmployeeAttendeeRecommendationsSuccess = {
  __typename?: "QueryEmployeeAttendeeRecommendationsSuccess";
  data: PublicEmployees;
};

export type QueryEmployeeReferralRecommendationsResult =
  | BaseError
  | QueryEmployeeReferralRecommendationsSuccess
  | ValidationError;

export type QueryEmployeeReferralRecommendationsSuccess = {
  __typename?: "QueryEmployeeReferralRecommendationsSuccess";
  data: PublicEmployees;
};

export type QueryExpensePoliciesResult =
  | BaseError
  | QueryExpensePoliciesSuccess
  | ValidationError;

export type QueryExpensePoliciesSuccess = {
  __typename?: "QueryExpensePoliciesSuccess";
  data: ExpensePolicies;
};

export type QueryExpenseReportResult =
  | BaseError
  | QueryExpenseReportSuccess
  | ValidationError;

export type QueryExpenseReportSuccess = {
  __typename?: "QueryExpenseReportSuccess";
  data: ExpenseReport;
};

export type QueryExpenseReportsByViewResult =
  | BaseError
  | QueryExpenseReportsByViewSuccess
  | ValidationError;

export type QueryExpenseReportsByViewSuccess = {
  __typename?: "QueryExpenseReportsByViewSuccess";
  data: ExpenseReports;
};

export type QueryExpenseReportsResult =
  | BaseError
  | QueryExpenseReportsSuccess
  | ValidationError;

export type QueryExpenseReportsSuccess = {
  __typename?: "QueryExpenseReportsSuccess";
  data: ExpenseReports;
};

export type QueryFilterOptionsResult =
  | BaseError
  | QueryFilterOptionsSuccess
  | ValidationError;

export type QueryFilterOptionsSuccess = {
  __typename?: "QueryFilterOptionsSuccess";
  data: FilterOptions;
};

export type QueryGiftCardCatalogResult =
  | BaseError
  | QueryGiftCardCatalogSuccess
  | ValidationError;

export type QueryGiftCardCatalogSuccess = {
  __typename?: "QueryGiftCardCatalogSuccess";
  data: Array<GiftCardCatalog>;
};

export type QueryGiftCardWalletResult =
  | BaseError
  | QueryGiftCardWalletSuccess
  | ValidationError;

export type QueryGiftCardWalletSuccess = {
  __typename?: "QueryGiftCardWalletSuccess";
  data: GiftCardWallets;
};

export type QueryHypercardGiftCardCatalogResult =
  | BaseError
  | QueryHypercardGiftCardCatalogSuccess
  | ValidationError;

export type QueryHypercardGiftCardCatalogSuccess = {
  __typename?: "QueryHypercardGiftCardCatalogSuccess";
  data: HypercardOwnedGiftCards;
};

export type QueryIdpStatusCheckResult =
  | BaseError
  | QueryIdpStatusCheckSuccess
  | ValidationError;

export type QueryIdpStatusCheckSuccess = {
  __typename?: "QueryIdpStatusCheckSuccess";
  data: Scalars["Boolean"]["output"];
};

export type QueryInsurancesResult =
  | BaseError
  | QueryInsurancesSuccess
  | ValidationError;

export type QueryInsurancesSuccess = {
  __typename?: "QueryInsurancesSuccess";
  data: Insurances;
};

export type QueryLinkFeatureFlagsResult =
  | BaseError
  | QueryLinkFeatureFlagsSuccess
  | ValidationError;

export type QueryLinkFeatureFlagsSuccess = {
  __typename?: "QueryLinkFeatureFlagsSuccess";
  data: LinkFeatureFlags;
};

export type QueryLinkedAccountResult =
  | BaseError
  | QueryLinkedAccountSuccess
  | ValidationError;

export type QueryLinkedAccountSuccess = {
  __typename?: "QueryLinkedAccountSuccess";
  data: LinkedAccount;
};

export type QueryMileageResult =
  | BaseError
  | QueryMileageSuccess
  | ValidationError;

export type QueryMileageSuccess = {
  __typename?: "QueryMileageSuccess";
  data: Mileage;
};

export type QueryMinimumStableVersionResult =
  | BaseError
  | QueryMinimumStableVersionSuccess
  | ValidationError;

export type QueryMinimumStableVersionSuccess = {
  __typename?: "QueryMinimumStableVersionSuccess";
  data: MinimumStableVersion;
};

export type QueryNetSavingsThisMonthResult =
  | BaseError
  | QueryNetSavingsThisMonthSuccess
  | ValidationError;

export type QueryNetSavingsThisMonthSuccess = {
  __typename?: "QueryNetSavingsThisMonthSuccess";
  data: Scalars["Float"]["output"];
};

export type QueryNotificationSettingsResult =
  | BaseError
  | QueryNotificationSettingsSuccess
  | ValidationError;

export type QueryNotificationSettingsSuccess = {
  __typename?: "QueryNotificationSettingsSuccess";
  data: NotificationSettings;
};

export type QueryOffersResult =
  | BaseError
  | QueryOffersSuccess
  | ValidationError;

export type QueryOffersSuccess = {
  __typename?: "QueryOffersSuccess";
  data: Offers;
};

export type QueryOrganizationCardDesignsResult =
  | BaseError
  | QueryOrganizationCardDesignsSuccess
  | ValidationError;

export type QueryOrganizationCardDesignsSuccess = {
  __typename?: "QueryOrganizationCardDesignsSuccess";
  data: Array<CardDesign>;
};

export type QueryOrganizationOnboardingContextByLandingPagePrefixResult =
  | BaseError
  | QueryOrganizationOnboardingContextByLandingPagePrefixSuccess
  | ValidationError;

export type QueryOrganizationOnboardingContextByLandingPagePrefixSuccess = {
  __typename?: "QueryOrganizationOnboardingContextByLandingPagePrefixSuccess";
  data: Organization;
};

export type QueryOrganizationResult =
  | BaseError
  | QueryOrganizationSuccess
  | ValidationError;

export type QueryOrganizationSuccess = {
  __typename?: "QueryOrganizationSuccess";
  data: Organization;
};

export type QueryOrganizationUserResult =
  | BaseError
  | QueryOrganizationUserSuccess
  | ValidationError;

export type QueryOrganizationUserSuccess = {
  __typename?: "QueryOrganizationUserSuccess";
  data: User;
};

export type QueryOrganizationUsersResult =
  | BaseError
  | QueryOrganizationUsersSuccess
  | ValidationError;

export type QueryOrganizationUsersSuccess = {
  __typename?: "QueryOrganizationUsersSuccess";
  data: Users;
};

export type QueryOrganizationalFeatureFlagsResult =
  | BaseError
  | QueryOrganizationalFeatureFlagsSuccess
  | ValidationError;

export type QueryOrganizationalFeatureFlagsSuccess = {
  __typename?: "QueryOrganizationalFeatureFlagsSuccess";
  data: OrganizationalFeatureFlags;
};

export type QueryPaymentMethodsResult =
  | BaseError
  | QueryPaymentMethodsSuccess
  | ValidationError;

export type QueryPaymentMethodsSuccess = {
  __typename?: "QueryPaymentMethodsSuccess";
  data: PaymentMethods;
};

export type QueryPointToDollarConversionResult =
  | BaseError
  | QueryPointToDollarConversionSuccess
  | ValidationError;

export type QueryPointToDollarConversionSuccess = {
  __typename?: "QueryPointToDollarConversionSuccess";
  data: Scalars["Float"]["output"];
};

export type QueryPrimaryCardResult =
  | BaseError
  | QueryPrimaryCardSuccess
  | ValidationError;

export type QueryPrimaryCardSuccess = {
  __typename?: "QueryPrimaryCardSuccess";
  data: Card;
};

export type QueryRecentExpenseActivitiesResult =
  | BaseError
  | QueryRecentExpenseActivitiesSuccess
  | ValidationError;

export type QueryRecentExpenseActivitiesSuccess = {
  __typename?: "QueryRecentExpenseActivitiesSuccess";
  data: Array<ExpenseUnionItem>;
};

export type QueryReferralOfferResult =
  | BaseError
  | QueryReferralOfferSuccess
  | ValidationError;

export type QueryReferralOfferSuccess = {
  __typename?: "QueryReferralOfferSuccess";
  data: Offer;
};

export type QueryRewardResult =
  | BaseError
  | QueryRewardSuccess
  | ValidationError;

export type QueryRewardSuccess = {
  __typename?: "QueryRewardSuccess";
  data: Reward;
};

export type QueryRewardsResult =
  | BaseError
  | QueryRewardsSuccess
  | ValidationError;

export type QueryRewardsSuccess = {
  __typename?: "QueryRewardsSuccess";
  data: Rewards;
};

export type QueryStatementResult =
  | BaseError
  | QueryStatementSuccess
  | ValidationError;

export type QueryStatementSuccess = {
  __typename?: "QueryStatementSuccess";
  data: Statement;
};

export type QueryStatementsResult =
  | BaseError
  | QueryStatementsSuccess
  | ValidationError;

export type QueryStatementsSuccess = {
  __typename?: "QueryStatementsSuccess";
  data: Statements;
};

export type QueryStipendExpenseResult =
  | BaseError
  | QueryStipendExpenseSuccess
  | ValidationError;

export type QueryStipendExpenseSuccess = {
  __typename?: "QueryStipendExpenseSuccess";
  data: StipendExpense;
};

export type QueryStipendExpensesByViewResult =
  | BaseError
  | QueryStipendExpensesByViewSuccess
  | ValidationError;

export type QueryStipendExpensesByViewSuccess = {
  __typename?: "QueryStipendExpensesByViewSuccess";
  data: StipendExpenses;
};

export type QueryStipendRulesResult =
  | BaseError
  | QueryStipendRulesSuccess
  | ValidationError;

export type QueryStipendRulesSuccess = {
  __typename?: "QueryStipendRulesSuccess";
  data: StipendDetails;
};

export type QueryStipendWalletResult =
  | BaseError
  | QueryStipendWalletSuccess
  | ValidationError;

export type QueryStipendWalletSuccess = {
  __typename?: "QueryStipendWalletSuccess";
  data: StipendWallet;
};

export type QueryStipendWalletsResult =
  | BaseError
  | QueryStipendWalletsSuccess
  | ValidationError;

export type QueryStipendWalletsSuccess = {
  __typename?: "QueryStipendWalletsSuccess";
  data: StipendWallets;
};

export type QueryTotalPendingReimbursementAmountResult =
  | BaseError
  | QueryTotalPendingReimbursementAmountSuccess
  | ValidationError;

export type QueryTotalPendingReimbursementAmountSuccess = {
  __typename?: "QueryTotalPendingReimbursementAmountSuccess";
  data: Scalars["Float"]["output"];
};

export type QueryTotalPointsResult =
  | BaseError
  | QueryTotalPointsSuccess
  | ValidationError;

export type QueryTotalPointsSuccess = {
  __typename?: "QueryTotalPointsSuccess";
  data: Scalars["Int"]["output"];
};

export type QueryTotalReimbursedAmountResult =
  | BaseError
  | QueryTotalReimbursedAmountSuccess
  | ValidationError;

export type QueryTotalReimbursedAmountSuccess = {
  __typename?: "QueryTotalReimbursedAmountSuccess";
  data: Scalars["Float"]["output"];
};

export type QueryTransactionResult =
  | BaseError
  | QueryTransactionSuccess
  | ValidationError;

export type QueryTransactionSuccess = {
  __typename?: "QueryTransactionSuccess";
  data: Transaction;
};

export type QueryTransactionSumResult =
  | BaseError
  | QueryTransactionSumSuccess
  | ValidationError;

export type QueryTransactionSumSuccess = {
  __typename?: "QueryTransactionSumSuccess";
  data: Scalars["Float"]["output"];
};

export type QueryTransactionsResult =
  | BaseError
  | QueryTransactionsSuccess
  | ValidationError;

export type QueryTransactionsSuccess = {
  __typename?: "QueryTransactionsSuccess";
  data: Transactions;
};

export type QueryUserFeatureFlagsResult =
  | BaseError
  | QueryUserFeatureFlagsSuccess
  | ValidationError;

export type QueryUserFeatureFlagsSuccess = {
  __typename?: "QueryUserFeatureFlagsSuccess";
  data: FeatureFlags;
};

export type QueryVisibleCustomFieldsResult =
  | BaseError
  | QueryVisibleCustomFieldsSuccess
  | ValidationError;

export type QueryVisibleCustomFieldsSuccess = {
  __typename?: "QueryVisibleCustomFieldsSuccess";
  data: CustomFieldEntities;
};

export type QueryVisibleExpenseCategoriesResult =
  | BaseError
  | QueryVisibleExpenseCategoriesSuccess
  | ValidationError;

export type QueryVisibleExpenseCategoriesSuccess = {
  __typename?: "QueryVisibleExpenseCategoriesSuccess";
  data: ExpenseCategoryGlPairings;
};

export type ReferralEmployee = {
  __typename?: "ReferralEmployee";
  firstName: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  workEmail: Scalars["String"]["output"];
};

export type ReportCountsPerStatusWithPercentageChange = {
  __typename?: "ReportCountsPerStatusWithPercentageChange";
  autoApprovedCount: Scalars["Int"]["output"];
  autoApprovedCountPercentageChange: Scalars["Float"]["output"];
  autoApprovedTotalPercentage: Scalars["Float"]["output"];
  distinctApprovedOrPartiallyApprovedCount: Scalars["Int"]["output"];
  manuallyApprovedCount: Scalars["Int"]["output"];
  manuallyApprovedCountPercentageChange: Scalars["Float"]["output"];
  manuallyApprovedTotalPercentage: Scalars["Float"]["output"];
  partiallyApprovedCount: Scalars["Int"]["output"];
  partiallyApprovedCountPercentageChange: Scalars["Float"]["output"];
  partiallyApprovedTotalPercentage: Scalars["Float"]["output"];
  rejectedCount: Scalars["Int"]["output"];
  rejectedCountPercentageChange: Scalars["Float"]["output"];
  rejectedTotalPercentage: Scalars["Float"]["output"];
  totalApprovedAmount: Scalars["Float"]["output"];
  totalReportCount: Scalars["Int"]["output"];
};

export type ReportPolicyCheckerExpenseViolation = {
  __typename?: "ReportPolicyCheckerExpenseViolation";
  expenseId: Scalars["Int"]["output"];
  reason: Scalars["String"]["output"];
  type: ExpenseViolationType;
};

export type ReportPolicyCheckerResult = {
  __typename?: "ReportPolicyCheckerResult";
  policyViolations: Array<ReportPolicyCheckerExpenseViolation>;
};

export enum RestaurantCity {
  Austin = "austin",
  LosAngeles = "losAngeles",
  Miami = "miami",
  Nyc = "nyc",
  SanFrancisco = "sanFrancisco",
}

export type RestaurantOffer = {
  __typename?: "RestaurantOffer";
  city: RestaurantCity;
  cuisine?: Maybe<Scalars["String"]["output"]>;
  displayCity?: Maybe<Scalars["String"]["output"]>;
  location: Scalars["String"]["output"];
  primaryImageUrl: Scalars["String"]["output"];
  secondaryImageUrl: Scalars["String"]["output"];
};

export type Reward = {
  __typename?: "Reward";
  amount: Scalars["Float"]["output"];
  applicationMethod: RewardApplicationMethod;
  createdAt: Scalars["DateTime"]["output"];
  details: Scalars["String"]["output"];
  displayAmount: Scalars["String"]["output"];
  displayFlair?: Maybe<Scalars["String"]["output"]>;
  displaySubtitle: Scalars["String"]["output"];
  displayTitle: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  multiplier?: Maybe<Scalars["Int"]["output"]>;
  offer?: Maybe<Offer>;
  rewardDescription: Scalars["String"]["output"];
  /** Used to identify reversals and redemptions. Reversals will have a RED gradient applied */
  type: RewardType;
};

export enum RewardApplicationMethod {
  Cashback = "cashback",
  Points = "points",
}

export enum RewardType {
  Redeem = "redeem",
  Regular = "regular",
  Reversal = "reversal",
}

export type Rewards = {
  __typename?: "Rewards";
  hasMore: Scalars["Boolean"]["output"];
  nextPageOffset?: Maybe<Scalars["Int"]["output"]>;
  rewards: Array<Reward>;
};

export type SapConnectionDetail = {
  __typename?: "SAPConnectionDetail";
  accessToken?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  geolocation?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["Int"]["output"];
  organizationId: Scalars["String"]["output"];
  refreshToken?: Maybe<Scalars["String"]["output"]>;
  sapCompanyUuid?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ShortCard = {
  __typename?: "ShortCard";
  id: Scalars["String"]["output"];
  status: CardStatus;
};

export enum SourceOfIncome {
  Allowance = "allowance",
  Employment = "employment",
  InvestmentIncome = "investmentIncome",
  Other = "other",
  PartnerIncome = "partnerIncome",
  ScholarshipAndGrant = "scholarshipAndGrant",
}

export type Statement = {
  __typename?: "Statement";
  amountDue: Scalars["Float"]["output"];
  credits: Scalars["Float"]["output"];
  creditsTotal: Scalars["Float"]["output"];
  currentBalance: Scalars["Float"]["output"];
  dueDate: Scalars["DateTime"]["output"];
  endDate: Scalars["DateTime"]["output"];
  feesTotal: Scalars["Float"]["output"];
  id: Scalars["String"]["output"];
  interestTotal: Scalars["Float"]["output"];
  minimumAmountDue: Scalars["Float"]["output"];
  nextStatement: Scalars["DateTime"]["output"];
  payments: Scalars["Float"]["output"];
  paymentsAndCredits: Scalars["Float"]["output"];
  previousBalance: Scalars["Float"]["output"];
  previousMinimumAmountDue: Scalars["Float"]["output"];
  purchaseTotal: Scalars["Float"]["output"];
  startDate: Scalars["DateTime"]["output"];
  statementDate: Scalars["DateTime"]["output"];
  statementMinimum: Scalars["Float"]["output"];
};

export type Statements = {
  __typename?: "Statements";
  count: Scalars["Int"]["output"];
  nextCursor?: Maybe<Scalars["String"]["output"]>;
  previousCursor?: Maybe<Scalars["String"]["output"]>;
  statements: Array<Statement>;
};

export enum StipendCategory {
  Celebration = "celebration",
  Commute = "commute",
  Connectivity = "connectivity",
  Convenience = "convenience",
  Education = "education",
  Entertainment = "entertainment",
  Fitness = "fitness",
  Food = "food",
  Healthcare = "healthcare",
  Network = "network",
  Travel = "travel",
  Wellness = "wellness",
}

export type StipendDetail = {
  __typename?: "StipendDetail";
  amount: Scalars["Float"]["output"];
  amountClaimed: Scalars["Float"]["output"];
  category: StipendCategory;
  createdAt: Scalars["DateTime"]["output"];
  cycleEndDate?: Maybe<Scalars["DateTime"]["output"]>;
  cycleStartDate: Scalars["DateTime"]["output"];
  departmentIds?: Maybe<Array<Scalars["Int"]["output"]>>;
  departments?: Maybe<Array<Department>>;
  displayCategory: Scalars["String"]["output"];
  expiresAt?: Maybe<Scalars["DateTime"]["output"]>;
  frequency: StipendRuleFrequency;
  iconUrl: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  isBalanceForwardable: Scalars["Boolean"]["output"];
  isEnabled: Scalars["Boolean"]["output"];
  isSingleUsage: Scalars["Boolean"]["output"];
  longDetails?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  numberOfClaims: Scalars["Int"]["output"];
  startsAt: Scalars["DateTime"]["output"];
  terms?: Maybe<Scalars["String"]["output"]>;
};

export type StipendDetails = {
  __typename?: "StipendDetails";
  hasMore: Scalars["Boolean"]["output"];
  nextPageOffset?: Maybe<Scalars["Int"]["output"]>;
  stipendRules: Array<StipendDetail>;
};

export type StipendEmployeeSpendAnalytic = {
  __typename?: "StipendEmployeeSpendAnalytic";
  employeeId: Scalars["String"]["output"];
  stipendExpenseCount: Scalars["Int"]["output"];
  totalExpenseAmount: Scalars["Float"]["output"];
  user: User;
};

export type StipendExpense = {
  __typename?: "StipendExpense";
  amount: Scalars["Float"]["output"];
  approvedOrRejectedAt?: Maybe<Scalars["DateTime"]["output"]>;
  approvedOrRejectedBy?: Maybe<PublicUser>;
  approvedOrRejectedByEmployeeId?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  designatedApprover?: Maybe<PublicUser>;
  displayPayoutMethod?: Maybe<Scalars["String"]["output"]>;
  displayStatus: Scalars["String"]["output"];
  employeeId: Scalars["String"]["output"];
  employerNotes?: Maybe<Scalars["String"]["output"]>;
  isAutoApproved: Scalars["Boolean"]["output"];
  merchantName?: Maybe<Scalars["String"]["output"]>;
  notes?: Maybe<Scalars["String"]["output"]>;
  paymentMethod: ExpensePaymentMethod;
  payoutMethod?: Maybe<ExpensePayoutMethod>;
  receiptFileUrl?: Maybe<Scalars["String"]["output"]>;
  status: StipendExpenseStatus;
  stipendDetail: StipendDetail;
  stipendExpenseId: Scalars["String"]["output"];
  stipendIconUrl: Scalars["String"]["output"];
  stipendName: Scalars["String"]["output"];
  stipendWalletId: Scalars["Int"]["output"];
  submittedAt: Scalars["DateTime"]["output"];
  transaction?: Maybe<Transaction>;
  transactionCategoryIconUrl: Scalars["String"]["output"];
  transactionDate: Scalars["Date"]["output"];
  transactionId?: Maybe<Scalars["Int"]["output"]>;
  user: User;
};

export enum StipendExpenseAnalyticGroup {
  Category = "CATEGORY",
  Department = "DEPARTMENT",
  Employee = "EMPLOYEE",
  Manager = "MANAGER",
  Merchant = "MERCHANT",
  PaymentMethod = "PAYMENT_METHOD",
  PolicyStatus = "POLICY_STATUS",
  Reviewer = "REVIEWER",
  StipendExpenseStatus = "STIPEND_EXPENSE_STATUS",
  StipendRule = "STIPEND_RULE",
}

export type StipendExpenseAutoApprovalMetadata = {
  __typename?: "StipendExpenseAutoApprovalMetadata";
  isAutoApproved: Scalars["Boolean"]["output"];
  reason?: Maybe<Scalars["String"]["output"]>;
};

export type StipendExpenseCreateInput = {
  amount: Scalars["Float"]["input"];
  merchantName: Scalars["String"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
  transactionDate: Scalars["Date"]["input"];
  transactionId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type StipendExpenseFilterInput = {
  createdAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdBefore?: InputMaybe<Scalars["DateTime"]["input"]>;
  expenseAmountLessThan?: InputMaybe<Scalars["Float"]["input"]>;
  expenseAmountMoreThan?: InputMaybe<Scalars["Float"]["input"]>;
  merchantName?: InputMaybe<Array<Scalars["String"]["input"]>>;
  stipendExpenseStatus?: InputMaybe<Array<StipendExpenseStatus>>;
  stipendRuleId?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  stipendWalletId?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  transactedAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
  transactedBefore?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type StipendExpensePolicyCheckerResult = {
  __typename?: "StipendExpensePolicyCheckerResult";
  policyStatus: ExpensePolicyStatus;
  reason: Scalars["String"]["output"];
};

export enum StipendExpenseSortField {
  Amount = "amount",
  CreatedAt = "createdAt",
  TransactionDate = "transactionDate",
}

export enum StipendExpenseStatus {
  Approved = "approved",
  Pending = "pending",
  Rejected = "rejected",
}

export type StipendExpenses = {
  __typename?: "StipendExpenses";
  hasMore: Scalars["Boolean"]["output"];
  nextPageOffset?: Maybe<Scalars["Int"]["output"]>;
  stipendExpenses: Array<StipendExpense>;
};

export type StipendExpensesSortInput = {
  ascendingDirection: Scalars["Boolean"]["input"];
  field: StipendExpenseSortField;
};

export enum StipendLedgerEntryType {
  Adjustment = "adjustment",
  Expense = "expense",
  Fund = "fund",
  Reversal = "reversal",
}

export type StipendRuleFilterInput = {
  associatedDepartmentIds?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  category?: InputMaybe<Array<Scalars["String"]["input"]>>;
  employeeWorkPeriodInDays?: InputMaybe<Scalars["Int"]["input"]>;
  expirationStatus?: InputMaybe<Array<StipendStatus>>;
  expiredAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
  frequency?: InputMaybe<Array<StipendRuleFrequency>>;
  isEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  stipendRuleIds?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export enum StipendRuleFrequency {
  Daily = "daily",
  Monthly = "monthly",
  OneTime = "oneTime",
}

export type StipendRuleSpendAnalytic = {
  __typename?: "StipendRuleSpendAnalytic";
  ruleId: Scalars["Int"]["output"];
  stipendDetail: StipendDetail;
  stipendExpenseCount: Scalars["Int"]["output"];
  totalExpenseAmount: Scalars["Float"]["output"];
};

export type StipendRuleValidationResult = {
  __typename?: "StipendRuleValidationResult";
  isValid: Scalars["Boolean"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
};

export enum StipendStatus {
  Active = "active",
  Disabled = "disabled",
  Expired = "expired",
  Upcoming = "upcoming",
}

export type StipendSummaryWithPercentageChange = {
  __typename?: "StipendSummaryWithPercentageChange";
  autoApprovedCountPercentageChange: Scalars["Float"]["output"];
  autoApprovedTotalPercentage: Scalars["Float"]["output"];
  manuallyApprovedCountPercentageChange: Scalars["Float"]["output"];
  manuallyApprovedTotalPercentage: Scalars["Float"]["output"];
  numberOfAutoApprovedStipends: Scalars["Int"]["output"];
  numberOfManuallyApprovedStipends: Scalars["Int"]["output"];
  numberOfRejectedStipends: Scalars["Int"]["output"];
  rejectedCountPercentageChange: Scalars["Float"]["output"];
  rejectedTotalPercentage: Scalars["Float"]["output"];
  totalCountOfStipendsApproved: Scalars["Int"]["output"];
  totalSumOfStipendsRedeemed: Scalars["Float"]["output"];
};

export type StipendWallet = {
  __typename?: "StipendWallet";
  createdAt: Scalars["DateTime"]["output"];
  expenses: Array<StipendExpense>;
  expiresAt?: Maybe<Scalars["DateTime"]["output"]>;
  fundsExpireAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["Int"]["output"];
  pendingBalance: Scalars["Float"]["output"];
  remainingBalance: Scalars["Float"]["output"];
  startingBalance: Scalars["Float"]["output"];
  startsAt: Scalars["DateTime"]["output"];
  stipendDetail: StipendDetail;
};

export type StipendWallets = {
  __typename?: "StipendWallets";
  wallets: Array<StipendWallet>;
};

export type StipendWalletsFilterInput = {
  expirationStatus?: InputMaybe<Array<StipendStatus>>;
};

export type StringCursorPaginationInput = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SubmitDraftExpenseReportResult =
  | ReportPolicyCheckerResult
  | SubmittedReportResult;

export type SubmitStipendExpenseV2Result =
  | StipendExpensePolicyCheckerResult
  | SubmittedStipendExpenseResult;

export type SubmittedReportResult = {
  __typename?: "SubmittedReportResult";
  autoApprovalMetadata: ExpenseReportAutoApprovalMetadata;
  report: ExpenseReport;
  timeSaved: ExpenseReportsTimeSaved;
};

export type SubmittedStipendExpenseResult = {
  __typename?: "SubmittedStipendExpenseResult";
  autoApprovalMetadata?: Maybe<StipendExpenseAutoApprovalMetadata>;
  expense: StipendExpense;
};

export type TestExpensePolicyInput = {
  expense: TestPolicyExpenseInput;
  policy: Scalars["String"]["input"];
};

export type TestExpensePolicyResult = {
  __typename?: "TestExpensePolicyResult";
  isAutoApproved: Scalars["Boolean"]["output"];
  reason?: Maybe<Scalars["String"]["output"]>;
  violationType?: Maybe<ExpenseViolationType>;
};

export type TestPolicyExpenseInput = {
  amount: Scalars["Float"]["input"];
  expenseCategoryGLId?: InputMaybe<Scalars["Int"]["input"]>;
  merchantName: Scalars["String"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
  receiptFileData?: InputMaybe<Scalars["String"]["input"]>;
  transactionDate: Scalars["Date"]["input"];
};

export type TimePeriodFilter = {
  createdAfter: Scalars["DateTime"]["input"];
  createdBefore: Scalars["DateTime"]["input"];
};

export type Transaction = {
  __typename?: "Transaction";
  amountInDollars: Scalars["Float"]["output"];
  cardLast4Digits?: Maybe<Scalars["String"]["output"]>;
  cardholderId: Scalars["String"]["output"];
  creditIndicator: CreditIndicator;
  digitalWallet?: Maybe<DigitalWallet>;
  displayDeclineReason?: Maybe<Scalars["String"]["output"]>;
  displayDollarAmount: Scalars["String"]["output"];
  displayFlair?: Maybe<Scalars["String"]["output"]>;
  displayLocation?: Maybe<Scalars["String"]["output"]>;
  displayTitle: Scalars["String"]["output"];
  dispute?: Maybe<Dispute>;
  expenseCategoryGLId?: Maybe<Scalars["Int"]["output"]>;
  expenseEnrichment?: Maybe<TransactionExpenseEnrichment>;
  expenses: Array<Expense>;
  externalMerchant?: Maybe<ExternalMerchant>;
  hypercardCategoryIconUrl: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  latestExpense?: Maybe<Expense>;
  latestStipendExpense?: Maybe<StipendExpense>;
  posType?: Maybe<Scalars["String"]["output"]>;
  reward?: Maybe<TransactionReward>;
  settledAt?: Maybe<Scalars["DateTime"]["output"]>;
  status: TransactionStatus;
  stipendExpenses: Array<StipendExpense>;
  transactedAt: Scalars["DateTime"]["output"];
  transactionLocality?: Maybe<TransactionLocality>;
  type: TransactionType;
  typeCategory?: Maybe<Scalars["String"]["output"]>;
  typeCategoryMetadata?: Maybe<Scalars["String"]["output"]>;
};

export type TransactionExpenseEnrichment = {
  __typename?: "TransactionExpenseEnrichment";
  expenseCategoryGLId?: Maybe<Scalars["Int"]["output"]>;
};

export type TransactionItem = PaymentTransaction | Transaction;

export enum TransactionLocality {
  International = "international",
  Regular = "regular",
}

export type TransactionReward = {
  __typename?: "TransactionReward";
  cashbackReward?: Maybe<Reward>;
  pointsReward?: Maybe<Reward>;
};

export enum TransactionSortField {
  Amount = "amount",
  TransactedAt = "transactedAt",
}

export enum TransactionStatus {
  Declined = "declined",
  Pending = "pending",
  Reversed = "reversed",
  Settled = "settled",
}

export enum TransactionType {
  BankCashback = "bankCashback",
  BankCashbackAdjustment = "bankCashbackAdjustment",
  CashAdvance = "cashAdvance",
  CreditBalanceRefund = "creditBalanceRefund",
  Dispute = "dispute",
  Fee = "fee",
  FeeAdjustment = "feeAdjustment",
  Payment = "payment",
  Refund = "refund",
  Regular = "regular",
}

export type Transactions = {
  __typename?: "Transactions";
  allTransactions: Array<TransactionItem>;
  hasMore: Scalars["Boolean"]["output"];
  nextPageOffset?: Maybe<Scalars["Int"]["output"]>;
};

export type TransactionsFilterInput = {
  amountLessThan?: InputMaybe<Scalars["Float"]["input"]>;
  amountMoreThan?: InputMaybe<Scalars["Float"]["input"]>;
  creditIndicator?: InputMaybe<Array<CreditIndicator>>;
  digitalWallet?: InputMaybe<Array<DigitalWallet>>;
  flaggedForReimbursement?: InputMaybe<Scalars["Boolean"]["input"]>;
  merchantName?: InputMaybe<Scalars["String"]["input"]>;
  settledAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
  settledBefore?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<Array<TransactionStatus>>;
  transactedAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
  transactedBefore?: InputMaybe<Scalars["DateTime"]["input"]>;
  transactionLocality?: InputMaybe<Array<TransactionLocality>>;
  type?: InputMaybe<Array<TransactionType>>;
};

export type TransactionsSortInput = {
  ascendingDirection: Scalars["Boolean"]["input"];
  field: TransactionSortField;
};

export type UpdateCardholderAddressInput = {
  addressLine1: Scalars["String"]["input"];
  addressLine2?: InputMaybe<Scalars["String"]["input"]>;
  city: Scalars["String"]["input"];
  state: Scalars["String"]["input"];
  type: AddressType;
  zip: Scalars["String"]["input"];
};

export type UpdateStipendRuleInput = {
  category?: InputMaybe<Scalars["String"]["input"]>;
  departmentIds?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  expiresAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  isEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  longDetails?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  terms?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertAutoPaymentScheduleInput = {
  paymentMethodId: Scalars["String"]["input"];
  type: PaymentType;
};

export type UpsertBeneficiaryInput = {
  beneficiary: BeneficiaryDetailsInput;
  beneficiaryId?: InputMaybe<Scalars["String"]["input"]>;
  nickname?: InputMaybe<Scalars["String"]["input"]>;
  paymentMethods: Array<Scalars["String"]["input"]>;
};

export type User = {
  __typename?: "User";
  cardholder?: Maybe<CardholderProfile>;
  displayName: Scalars["String"]["output"];
  employee?: Maybe<EmployeeProfile>;
  /** The highest employee role. Throws errors if our friends and family cardholders try to get this value. */
  employeeDisplayRole: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  referralLink: Scalars["String"]["output"];
  roles: Array<UserRole>;
  userId: Scalars["String"]["output"];
};

export enum UserFeatureNotification {
  HypercardLaunch = "hypercard_launch",
  RestaurantReservations = "restaurant_reservations",
}

export type UserFilterInput = {
  departmentIds?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  employeeIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  exceptEmployeeIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  exceptUserIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  managerEmployeeIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** DEPTH = 1: only direct reports, DEPTH = 2: direct reports and their direct reports */
  maxEmployeeHeirarchyDepth?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  personalEmail?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  roles?: InputMaybe<Array<UserRole>>;
  userIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  workEmail?: InputMaybe<Scalars["String"]["input"]>;
};

export enum UserRole {
  Admin = "admin",
  Cardholder = "cardholder",
  Employee = "employee",
  Manager = "manager",
}

export type UserRoleCounts = {
  __typename?: "UserRoleCounts";
  admin: Scalars["Int"]["output"];
  cardholder: Scalars["Int"]["output"];
  employee: Scalars["Int"]["output"];
  manager: Scalars["Int"]["output"];
};

export type Users = {
  __typename?: "Users";
  hasMore: Scalars["Boolean"]["output"];
  nextPageOffset?: Maybe<Scalars["Int"]["output"]>;
  users: Array<User>;
};

export type ValidationError = Error & {
  __typename?: "ValidationError";
  code: Scalars["String"]["output"];
  fieldErrors?: Maybe<Array<ZodFieldError>>;
  message: Scalars["String"]["output"];
};

export type WaitlistUser = {
  __typename?: "WaitlistUser";
  annualIncome?: Maybe<Scalars["Float"]["output"]>;
  dateOfBirth?: Maybe<Scalars["Date"]["output"]>;
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  formattedDateOfBirth?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  residentialAddress?: Maybe<Address>;
  ssn?: Maybe<Scalars["String"]["output"]>;
};

export type WaitlistUserApplicationStartedContext = {
  __typename?: "WaitlistUserApplicationStartedContext";
  applicationId: Scalars["String"]["output"];
  waitlistUser: WaitlistUser;
};

export type ZodFieldError = {
  __typename?: "ZodFieldError";
  message: Scalars["String"]["output"];
  path: Array<Scalars["String"]["output"]>;
};

export type EmployeeAttendeeRecommendationsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type EmployeeAttendeeRecommendationsQuery = {
  __typename?: "Query";
  employeeAttendeeRecommendations:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryEmployeeAttendeeRecommendationsSuccess";
        data: {
          __typename?: "PublicEmployees";
          employees: Array<{
            __typename?: "PublicEmployee";
            firstName: string;
            lastName: string;
            workEmail: string;
          }>;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type HealthCheckQueryVariables = Exact<{ [key: string]: never }>;

export type HealthCheckQuery = { __typename?: "Query"; healthCheck: string };

export type AdminReportGraphMetricsQueryVariables = Exact<{
  computePrevious?: InputMaybe<Scalars["Boolean"]["input"]>;
  filters?: InputMaybe<AdminReportExpenseFilterInput>;
  groupedBy: ExpenseReportAnalyticGroup;
  interval: GraphAnalyticInterval;
  groupByCustomFieldEntityId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type AdminReportGraphMetricsQuery = {
  __typename?: "Query";
  adminReportGraphMetrics:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryAdminReportGraphMetricsSuccess";
        data: {
          __typename?: "GraphAnalyticResponse";
          metrics: Array<{
            __typename?: "GraphAnalyticMetric";
            id: string;
            groupedEntityName: string;
            totalValue: number;
            totalCount: number;
            values: Array<{
              __typename?: "GraphAnalyticMetricValue";
              date: any;
              value: number;
              count: number;
            }>;
          }>;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type AdminStipendGraphMetricsQueryVariables = Exact<{
  computePrevious?: InputMaybe<Scalars["Boolean"]["input"]>;
  filters?: InputMaybe<AdminStipendExpenseFilterInput>;
  groupedBy: StipendExpenseAnalyticGroup;
  interval: GraphAnalyticInterval;
}>;

export type AdminStipendGraphMetricsQuery = {
  __typename?: "Query";
  adminStipendGraphMetrics?:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryAdminStipendGraphMetricsSuccess";
        data: {
          __typename?: "GraphAnalyticResponse";
          metrics: Array<{
            __typename?: "GraphAnalyticMetric";
            id: string;
            groupedEntityName: string;
            totalValue: number;
            totalCount: number;
            values: Array<{
              __typename?: "GraphAnalyticMetricValue";
              date: any;
              value: number;
              count: number;
            }>;
          }>;
        };
      }
    | { __typename?: "ValidationError"; message: string }
    | null;
};

export type FilterOptionsQueryVariables = Exact<{
  categories: Array<FilterCategoryEnum> | FilterCategoryEnum;
  customFieldEntityIds?: InputMaybe<
    Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
  >;
  pagination?: InputMaybe<OffsetPaginationInput>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type FilterOptionsQuery = {
  __typename?: "Query";
  filterOptions:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryFilterOptionsSuccess";
        data: {
          __typename?: "FilterOptions";
          options: Array<{
            __typename?: "FilterOption";
            category: FilterCategoryEnum;
            id: string;
            displayTitle: string;
            displaySubtitle: string;
            iconUrl?: string | null;
            secondaryId?: string | null;
          }>;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type AdminOrganizationExpensesQueryVariables = Exact<{
  filters?: InputMaybe<AdminReportExpenseFilterInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
}>;

export type AdminOrganizationExpensesQuery = {
  __typename?: "Query";
  adminOrganizationExpenses:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryAdminOrganizationExpensesSuccess";
        data: {
          __typename?: "Expenses";
          expenses: Array<{
            __typename?: "Expense";
            amount: number;
            merchantName: string;
            paymentMethod: ExpensePaymentMethod;
            transactionCategoryIconUrl: string;
            transactionDate: any;
            notes?: string | null;
            receiptFileUrl?: string | null;
            status: ExpenseStatus;
            report: {
              __typename?: "ExpenseReport";
              title: string;
              employerNotes?: string | null;
              approvedOrRejectedAt?: any | null;
              displayTotalDollarAmount: string;
            };
            expenseCategory?: {
              __typename?: "ExpenseCategoryGLPairing";
              categoryName: string;
            } | null;
            user: {
              __typename?: "User";
              displayName: string;
              employee?: {
                __typename?: "EmployeeProfile";
                workEmail: string;
                department: { __typename?: "Department"; name: string };
              } | null;
            };
          }>;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type StipendExpensesByViewForReportingQueryVariables = Exact<{
  filters?: InputMaybe<AdminStipendExpenseFilterInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
}>;

export type StipendExpensesByViewForReportingQuery = {
  __typename?: "Query";
  stipendExpensesByView:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryStipendExpensesByViewSuccess";
        data: {
          __typename?: "StipendExpenses";
          hasMore: boolean;
          stipendExpenses: Array<{
            __typename?: "StipendExpense";
            amount: number;
            merchantName?: string | null;
            notes?: string | null;
            paymentMethod: ExpensePaymentMethod;
            receiptFileUrl?: string | null;
            stipendIconUrl: string;
            stipendName: string;
            approvedOrRejectedAt?: any | null;
            transactionDate: any;
            status: StipendExpenseStatus;
            approvedOrRejectedBy?: {
              __typename?: "PublicUser";
              displayName: string;
            } | null;
            user: {
              __typename?: "User";
              displayName: string;
              employee?: {
                __typename?: "EmployeeProfile";
                workEmail: string;
                department: { __typename?: "Department"; name: string };
              } | null;
            };
          }>;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type InitiateAuthenticationMutationVariables = Exact<{
  email: Scalars["String"]["input"];
  redirectUri: Scalars["String"]["input"];
  state?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type InitiateAuthenticationMutation = {
  __typename?: "Mutation";
  initiateAuthentication:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationInitiateAuthenticationSuccess";
        data: {
          __typename?: "AuthenticationInitationResponse";
          authenticationUrl?: string | null;
          isOTPSent?: boolean | null;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type VerifyAuthCodeMutationVariables = Exact<{
  code: Scalars["String"]["input"];
}>;

export type VerifyAuthCodeMutation = {
  __typename?: "Mutation";
  verifyAuthCode:
    | { __typename?: "BaseError" }
    | {
        __typename?: "MutationVerifyAuthCodeSuccess";
        data: {
          __typename?: "AuthTokenResponse";
          accessToken: string;
          refreshToken: string;
          accessTokenExpiresAt: any;
          refreshTokenExpiresAt: any;
        };
      }
    | { __typename?: "ValidationError" };
};

export type VerifyOtpCodeMutationVariables = Exact<{
  email: Scalars["String"]["input"];
  code: Scalars["String"]["input"];
}>;

export type VerifyOtpCodeMutation = {
  __typename?: "Mutation";
  verifyOTPCode:
    | { __typename?: "BaseError" }
    | {
        __typename?: "MutationVerifyOTPCodeSuccess";
        data: {
          __typename?: "AuthTokenResponse";
          accessToken: string;
          accessTokenExpiresAt: any;
          refreshToken: string;
          refreshTokenExpiresAt: any;
        };
      }
    | { __typename?: "ValidationError" };
};

export type RefreshAccessTokenMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RefreshAccessTokenMutation = {
  __typename?: "Mutation";
  refreshAccessToken:
    | { __typename?: "BaseError" }
    | {
        __typename?: "MutationRefreshAccessTokenSuccess";
        data: {
          __typename?: "AuthTokenResponse";
          accessToken: string;
          accessTokenExpiresAt: any;
          refreshToken: string;
          refreshTokenExpiresAt: any;
        };
      }
    | { __typename?: "ValidationError" };
};

export type InvalidateRefreshTokenMutationVariables = Exact<{
  [key: string]: never;
}>;

export type InvalidateRefreshTokenMutation = {
  __typename?: "Mutation";
  invalidateRefreshToken:
    | { __typename: "BaseError" }
    | { __typename: "MutationInvalidateRefreshTokenSuccess" }
    | { __typename: "ValidationError" };
};

export type AuthenticalUrlQueryVariables = Exact<{
  redirectUri: Scalars["String"]["input"];
  email?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
  provider?: InputMaybe<AuthProvider>;
}>;

export type AuthenticalUrlQuery = {
  __typename?: "Query";
  authenticationUrl:
    | { __typename?: "BaseError"; message: string }
    | { __typename?: "QueryAuthenticationUrlSuccess"; data: string }
    | { __typename?: "ValidationError"; message: string };
};

export type AccountQueryVariables = Exact<{ [key: string]: never }>;

export type AccountQuery = {
  __typename?: "Query";
  account:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryAccountSuccess";
        data: {
          __typename?: "Account";
          currentBalance: number;
          creditLimit: number;
          dueDateUtc: any;
          dueAmount: number;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type TotalPointsQueryVariables = Exact<{ [key: string]: never }>;

export type TotalPointsQuery = {
  __typename?: "Query";
  totalPoints?:
    | { __typename?: "BaseError"; message: string }
    | { __typename?: "QueryTotalPointsSuccess"; data: number }
    | { __typename?: "ValidationError"; message: string }
    | null;
};

export type CardArtQueryVariables = Exact<{ [key: string]: never }>;

export type CardArtQuery = {
  __typename?: "Query";
  cardArt:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryCardArtSuccess";
        data: { __typename?: "CardArt"; frontImageUrl: string };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type PrimaryCardQueryVariables = Exact<{ [key: string]: never }>;

export type PrimaryCardQuery = {
  __typename?: "Query";
  primaryCard:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryPrimaryCardSuccess";
        data: { __typename?: "Card"; last4Digits: string };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type TransactionsQueryVariables = Exact<{ [key: string]: never }>;

export type TransactionsQuery = {
  __typename?: "Query";
  transactions:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryTransactionsSuccess";
        data: {
          __typename?: "Transactions";
          allTransactions: Array<
            | {
                __typename?: "PaymentTransaction";
                displayTitle: string;
                displayDollarAmount: string;
                displayFlair?: string | null;
                transactedAt: any;
                hypercardCategoryIconUrl: string;
                paymentStatus: PaymentTransactionStatus;
                paymentType: PaymentTransactionType;
              }
            | {
                __typename?: "Transaction";
                displayTitle: string;
                displayDollarAmount: string;
                displayFlair?: string | null;
                transactedAt: any;
                hypercardCategoryIconUrl: string;
                creditIndicator: CreditIndicator;
                transactionStatus: TransactionStatus;
                transactionType: TransactionType;
              }
          >;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type OffersQueryVariables = Exact<{
  categories?: InputMaybe<Array<OfferCategory> | OfferCategory>;
}>;

export type OffersQuery = {
  __typename?: "Query";
  offers:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryOffersSuccess";
        data: {
          __typename?: "Offers";
          offers: Array<{
            __typename?: "Offer";
            title: string;
            details: string;
            iconImageUrl?: string | null;
            isUsageLimitReached: boolean;
            hypercardMerchant?: {
              __typename?: "HypercardMerchant";
              logoImageUrl: string;
            } | null;
          }>;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type ReferralOfferQueryVariables = Exact<{ [key: string]: never }>;

export type ReferralOfferQuery = {
  __typename?: "Query";
  referralOffer?:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryReferralOfferSuccess";
        data: {
          __typename?: "Offer";
          caption?: string | null;
          category?: OfferCategory | null;
          details: string;
          flair?: OfferFlair | null;
          iconImageUrl?: string | null;
          isUsageLimitReached: boolean;
          landingPageUrl?: string | null;
          longDetails?: string | null;
          maxUsageCount?: number | null;
          rewardRuleId: number;
          shortRewardDescriptor: string;
          terms?: string | null;
          title: string;
          trigger: OfferTrigger;
          usageCount: number;
        };
      }
    | { __typename?: "ValidationError"; message: string }
    | null;
};

export type AdminReimbursementsTimeSavedInSecondsQueryVariables = Exact<{
  createdAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdBefore?: InputMaybe<Scalars["DateTime"]["input"]>;
}>;

export type AdminReimbursementsTimeSavedInSecondsQuery = {
  __typename?: "Query";
  adminReimbursementsTimeSavedInSeconds?:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryAdminReimbursementsTimeSavedInSecondsSuccess";
        data: number;
      }
    | { __typename?: "ValidationError"; message: string }
    | null;
};

export type FeatureFlagsQueryVariables = Exact<{
  organizationId: Scalars["String"]["input"];
}>;

export type FeatureFlagsQuery = {
  __typename?: "Query";
  organizationalFeatureFlags:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryOrganizationalFeatureFlagsSuccess";
        data: {
          __typename?: "OrganizationalFeatureFlags";
          hypercardDelegatesShown: boolean;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type CurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentUserQuery = {
  __typename?: "Query";
  currentUser?:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryCurrentUserSuccess";
        data: {
          __typename?: "User";
          firstName: string;
          lastName: string;
          displayName: string;
          roles: Array<UserRole>;
          employeeDisplayRole: string;
          userId: string;
          employee?: {
            __typename?: "EmployeeProfile";
            employeeId: string;
            workEmail: string;
            awxBeneficiaryId?: string | null;
            employmentStartDate?: any | null;
            manager?: {
              __typename?: "PublicUser";
              firstName: string;
              lastName: string;
            } | null;
            department: { __typename?: "Department"; name: string; id: number };
            delegateUsers: Array<{
              __typename?: "PublicUser";
              userId: string;
              firstName: string;
              lastName: string;
              displayName: string;
              employee?: {
                __typename?: "PublicEmployeeProfile";
                employeeId: string;
                workEmail: string;
              } | null;
            }>;
            impersonatableDelegateUsers: Array<{
              __typename?: "PublicUser";
              userId: string;
              displayName: string;
              employee?: {
                __typename?: "PublicEmployeeProfile";
                employeeId: string;
              } | null;
            }>;
            organization: {
              __typename?: "Organization";
              organizationId: string;
              name: string;
              homePageCardImageUrl: string;
              cardApplicationPageUrl: string;
            };
          } | null;
          cardholder?: {
            __typename?: "CardholderProfile";
            personalEmail: string;
            phoneNumber: string;
            delegateHasTransactionAccess?: boolean | null;
            residentialAddress?: {
              __typename?: "Address";
              line1?: string | null;
              line2?: string | null;
              city?: string | null;
              postalCode?: string | null;
              state?: string | null;
            } | null;
          } | null;
        };
      }
    | { __typename?: "ValidationError"; message: string }
    | null;
};

export type CardholderQueryVariables = Exact<{ [key: string]: never }>;

export type CardholderQuery = {
  __typename?: "Query";
  cardholder?:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryCardholderSuccess";
        data: {
          __typename?: "CardholderProfile";
          cardholderId: string;
          nameOnCard?: string | null;
        };
      }
    | { __typename?: "ValidationError"; message: string }
    | null;
};

export type ActiveAutoPaymentQueryVariables = Exact<{ [key: string]: never }>;

export type ActiveAutoPaymentQuery = {
  __typename?: "Query";
  activeAutoPayment?:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryActiveAutoPaymentSuccess";
        data: {
          __typename?: "PaymentSchedule";
          amount?: string | null;
          paymentDate?: any | null;
        };
      }
    | { __typename?: "ValidationError"; message: string }
    | null;
};

export type RemoveExpenseFromReportMutationVariables = Exact<{
  expenseId: Scalars["Int"]["input"];
  reportId: Scalars["Int"]["input"];
}>;

export type RemoveExpenseFromReportMutation = {
  __typename?: "Mutation";
  removeExpenseFromReport:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationRemoveExpenseFromReportSuccess";
        data: { __typename?: "Expense"; id: number };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type UpsertExpenseReportMutationVariables = Exact<{
  reportId: Scalars["Int"]["input"];
  title: Scalars["String"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpsertExpenseReportMutation = {
  __typename?: "Mutation";
  upsertExpenseReport:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationUpsertExpenseReportSuccess";
        data: { __typename?: "ExpenseReport"; id: number };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type SubmitDraftExpenseReportMutationVariables = Exact<{
  reportId: Scalars["Int"]["input"];
  skipPolicyCheck: Scalars["Boolean"]["input"];
}>;

export type SubmitDraftExpenseReportMutation = {
  __typename?: "Mutation";
  submitDraftExpenseReport:
    | { __typename?: "BaseError"; code: string; message: string }
    | {
        __typename?: "MutationSubmitDraftExpenseReportSuccess";
        data:
          | {
              __typename?: "ReportPolicyCheckerResult";
              policyViolations: Array<{
                __typename?: "ReportPolicyCheckerExpenseViolation";
                expenseId: number;
                reason: string;
              }>;
            }
          | {
              __typename?: "SubmittedReportResult";
              autoApprovalMetadata: {
                __typename?: "ExpenseReportAutoApprovalMetadata";
                reason?: string | null;
              };
              report: {
                __typename?: "ExpenseReport";
                isAutoApproved: boolean;
                id: number;
              };
            };
      }
    | { __typename?: "ValidationError"; code: string; message: string };
};

export type CreateLeafReportMutationVariables = Exact<{
  title: Scalars["String"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CreateLeafReportMutation = {
  __typename?: "Mutation";
  upsertExpenseReport:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationUpsertExpenseReportSuccess";
        data: { __typename?: "ExpenseReport"; id: number };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type AddExpenseToReportMutationVariables = Exact<{
  idempotencyKey: Scalars["String"]["input"];
  reportId: Scalars["Int"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
  expenseCategoryGLId?: InputMaybe<Scalars["Int"]["input"]>;
  amount: Scalars["Float"]["input"];
  merchantName: Scalars["String"]["input"];
  receiptFileData?: InputMaybe<Scalars["String"]["input"]>;
  transactionDate: Scalars["Date"]["input"];
  attendeeEmails?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  transactionId?: InputMaybe<Scalars["Int"]["input"]>;
  customFieldEntries?: InputMaybe<
    | Array<ExpenseCustomFieldEntryUpsertInput>
    | ExpenseCustomFieldEntryUpsertInput
  >;
}>;

export type AddExpenseToReportMutation = {
  __typename?: "Mutation";
  addExpenseToReport:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationAddExpenseToReportSuccess";
        data: { __typename?: "Expense"; id: number; reportId: number };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type ApproveOrRejectExpenseReportMutationVariables = Exact<{
  approvedExpenseIds: Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"];
  employeeId: Scalars["String"]["input"];
  employerNotes?: InputMaybe<Scalars["String"]["input"]>;
  reportId: Scalars["Int"]["input"];
}>;

export type ApproveOrRejectExpenseReportMutation = {
  __typename?: "Mutation";
  approveOrRejectExpenseReport:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationApproveOrRejectExpenseReportSuccess";
        data: { __typename?: "ExpenseReport"; id: number };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type UpdateExpenseMutationVariables = Exact<{
  expenseId: Scalars["Int"]["input"];
  amount: Scalars["Float"]["input"];
  attendeeEmails?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  merchantName: Scalars["String"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
  transactionDate: Scalars["Date"]["input"];
  receiptFileData?: InputMaybe<Scalars["String"]["input"]>;
  reportId: Scalars["Int"]["input"];
  expenseCategoryGLId?: InputMaybe<Scalars["Int"]["input"]>;
  customFieldEntries?: InputMaybe<
    | Array<ExpenseCustomFieldEntryUpsertInput>
    | ExpenseCustomFieldEntryUpsertInput
  >;
}>;

export type UpdateExpenseMutation = {
  __typename?: "Mutation";
  updateExpense:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationUpdateExpenseSuccess";
        data: { __typename?: "Expense"; id: number };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type ParseExpenseReceiptMutationVariables = Exact<{
  receiptFileData: Scalars["String"]["input"];
}>;

export type ParseExpenseReceiptMutation = {
  __typename?: "Mutation";
  parseReceiptWithOCR:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationParseReceiptWithOCRSuccess";
        data: {
          __typename?: "ExpenseAutofillInfo";
          amount?: number | null;
          merchantName?: string | null;
          transactionDate?: any | null;
          expenseCategoryGLId?: number | null;
          customFields?: Array<{
            __typename?: "ExpenseCustomFieldAutofillInfo";
            booleanValue?: boolean | null;
            customFieldEntityId: number;
            customFieldEntityType: CustomFieldType;
            customFieldListOptionId?: number | null;
            rawValue?: string | null;
          }> | null;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type DeleteReportMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type DeleteReportMutation = {
  __typename?: "Mutation";
  deleteDraftExpenseReport:
    | { __typename?: "BaseError"; code: string; message: string }
    | { __typename?: "MutationDeleteDraftExpenseReportSuccess"; data: boolean }
    | { __typename?: "ValidationError"; code: string; message: string };
};

export type ExpenseReportsByViewQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  expenseReportStatus?: InputMaybe<
    Array<ExpenseReportStatus> | ExpenseReportStatus
  >;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type ExpenseReportsByViewQuery = {
  __typename?: "Query";
  expenseReportsByView:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryExpenseReportsByViewSuccess";
        data: {
          __typename?: "ExpenseReports";
          hasMore: boolean;
          nextPageOffset?: number | null;
          reports: Array<{
            __typename?: "ExpenseReport";
            id: number;
            createdAt: any;
            displayStatus: string;
            displayTotalDollarAmount: string;
            employeeId: string;
            employerNotes?: string | null;
            isAutoApproved: boolean;
            isInstantReimbursed: boolean;
            notes?: string | null;
            status: ExpenseReportStatus;
            statusIconUrl: string;
            title: string;
            updatedAt: any;
            displayPayoutMethod?: string | null;
            designatedApprover?: {
              __typename?: "PublicUser";
              displayName: string;
            } | null;
            approvedOrRejectedBy?: {
              __typename?: "PublicUser";
              displayName: string;
            } | null;
            expenses: Array<{
              __typename?: "Expense";
              expenseCategoryGLId?: number | null;
              amount: number;
              attendeeEmails: Array<string>;
              createdAt: any;
              id: number;
              merchantName: string;
              notes?: string | null;
              receiptFileUrl?: string | null;
              reportId: number;
              transactionDate: any;
              status: ExpenseStatus;
              transactionCategoryIconUrl: string;
              transactionId?: number | null;
              updatedAt: any;
              expenseCategory?: {
                __typename?: "ExpenseCategoryGLPairing";
                id: number;
                categoryName: string;
              } | null;
              report: {
                __typename?: "ExpenseReport";
                status: ExpenseReportStatus;
                displayStatus: string;
                title: string;
                isAutoApproved: boolean;
              };
              customFieldEntries: Array<{
                __typename?: "ExpenseCustomFieldEntry";
                customFieldEntityId: number;
                rawValue?: string | null;
                booleanValue?: boolean | null;
                customFieldListOptionId?: number | null;
                type: CustomFieldType;
              }>;
            }>;
            user: { __typename?: "User"; firstName: string; lastName: string };
          }>;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type ExpenseReportQueryVariables = Exact<{
  reportId: Scalars["Int"]["input"];
}>;

export type ExpenseReportQuery = {
  __typename?: "Query";
  expenseReport:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryExpenseReportSuccess";
        data: {
          __typename?: "ExpenseReport";
          id: number;
          createdAt: any;
          displayStatus: string;
          displayTotalDollarAmount: string;
          employerNotes?: string | null;
          isInstantReimbursed: boolean;
          notes?: string | null;
          status: ExpenseReportStatus;
          statusIconUrl: string;
          title: string;
          updatedAt: any;
          displayPayoutMethod?: string | null;
          isAutoApproved: boolean;
          designatedApprover?: {
            __typename?: "PublicUser";
            displayName: string;
          } | null;
          expenses: Array<{
            __typename?: "Expense";
            amount: number;
            expenseCategoryGLId?: number | null;
            attendeeEmails: Array<string>;
            createdAt: any;
            transactionDate: any;
            id: number;
            merchantName: string;
            notes?: string | null;
            receiptFileUrl?: string | null;
            reportId: number;
            status: ExpenseStatus;
            transactionCategoryIconUrl: string;
            transactionId?: number | null;
            updatedAt: any;
            expenseCategory?: {
              __typename?: "ExpenseCategoryGLPairing";
              id: number;
              categoryName: string;
            } | null;
            report: {
              __typename?: "ExpenseReport";
              id: number;
              title: string;
              status: ExpenseReportStatus;
              displayStatus: string;
              isAutoApproved: boolean;
              displayTotalDollarAmount: string;
              updatedAt: any;
              approvedOrRejectedBy?: {
                __typename?: "PublicUser";
                displayName: string;
              } | null;
            };
            customFieldEntries: Array<{
              __typename?: "ExpenseCustomFieldEntry";
              customFieldEntityId: number;
              rawValue?: string | null;
              booleanValue?: boolean | null;
              customFieldListOptionId?: number | null;
              type: CustomFieldType;
              customFieldEntity: {
                __typename?: "CustomFieldEntity";
                name: string;
                listOptions?: Array<{
                  __typename?: "CustomFieldListOption";
                  id: number;
                  name: string;
                  value: string;
                }> | null;
              };
            }>;
          }>;
          user: { __typename?: "User"; firstName: string; lastName: string };
        };
      }
    | { __typename?: "ValidationError" };
};

export type OrganizationQueryVariables = Exact<{ [key: string]: never }>;

export type OrganizationQuery = {
  __typename?: "Query";
  organization:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryOrganizationSuccess";
        data: { __typename?: "Organization"; cardApplicationPageUrl: string };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type GetDebitTransactionsQueryVariables = Exact<{
  status?: InputMaybe<Array<TransactionStatus> | TransactionStatus>;
  merchantName?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Array<TransactionType> | TransactionType>;
}>;

export type GetDebitTransactionsQuery = {
  __typename?: "Query";
  transactions:
    | { __typename?: "BaseError" }
    | {
        __typename: "QueryTransactionsSuccess";
        data: {
          __typename?: "Transactions";
          hasMore: boolean;
          nextPageOffset?: number | null;
          allTransactions: Array<
            | { __typename?: "PaymentTransaction" }
            | {
                __typename?: "Transaction";
                displayTitle: string;
                displayDollarAmount: string;
                transactedAt: any;
                id: number;
                amountInDollars: number;
                expenseCategoryGLId?: number | null;
                type: TransactionType;
                latestExpense?: {
                  __typename?: "Expense";
                  id: number;
                  status: ExpenseStatus;
                  reportId: number;
                  updatedAt: any;
                  report: { __typename?: "ExpenseReport"; title: string };
                } | null;
                latestStipendExpense?: {
                  __typename?: "StipendExpense";
                  stipendExpenseId: string;
                  status: StipendExpenseStatus;
                  stipendName: string;
                  createdAt: any;
                } | null;
              }
          >;
        };
      }
    | { __typename?: "ValidationError" };
};

export type UpdateEmployeeMutationVariables = Exact<{
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  departmentId: Scalars["Int"]["input"];
  managerEmployeeProfileId?: InputMaybe<Scalars["String"]["input"]>;
  userId: Scalars["String"]["input"];
  roles: Array<UserRole> | UserRole;
}>;

export type UpdateEmployeeMutation = {
  __typename?: "Mutation";
  updateEmployee:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationUpdateEmployeeSuccess";
        data: { __typename?: "User"; userId: string };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type AdminUpsertDepartmentMutationVariables = Exact<{
  isShown?: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["String"]["input"];
  uuid: Scalars["String"]["input"];
}>;

export type AdminUpsertDepartmentMutation = {
  __typename?: "Mutation";
  adminUpsertDepartment:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationAdminUpsertDepartmentSuccess";
        data: { __typename?: "Department"; id: number };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type UpdateEmployeesToDepartmentMutationVariables = Exact<{
  departmentId: Scalars["Int"]["input"];
  userIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type UpdateEmployeesToDepartmentMutation = {
  __typename?: "Mutation";
  updateEmployeesToDepartment:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationUpdateEmployeesToDepartmentSuccess";
        data: boolean;
      }
    | { __typename?: "ValidationError" };
};

export type AdminUpsertExpenseCategoryGlPairingMutationVariables = Exact<{
  categoryName: Scalars["String"]["input"];
  glAccount: Scalars["String"]["input"];
  isShown: Scalars["Boolean"]["input"];
  uuid: Scalars["String"]["input"];
}>;

export type AdminUpsertExpenseCategoryGlPairingMutation = {
  __typename?: "Mutation";
  adminUpsertExpenseCategoryGLPairing:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationAdminUpsertExpenseCategoryGLPairingSuccess";
        data: { __typename?: "ExpenseCategoryGLPairing"; id: number };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type UpsertPolicyMutationVariables = Exact<{
  uuid?: InputMaybe<Scalars["String"]["input"]>;
  policy: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  departmentIds?: InputMaybe<
    Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
  >;
}>;

export type UpsertPolicyMutation = {
  __typename?: "Mutation";
  upsertPolicy:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationUpsertPolicySuccess";
        data: { __typename?: "ExpensePolicy"; id: number };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type InviteEmployeeMutationVariables = Exact<{
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  workEmail: Scalars["String"]["input"];
  departmentId: Scalars["Int"]["input"];
  managerEmployeeProfileId?: InputMaybe<Scalars["String"]["input"]>;
  roles: Array<UserRole> | UserRole;
}>;

export type InviteEmployeeMutation = {
  __typename?: "Mutation";
  inviteEmployee:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationInviteEmployeeSuccess";
        data: { __typename?: "User"; userId: string };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type AwxCreateAndAuthorizeAccountMutationVariables = Exact<{
  codeChallenge: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
}>;

export type AwxCreateAndAuthorizeAccountMutation = {
  __typename?: "Mutation";
  awxCreateAndAuthorizeAccount:
    | { __typename?: "BaseError" }
    | {
        __typename?: "MutationAwxCreateAndAuthorizeAccountSuccess";
        data: {
          __typename?: "AwxAuthorizeConnectedAccount";
          authorizationCode: string;
        };
      }
    | { __typename?: "ValidationError" };
};

export type AwxAuthorizeBeneficiaryAccountMutationVariables = Exact<{
  codeChallenge: Scalars["String"]["input"];
}>;

export type AwxAuthorizeBeneficiaryAccountMutation = {
  __typename?: "Mutation";
  awxAuthorizeBeneficiaryAccount:
    | { __typename?: "BaseError" }
    | {
        __typename?: "MutationAwxAuthorizeBeneficiaryAccountSuccess";
        data: {
          __typename?: "AwxAuthorizeBeneficiaryAccount";
          authorizationCode: string;
        };
      }
    | { __typename?: "ValidationError" };
};

export type ConnectLinkedBankAccountMutationVariables = Exact<{
  publicToken: Scalars["String"]["input"];
  institutionId: Scalars["String"]["input"];
  institutionName: Scalars["String"]["input"];
  accountId: Scalars["String"]["input"];
  accountName: Scalars["String"]["input"];
  accountMask: Scalars["String"]["input"];
  signatoryEmail: Scalars["String"]["input"];
}>;

export type ConnectLinkedBankAccountMutation = {
  __typename?: "Mutation";
  awxConnectLinkedAccount:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationAwxConnectLinkedAccountSuccess";
        data: {
          __typename?: "LinkedAccount";
          awxLinkedAccount?: {
            __typename?: "AwxLinkedAccount";
            id: string;
            status: AwxLinkedAccountStatus;
          } | null;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type UpsertAwxBeneficiaryAccountMutationVariables = Exact<{
  input: UpsertBeneficiaryInput;
}>;

export type UpsertAwxBeneficiaryAccountMutation = {
  __typename?: "Mutation";
  upsertAwxBeneficiaryAccount:
    | { __typename?: "BaseError" }
    | {
        __typename?: "MutationUpsertAwxBeneficiaryAccountSuccess";
        data: {
          __typename?: "Beneficiary";
          nickname?: string | null;
          beneficiaryId: string;
          beneficiary: {
            __typename?: "BeneficiaryDetails";
            bankDetails: {
              __typename?: "BankDetails";
              accountName: string;
              accountNumberLastFour?: string | null;
              bankCountryCode: string;
              localClearingSystem?: string | null;
            };
          };
        };
      }
    | { __typename?: "ValidationError" };
};

export type SuspendLinkedAccountMutationVariables = Exact<{
  [key: string]: never;
}>;

export type SuspendLinkedAccountMutation = {
  __typename?: "Mutation";
  suspendLinkedAccount:
    | { __typename?: "BaseError" }
    | { __typename?: "MutationSuspendLinkedAccountSuccess"; data: boolean }
    | { __typename?: "ValidationError" };
};

export type DeleteBeneficiaryMutationVariables = Exact<{
  [key: string]: never;
}>;

export type DeleteBeneficiaryMutation = {
  __typename?: "Mutation";
  deleteAwxBeneficiaryAccount:
    | { __typename?: "BaseError" }
    | {
        __typename?: "MutationDeleteAwxBeneficiaryAccountSuccess";
        data: boolean;
      }
    | { __typename?: "ValidationError" };
};

export type RegisterNotifyMeForFeatureMutationVariables = Exact<{
  feature: UserFeatureNotification;
}>;

export type RegisterNotifyMeForFeatureMutation = {
  __typename?: "Mutation";
  registerNotifyMeForFeature:
    | { __typename?: "BaseError" }
    | {
        __typename?: "MutationRegisterNotifyMeForFeatureSuccess";
        data: boolean;
      }
    | { __typename?: "ValidationError" };
};

export type TestExpensePolicyMutationVariables = Exact<{
  input: TestExpensePolicyInput;
}>;

export type TestExpensePolicyMutation = {
  __typename?: "Mutation";
  testExpensePolicy:
    | { __typename?: "BaseError" }
    | {
        __typename?: "MutationTestExpensePolicySuccess";
        data: {
          __typename: "TestExpensePolicyResult";
          isAutoApproved: boolean;
          reason?: string | null;
        };
      }
    | { __typename?: "ValidationError" };
};

export type SubmitFeedbackMutationVariables = Exact<{
  feedback: Scalars["String"]["input"];
}>;

export type SubmitFeedbackMutation = {
  __typename?: "Mutation";
  submitFeedback:
    | { __typename?: "BaseError"; message: string }
    | { __typename?: "MutationSubmitFeedbackSuccess"; data: boolean }
    | { __typename?: "ValidationError"; message: string };
};

export type TerminateEmployeeProfileMutationVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type TerminateEmployeeProfileMutation = {
  __typename?: "Mutation";
  terminateEmployeeProfile:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationTerminateEmployeeProfileSuccess";
        data: {
          __typename?: "User";
          employee?: {
            __typename?: "EmployeeProfile";
            status: EmployeeProfileStatus;
            displayStatus: string;
            employmentStartDate?: any | null;
            workEmail: string;
            manager?: {
              __typename?: "PublicUser";
              userId: string;
              firstName: string;
              lastName: string;
              employee?: {
                __typename?: "PublicEmployeeProfile";
                employeeId: string;
              } | null;
            } | null;
            department: { __typename?: "Department"; name: string; id: number };
          } | null;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type UpdateCurrentUserEmployeeDelegatesMutationVariables = Exact<{
  delegateEmployeeProfileIds:
    | Array<Scalars["String"]["input"]>
    | Scalars["String"]["input"];
}>;

export type UpdateCurrentUserEmployeeDelegatesMutation = {
  __typename?: "Mutation";
  updateCurrentUserEmployeeDelegates:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationUpdateCurrentUserEmployeeDelegatesSuccess";
        data: {
          __typename?: "User";
          employee?: {
            __typename?: "EmployeeProfile";
            delegateUsers: Array<{
              __typename?: "PublicUser";
              userId: string;
              firstName: string;
              lastName: string;
              displayName: string;
              employee?: {
                __typename?: "PublicEmployeeProfile";
                employeeId: string;
              } | null;
            }>;
            impersonatableDelegateUsers: Array<{
              __typename?: "PublicUser";
              userId: string;
              firstName: string;
              lastName: string;
              employee?: {
                __typename?: "PublicEmployeeProfile";
                employeeId: string;
              } | null;
            }>;
          } | null;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type UpdateDelegateTransactionAccessMutationVariables = Exact<{
  toggleDelegateTransactionAccess: Scalars["Boolean"]["input"];
}>;

export type UpdateDelegateTransactionAccessMutation = {
  __typename?: "Mutation";
  updateDelegateTransactionAccess:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationUpdateDelegateTransactionAccessSuccess";
        data: boolean;
      }
    | { __typename?: "ValidationError"; message: string };
};

export type UpsertCustomFieldListOptionMutationVariables = Exact<{
  input: CustomFieldListOptionInput;
}>;

export type UpsertCustomFieldListOptionMutation = {
  __typename?: "Mutation";
  upsertCustomFieldListOption:
    | { __typename?: "BaseError" }
    | {
        __typename?: "MutationUpsertCustomFieldListOptionSuccess";
        data: {
          __typename?: "CustomFieldListOption";
          createdAt: any;
          customFieldEntityId: number;
          id: number;
          isDeleted: boolean;
          name: string;
          parentFieldOptionUuid?: string | null;
          updatedAt: any;
          uuid: string;
          value: string;
        };
      }
    | { __typename?: "ValidationError" };
};

export type UpsertCustomFieldMutationVariables = Exact<{
  input: CustomFieldEntityInput;
}>;

export type UpsertCustomFieldMutation = {
  __typename?: "Mutation";
  upsertCustomField:
    | { __typename?: "BaseError" }
    | {
        __typename?: "MutationUpsertCustomFieldSuccess";
        data: { __typename?: "CustomFieldEntity"; createdAt: any };
      }
    | { __typename?: "ValidationError" };
};

export type RecentExpenseActivitiesQueryVariables = Exact<{
  employeeId: Scalars["String"]["input"];
}>;

export type RecentExpenseActivitiesQuery = {
  __typename?: "Query";
  recentExpenseActivities:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryRecentExpenseActivitiesSuccess";
        data: Array<
          | {
              __typename?: "Expense";
              amount: number;
              transactionCategoryIconUrl: string;
              merchantName: string;
              transactionDate: any;
            }
          | {
              __typename?: "StipendExpense";
              amount: number;
              transactionCategoryIconUrl: string;
              stipendName: string;
              transactionDate: any;
            }
        >;
      }
    | { __typename?: "ValidationError"; message: string };
};

export type AdminExpenseCategoriesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminExpenseCategoriesQuery = {
  __typename?: "Query";
  adminExpenseCategories?:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryAdminExpenseCategoriesSuccess";
        data: {
          __typename?: "ExpenseCategoryGLPairings";
          categories: Array<{
            __typename?: "ExpenseCategoryGLPairing";
            id: number;
            categoryName: string;
            isShown: boolean;
            glAccount?: string | null;
            uuid: string;
            updatedAt: any;
            createdAt: any;
          }>;
        };
      }
    | { __typename?: "ValidationError"; message: string }
    | null;
};

export type VisibleExpenseCategoriesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type VisibleExpenseCategoriesQuery = {
  __typename?: "Query";
  visibleExpenseCategories?:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryVisibleExpenseCategoriesSuccess";
        data: {
          __typename?: "ExpenseCategoryGLPairings";
          categories: Array<{
            __typename?: "ExpenseCategoryGLPairing";
            id: number;
            categoryName: string;
            uuid: string;
          }>;
        };
      }
    | { __typename?: "ValidationError"; message: string }
    | null;
};

export type ExpensePoliciesQueryVariables = Exact<{ [key: string]: never }>;

export type ExpensePoliciesQuery = {
  __typename?: "Query";
  expensePolicies?:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryExpensePoliciesSuccess";
        data: {
          __typename?: "ExpensePolicies";
          policies: Array<{
            __typename?: "ExpensePolicy";
            id: number;
            name: string;
            uuid: string;
            policy: string;
            isActive: boolean;
            departmentIds: Array<number>;
            departments: Array<{
              __typename?: "Department";
              name: string;
              id: number;
              uuid: string;
            }>;
          }>;
        };
      }
    | { __typename?: "ValidationError"; message: string }
    | null;
};

export type OrganizationUsersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  departmentIds?: InputMaybe<
    Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
  >;
  exceptUserIds?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
}>;

export type OrganizationUsersQuery = {
  __typename?: "Query";
  organizationUsers:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryOrganizationUsersSuccess";
        data: {
          __typename?: "Users";
          hasMore: boolean;
          nextPageOffset?: number | null;
          users: Array<{
            __typename?: "User";
            userId: string;
            displayName: string;
            employeeDisplayRole: string;
            employee?: {
              __typename?: "EmployeeProfile";
              employeeId: string;
              workEmail: string;
              status: EmployeeProfileStatus;
              displayStatus: string;
              department: { __typename?: "Department"; name: string };
              manager?: {
                __typename?: "PublicUser";
                firstName: string;
                lastName: string;
                displayName: string;
              } | null;
            } | null;
          }>;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type OrganizationUserQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type OrganizationUserQuery = {
  __typename?: "Query";
  organizationUser:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryOrganizationUserSuccess";
        data: {
          __typename?: "User";
          displayName: string;
          firstName: string;
          lastName: string;
          employeeDisplayRole: string;
          roles: Array<UserRole>;
          employee?: {
            __typename?: "EmployeeProfile";
            status: EmployeeProfileStatus;
            displayStatus: string;
            employmentStartDate?: any | null;
            workEmail: string;
            manager?: {
              __typename?: "PublicUser";
              userId: string;
              firstName: string;
              lastName: string;
              employee?: {
                __typename?: "PublicEmployeeProfile";
                employeeId: string;
              } | null;
            } | null;
            department: { __typename?: "Department"; name: string; id: number };
          } | null;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type AdminAwxOrganizationStateQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminAwxOrganizationStateQuery = {
  __typename?: "Query";
  awxOrganizationState?:
    | { __typename?: "BaseError" }
    | {
        __typename?: "QueryAwxOrganizationStateSuccess";
        data: {
          __typename?: "AwxOrganizationState";
          connectedAccountId: string;
          connectedAccountStatus?: AwxConnectedAccountStatus | null;
          createdAt: any;
          linkedAccountId?: string | null;
          linkedAccountStatus?: AwxLinkedAccountStatus | null;
          organizationId: string;
          rfiStatus?: AwxRfiStatus | null;
          isEligibleToAddBeneficiary: boolean;
          updatedAt: any;
        };
      }
    | { __typename?: "ValidationError" }
    | null;
};

export type AchPlaidAuthLinkTokenQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AchPlaidAuthLinkTokenQuery = {
  __typename?: "Query";
  achAuthLinkToken:
    | { __typename?: "BaseError"; message: string }
    | { __typename?: "QueryAchAuthLinkTokenSuccess"; data: string }
    | { __typename?: "ValidationError"; message: string };
};

export type AdminDepartmentsQueryVariables = Exact<{ [key: string]: never }>;

export type AdminDepartmentsQuery = {
  __typename?: "Query";
  departments?:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryDepartmentsSuccess";
        data: {
          __typename?: "Departments";
          departments: Array<{
            __typename?: "Department";
            name: string;
            id: number;
            displaySpendThisMonth: string;
            displaySubtitle: string;
            uuid: string;
          }>;
        };
      }
    | { __typename?: "ValidationError"; message: string }
    | null;
};

export type ConnectedLinkedAccountQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ConnectedLinkedAccountQuery = {
  __typename?: "Query";
  linkedAccount:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryLinkedAccountSuccess";
        data: {
          __typename?: "LinkedAccount";
          institutionName?: string | null;
          awxLinkedAccount?: {
            __typename?: "AwxLinkedAccount";
            status: AwxLinkedAccountStatus;
            usBank?: {
              __typename?: "Bank";
              accountName?: string | null;
              accountNumberLastFour?: string | null;
            } | null;
          } | null;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type BeneficiaryQueryVariables = Exact<{ [key: string]: never }>;

export type BeneficiaryQuery = {
  __typename?: "Query";
  beneficiary?:
    | { __typename?: "BaseError" }
    | {
        __typename?: "QueryBeneficiarySuccess";
        data: {
          __typename?: "Beneficiary";
          nickname?: string | null;
          beneficiary: {
            __typename?: "BeneficiaryDetails";
            bankDetails: {
              __typename?: "BankDetails";
              accountName: string;
              accountNumberLastFour?: string | null;
              bankCountryCode: string;
              localClearingSystem?: string | null;
            };
          };
        };
      }
    | { __typename?: "ValidationError" }
    | null;
};

export type ActiveEmployeeProfileRecommendationsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ActiveEmployeeProfileRecommendationsQuery = {
  __typename?: "Query";
  activeEmployeeProfileRecommendations:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryActiveEmployeeProfileRecommendationsSuccess";
        data: {
          __typename?: "PublicEmployees";
          employees: Array<{
            __typename?: "PublicEmployee";
            id: string;
            lastName: string;
            firstName: string;
            workEmail: string;
          }>;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type CustomFieldsQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<Array<CustomFieldEntityState> | CustomFieldEntityState>;
}>;

export type CustomFieldsQuery = {
  __typename?: "Query";
  visibleCustomFields:
    | { __typename?: "BaseError" }
    | {
        __typename?: "QueryVisibleCustomFieldsSuccess";
        data: {
          __typename?: "CustomFieldEntities";
          customFields: Array<{
            __typename?: "CustomFieldEntity";
            createdAt: any;
            id: number;
            name: string;
            organizationId: string;
            parentEntityUuid?: string | null;
            state: string;
            type: CustomFieldType;
            updatedAt: any;
            uuid: string;
            listOptions?: Array<{
              __typename?: "CustomFieldListOption";
              createdAt: any;
              customFieldEntityId: number;
              id: number;
              isDeleted: boolean;
              name: string;
              parentFieldOptionUuid?: string | null;
              updatedAt: any;
              uuid: string;
              value: string;
            }> | null;
          }>;
        };
      }
    | { __typename?: "ValidationError" };
};

export type CustomFieldListOptionsQueryVariables = Exact<{
  customFieldEntityId: Scalars["Int"]["input"];
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  parentFieldOptionUuid?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CustomFieldListOptionsQuery = {
  __typename?: "Query";
  customFieldVisibleListOptions:
    | { __typename?: "BaseError" }
    | {
        __typename?: "QueryCustomFieldVisibleListOptionsSuccess";
        data: {
          __typename?: "CustomFieldListOptions";
          listOptions: Array<{
            __typename?: "CustomFieldListOption";
            createdAt: any;
            customFieldEntityId: number;
            id: number;
            isDeleted: boolean;
            name: string;
            parentFieldOptionUuid?: string | null;
            updatedAt: any;
            uuid: string;
            value: string;
          }>;
        };
      }
    | { __typename?: "ValidationError" };
};

export type AdminCustomFieldsQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AdminCustomFieldsQuery = {
  __typename?: "Query";
  adminCustomFields:
    | { __typename?: "BaseError" }
    | {
        __typename?: "QueryAdminCustomFieldsSuccess";
        data: {
          __typename?: "CustomFieldEntities";
          customFields: Array<{
            __typename?: "CustomFieldEntity";
            createdAt: any;
            id: number;
            name: string;
            organizationId: string;
            parentEntityUuid?: string | null;
            state: string;
            type: CustomFieldType;
            updatedAt: any;
            uuid: string;
            listOptions?: Array<{
              __typename?: "CustomFieldListOption";
              createdAt: any;
              customFieldEntityId: number;
              id: number;
              isDeleted: boolean;
              name: string;
              parentFieldOptionUuid?: string | null;
              updatedAt: any;
              uuid: string;
              value: string;
            }> | null;
          }>;
        };
      }
    | { __typename?: "ValidationError" };
};

export type AdminCustomFieldListOptionsQueryVariables = Exact<{
  customFieldEntityId: Scalars["Int"]["input"];
  searchText?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AdminCustomFieldListOptionsQuery = {
  __typename?: "Query";
  adminCustomFieldListOptions:
    | { __typename?: "BaseError" }
    | {
        __typename?: "QueryAdminCustomFieldListOptionsSuccess";
        data: {
          __typename?: "CustomFieldListOptions";
          listOptions: Array<{
            __typename?: "CustomFieldListOption";
            createdAt: any;
            customFieldEntityId: number;
            id: number;
            isDeleted: boolean;
            name: string;
            parentFieldOptionUuid?: string | null;
            updatedAt: any;
            uuid: string;
            value: string;
          }>;
        };
      }
    | { __typename?: "ValidationError" };
};

export type ProcessExpenseReportDownloadAndGetUrlMutationVariables = Exact<{
  filters?: InputMaybe<AdminExpenseReportFilterInput>;
}>;

export type ProcessExpenseReportDownloadAndGetUrlMutation = {
  __typename?: "Mutation";
  processExpenseReportDownloadAndGetUrl:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationProcessExpenseReportDownloadAndGetUrlSuccess";
        data: string;
      }
    | { __typename?: "ValidationError"; message: string };
};

export type SubmitStipendExpenseMutationVariables = Exact<{
  stipendWalletId: Scalars["Int"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
  amount: Scalars["Float"]["input"];
  merchantName: Scalars["String"]["input"];
  transactionDate: Scalars["Date"]["input"];
  receiptFileData?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type SubmitStipendExpenseMutation = {
  __typename?: "Mutation";
  submitStipendExpenseV2:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationSubmitStipendExpenseV2Success";
        data:
          | { __typename?: "StipendExpensePolicyCheckerResult"; reason: string }
          | {
              __typename?: "SubmittedStipendExpenseResult";
              autoApprovalMetadata?: {
                __typename?: "StipendExpenseAutoApprovalMetadata";
                isAutoApproved: boolean;
                reason?: string | null;
              } | null;
              expense: {
                __typename?: "StipendExpense";
                stipendWalletId: number;
                stipendExpenseId: string;
              };
            };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type ApproveOrRejectStipendExpenseMutationVariables = Exact<{
  stipendExpenseId: Scalars["String"]["input"];
  isApproved: Scalars["Boolean"]["input"];
  employeeId: Scalars["String"]["input"];
  employerNotes?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ApproveOrRejectStipendExpenseMutation = {
  __typename?: "Mutation";
  approveOrRejectStipendExpense:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationApproveOrRejectStipendExpenseSuccess";
        data: {
          __typename?: "StipendExpense";
          stipendExpenseId: string;
          status: StipendExpenseStatus;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type CreateStipendRuleMutationVariables = Exact<{
  input: CreateStipendRuleInput;
}>;

export type CreateStipendRuleMutation = {
  __typename?: "Mutation";
  createStipendRule:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationCreateStipendRuleSuccess";
        data: { __typename?: "StipendDetail"; name: string };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type UpdateStipendRuleMutationVariables = Exact<{
  input: UpdateStipendRuleInput;
  stipendRuleId: Scalars["Int"]["input"];
}>;

export type UpdateStipendRuleMutation = {
  __typename?: "Mutation";
  updateStipendRule:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationUpdateStipendRuleSuccess";
        data: { __typename?: "StipendDetail"; name: string };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type ValidateStipendRuleMutationVariables = Exact<{
  input: CreateStipendRuleInput;
}>;

export type ValidateStipendRuleMutation = {
  __typename?: "Mutation";
  validateStipendRule:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "MutationValidateStipendRuleSuccess";
        data: {
          __typename?: "StipendRuleValidationResult";
          isValid: boolean;
          message?: string | null;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type StipendWalletsQueryVariables = Exact<{
  filters?: InputMaybe<StipendWalletsFilterInput>;
}>;

export type StipendWalletsQuery = {
  __typename?: "Query";
  stipendWallets:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryStipendWalletsSuccess";
        data: {
          __typename?: "StipendWallets";
          wallets: Array<{
            __typename?: "StipendWallet";
            id: number;
            createdAt: any;
            startsAt: any;
            expiresAt?: any | null;
            pendingBalance: number;
            remainingBalance: number;
            startingBalance: number;
            expenses: Array<{
              __typename?: "StipendExpense";
              stipendExpenseId: string;
              amount: number;
              transactionDate: any;
              createdAt: any;
              merchantName?: string | null;
              notes?: string | null;
              displayPayoutMethod?: string | null;
              status: StipendExpenseStatus;
              stipendName: string;
              stipendWalletId: number;
              receiptFileUrl?: string | null;
              isAutoApproved: boolean;
              employerNotes?: string | null;
              user: {
                __typename?: "User";
                firstName: string;
                lastName: string;
              };
              approvedOrRejectedBy?: {
                __typename?: "PublicUser";
                displayName: string;
              } | null;
              designatedApprover?: {
                __typename?: "PublicUser";
                displayName: string;
              } | null;
            }>;
            stipendDetail: {
              __typename?: "StipendDetail";
              category: StipendCategory;
              createdAt: any;
              cycleStartDate: any;
              cycleEndDate?: any | null;
              frequency: StipendRuleFrequency;
              id: number;
              isBalanceForwardable: boolean;
              isSingleUsage: boolean;
              longDetails?: string | null;
              isEnabled: boolean;
              name: string;
              terms?: string | null;
            };
          }>;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type StipendExpensesByViewQueryVariables = Exact<{
  stipendExpenseStatus?: InputMaybe<
    Array<StipendExpenseStatus> | StipendExpenseStatus
  >;
  offset: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
}>;

export type StipendExpensesByViewQuery = {
  __typename?: "Query";
  stipendExpensesByView:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryStipendExpensesByViewSuccess";
        data: {
          __typename?: "StipendExpenses";
          hasMore: boolean;
          nextPageOffset?: number | null;
          stipendExpenses: Array<{
            __typename?: "StipendExpense";
            stipendExpenseId: string;
            merchantName?: string | null;
            transactionDate: any;
            amount: number;
            receiptFileUrl?: string | null;
            stipendName: string;
            notes?: string | null;
            status: StipendExpenseStatus;
            employeeId: string;
            isAutoApproved: boolean;
            displayPayoutMethod?: string | null;
            designatedApprover?: {
              __typename?: "PublicUser";
              displayName: string;
            } | null;
            user: { __typename?: "User"; firstName: string; lastName: string };
          }>;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type StipendRulesQueryVariables = Exact<{
  filters?: InputMaybe<StipendRuleFilterInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
}>;

export type StipendRulesQuery = {
  __typename?: "Query";
  stipendRules:
    | { __typename?: "BaseError"; message: string }
    | {
        __typename?: "QueryStipendRulesSuccess";
        data: {
          __typename?: "StipendDetails";
          stipendRules: Array<{
            __typename?: "StipendDetail";
            id: number;
            departmentIds?: Array<number> | null;
            iconUrl: string;
            name: string;
            isEnabled: boolean;
            amountClaimed: number;
            numberOfClaims: number;
            amount: number;
            longDetails?: string | null;
            category: StipendCategory;
            frequency: StipendRuleFrequency;
            terms?: string | null;
            isBalanceForwardable: boolean;
            isSingleUsage: boolean;
            createdAt: any;
            startsAt: any;
            expiresAt?: any | null;
            departments?: Array<{
              __typename?: "Department";
              id: number;
              name: string;
            }> | null;
          }>;
        };
      }
    | { __typename?: "ValidationError"; message: string };
};

export type AdminSpendAnalyticsPerStipendQueryVariables = Exact<{
  createdAfter: Scalars["DateTime"]["input"];
  createdBefore: Scalars["DateTime"]["input"];
  stipendExpenseStatus?: InputMaybe<
    Array<StipendExpenseStatus> | StipendExpenseStatus
  >;
}>;

export type AdminSpendAnalyticsPerStipendQuery = {
  __typename?: "Query";
  adminSpendAnalyticsPerStipend:
    | { __typename?: "BaseError" }
    | {
        __typename?: "QueryAdminSpendAnalyticsPerStipendSuccess";
        data: Array<{
          __typename?: "StipendRuleSpendAnalytic";
          ruleId: number;
          stipendExpenseCount: number;
          totalExpenseAmount: number;
          stipendDetail: {
            __typename?: "StipendDetail";
            category: StipendCategory;
            createdAt: any;
            cycleEndDate?: any | null;
            cycleStartDate: any;
            frequency: StipendRuleFrequency;
            iconUrl: string;
            id: number;
            isBalanceForwardable: boolean;
            isSingleUsage: boolean;
            longDetails?: string | null;
            name: string;
            terms?: string | null;
          };
        }>;
      }
    | { __typename?: "ValidationError" };
};

export const EmployeeAttendeeRecommendationsDocument = gql`
  query EmployeeAttendeeRecommendations(
    $offset: Int
    $pageSize: Int
    $searchText: String
  ) {
    employeeAttendeeRecommendations(
      pagination: { offset: $offset, pageSize: $pageSize }
      searchText: $searchText
    ) {
      ... on QueryEmployeeAttendeeRecommendationsSuccess {
        data {
          employees {
            firstName
            lastName
            workEmail
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useEmployeeAttendeeRecommendationsQuery__
 *
 * To run a query within a React component, call `useEmployeeAttendeeRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeAttendeeRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeAttendeeRecommendationsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      pageSize: // value for 'pageSize'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useEmployeeAttendeeRecommendationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    EmployeeAttendeeRecommendationsQuery,
    EmployeeAttendeeRecommendationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EmployeeAttendeeRecommendationsQuery,
    EmployeeAttendeeRecommendationsQueryVariables
  >(EmployeeAttendeeRecommendationsDocument, options);
}
export function useEmployeeAttendeeRecommendationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EmployeeAttendeeRecommendationsQuery,
    EmployeeAttendeeRecommendationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EmployeeAttendeeRecommendationsQuery,
    EmployeeAttendeeRecommendationsQueryVariables
  >(EmployeeAttendeeRecommendationsDocument, options);
}
export function useEmployeeAttendeeRecommendationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EmployeeAttendeeRecommendationsQuery,
    EmployeeAttendeeRecommendationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EmployeeAttendeeRecommendationsQuery,
    EmployeeAttendeeRecommendationsQueryVariables
  >(EmployeeAttendeeRecommendationsDocument, options);
}
export type EmployeeAttendeeRecommendationsQueryHookResult = ReturnType<
  typeof useEmployeeAttendeeRecommendationsQuery
>;
export type EmployeeAttendeeRecommendationsLazyQueryHookResult = ReturnType<
  typeof useEmployeeAttendeeRecommendationsLazyQuery
>;
export type EmployeeAttendeeRecommendationsSuspenseQueryHookResult = ReturnType<
  typeof useEmployeeAttendeeRecommendationsSuspenseQuery
>;
export type EmployeeAttendeeRecommendationsQueryResult = Apollo.QueryResult<
  EmployeeAttendeeRecommendationsQuery,
  EmployeeAttendeeRecommendationsQueryVariables
>;
export const HealthCheckDocument = gql`
  query HealthCheck {
    healthCheck
  }
`;

/**
 * __useHealthCheckQuery__
 *
 * To run a query within a React component, call `useHealthCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHealthCheckQuery({
 *   variables: {
 *   },
 * });
 */
export function useHealthCheckQuery(
  baseOptions?: Apollo.QueryHookOptions<
    HealthCheckQuery,
    HealthCheckQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HealthCheckQuery, HealthCheckQueryVariables>(
    HealthCheckDocument,
    options,
  );
}
export function useHealthCheckLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HealthCheckQuery,
    HealthCheckQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HealthCheckQuery, HealthCheckQueryVariables>(
    HealthCheckDocument,
    options,
  );
}
export function useHealthCheckSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    HealthCheckQuery,
    HealthCheckQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<HealthCheckQuery, HealthCheckQueryVariables>(
    HealthCheckDocument,
    options,
  );
}
export type HealthCheckQueryHookResult = ReturnType<typeof useHealthCheckQuery>;
export type HealthCheckLazyQueryHookResult = ReturnType<
  typeof useHealthCheckLazyQuery
>;
export type HealthCheckSuspenseQueryHookResult = ReturnType<
  typeof useHealthCheckSuspenseQuery
>;
export type HealthCheckQueryResult = Apollo.QueryResult<
  HealthCheckQuery,
  HealthCheckQueryVariables
>;
export const AdminReportGraphMetricsDocument = gql`
  query AdminReportGraphMetrics(
    $computePrevious: Boolean
    $filters: AdminReportExpenseFilterInput
    $groupedBy: ExpenseReportAnalyticGroup!
    $interval: GraphAnalyticInterval!
    $groupByCustomFieldEntityId: Int
  ) {
    adminReportGraphMetrics(
      computePrevious: $computePrevious
      filters: $filters
      groupedBy: $groupedBy
      interval: $interval
      groupByCustomFieldEntityId: $groupByCustomFieldEntityId
    ) {
      ... on QueryAdminReportGraphMetricsSuccess {
        data {
          metrics {
            id
            groupedEntityName
            totalValue
            totalCount
            values {
              date
              value
              count
            }
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useAdminReportGraphMetricsQuery__
 *
 * To run a query within a React component, call `useAdminReportGraphMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminReportGraphMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminReportGraphMetricsQuery({
 *   variables: {
 *      computePrevious: // value for 'computePrevious'
 *      filters: // value for 'filters'
 *      groupedBy: // value for 'groupedBy'
 *      interval: // value for 'interval'
 *      groupByCustomFieldEntityId: // value for 'groupByCustomFieldEntityId'
 *   },
 * });
 */
export function useAdminReportGraphMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminReportGraphMetricsQuery,
    AdminReportGraphMetricsQueryVariables
  > &
    (
      | { variables: AdminReportGraphMetricsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminReportGraphMetricsQuery,
    AdminReportGraphMetricsQueryVariables
  >(AdminReportGraphMetricsDocument, options);
}
export function useAdminReportGraphMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminReportGraphMetricsQuery,
    AdminReportGraphMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminReportGraphMetricsQuery,
    AdminReportGraphMetricsQueryVariables
  >(AdminReportGraphMetricsDocument, options);
}
export function useAdminReportGraphMetricsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminReportGraphMetricsQuery,
    AdminReportGraphMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminReportGraphMetricsQuery,
    AdminReportGraphMetricsQueryVariables
  >(AdminReportGraphMetricsDocument, options);
}
export type AdminReportGraphMetricsQueryHookResult = ReturnType<
  typeof useAdminReportGraphMetricsQuery
>;
export type AdminReportGraphMetricsLazyQueryHookResult = ReturnType<
  typeof useAdminReportGraphMetricsLazyQuery
>;
export type AdminReportGraphMetricsSuspenseQueryHookResult = ReturnType<
  typeof useAdminReportGraphMetricsSuspenseQuery
>;
export type AdminReportGraphMetricsQueryResult = Apollo.QueryResult<
  AdminReportGraphMetricsQuery,
  AdminReportGraphMetricsQueryVariables
>;
export const AdminStipendGraphMetricsDocument = gql`
  query AdminStipendGraphMetrics(
    $computePrevious: Boolean
    $filters: AdminStipendExpenseFilterInput
    $groupedBy: StipendExpenseAnalyticGroup!
    $interval: GraphAnalyticInterval!
  ) {
    adminStipendGraphMetrics(
      computePrevious: $computePrevious
      filters: $filters
      groupedBy: $groupedBy
      interval: $interval
    ) {
      ... on QueryAdminStipendGraphMetricsSuccess {
        data {
          metrics {
            id
            groupedEntityName
            totalValue
            totalCount
            values {
              date
              value
              count
            }
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useAdminStipendGraphMetricsQuery__
 *
 * To run a query within a React component, call `useAdminStipendGraphMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminStipendGraphMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminStipendGraphMetricsQuery({
 *   variables: {
 *      computePrevious: // value for 'computePrevious'
 *      filters: // value for 'filters'
 *      groupedBy: // value for 'groupedBy'
 *      interval: // value for 'interval'
 *   },
 * });
 */
export function useAdminStipendGraphMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminStipendGraphMetricsQuery,
    AdminStipendGraphMetricsQueryVariables
  > &
    (
      | { variables: AdminStipendGraphMetricsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminStipendGraphMetricsQuery,
    AdminStipendGraphMetricsQueryVariables
  >(AdminStipendGraphMetricsDocument, options);
}
export function useAdminStipendGraphMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminStipendGraphMetricsQuery,
    AdminStipendGraphMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminStipendGraphMetricsQuery,
    AdminStipendGraphMetricsQueryVariables
  >(AdminStipendGraphMetricsDocument, options);
}
export function useAdminStipendGraphMetricsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminStipendGraphMetricsQuery,
    AdminStipendGraphMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminStipendGraphMetricsQuery,
    AdminStipendGraphMetricsQueryVariables
  >(AdminStipendGraphMetricsDocument, options);
}
export type AdminStipendGraphMetricsQueryHookResult = ReturnType<
  typeof useAdminStipendGraphMetricsQuery
>;
export type AdminStipendGraphMetricsLazyQueryHookResult = ReturnType<
  typeof useAdminStipendGraphMetricsLazyQuery
>;
export type AdminStipendGraphMetricsSuspenseQueryHookResult = ReturnType<
  typeof useAdminStipendGraphMetricsSuspenseQuery
>;
export type AdminStipendGraphMetricsQueryResult = Apollo.QueryResult<
  AdminStipendGraphMetricsQuery,
  AdminStipendGraphMetricsQueryVariables
>;
export const FilterOptionsDocument = gql`
  query FilterOptions(
    $categories: [FilterCategoryEnum!]!
    $customFieldEntityIds: [Int!]
    $pagination: OffsetPaginationInput
    $searchText: String
  ) {
    filterOptions(
      categories: $categories
      pagination: $pagination
      searchText: $searchText
      customFieldEntityIds: $customFieldEntityIds
    ) {
      ... on QueryFilterOptionsSuccess {
        data {
          options {
            category
            id
            displayTitle
            displaySubtitle
            iconUrl
            secondaryId
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useFilterOptionsQuery__
 *
 * To run a query within a React component, call `useFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterOptionsQuery({
 *   variables: {
 *      categories: // value for 'categories'
 *      customFieldEntityIds: // value for 'customFieldEntityIds'
 *      pagination: // value for 'pagination'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useFilterOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FilterOptionsQuery,
    FilterOptionsQueryVariables
  > &
    (
      | { variables: FilterOptionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FilterOptionsQuery, FilterOptionsQueryVariables>(
    FilterOptionsDocument,
    options,
  );
}
export function useFilterOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FilterOptionsQuery,
    FilterOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FilterOptionsQuery, FilterOptionsQueryVariables>(
    FilterOptionsDocument,
    options,
  );
}
export function useFilterOptionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FilterOptionsQuery,
    FilterOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FilterOptionsQuery,
    FilterOptionsQueryVariables
  >(FilterOptionsDocument, options);
}
export type FilterOptionsQueryHookResult = ReturnType<
  typeof useFilterOptionsQuery
>;
export type FilterOptionsLazyQueryHookResult = ReturnType<
  typeof useFilterOptionsLazyQuery
>;
export type FilterOptionsSuspenseQueryHookResult = ReturnType<
  typeof useFilterOptionsSuspenseQuery
>;
export type FilterOptionsQueryResult = Apollo.QueryResult<
  FilterOptionsQuery,
  FilterOptionsQueryVariables
>;
export const AdminOrganizationExpensesDocument = gql`
  query AdminOrganizationExpenses(
    $filters: AdminReportExpenseFilterInput
    $pagination: OffsetPaginationInput
  ) {
    adminOrganizationExpenses(filters: $filters, pagination: $pagination) {
      ... on QueryAdminOrganizationExpensesSuccess {
        data {
          expenses {
            amount
            merchantName
            paymentMethod
            report {
              title
              employerNotes
              approvedOrRejectedAt
              displayTotalDollarAmount
            }
            transactionCategoryIconUrl
            transactionDate
            expenseCategory {
              categoryName
            }
            notes
            receiptFileUrl
            status
            user {
              displayName
              employee {
                workEmail
                department {
                  name
                }
              }
            }
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useAdminOrganizationExpensesQuery__
 *
 * To run a query within a React component, call `useAdminOrganizationExpensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrganizationExpensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrganizationExpensesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAdminOrganizationExpensesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminOrganizationExpensesQuery,
    AdminOrganizationExpensesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminOrganizationExpensesQuery,
    AdminOrganizationExpensesQueryVariables
  >(AdminOrganizationExpensesDocument, options);
}
export function useAdminOrganizationExpensesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminOrganizationExpensesQuery,
    AdminOrganizationExpensesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminOrganizationExpensesQuery,
    AdminOrganizationExpensesQueryVariables
  >(AdminOrganizationExpensesDocument, options);
}
export function useAdminOrganizationExpensesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminOrganizationExpensesQuery,
    AdminOrganizationExpensesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminOrganizationExpensesQuery,
    AdminOrganizationExpensesQueryVariables
  >(AdminOrganizationExpensesDocument, options);
}
export type AdminOrganizationExpensesQueryHookResult = ReturnType<
  typeof useAdminOrganizationExpensesQuery
>;
export type AdminOrganizationExpensesLazyQueryHookResult = ReturnType<
  typeof useAdminOrganizationExpensesLazyQuery
>;
export type AdminOrganizationExpensesSuspenseQueryHookResult = ReturnType<
  typeof useAdminOrganizationExpensesSuspenseQuery
>;
export type AdminOrganizationExpensesQueryResult = Apollo.QueryResult<
  AdminOrganizationExpensesQuery,
  AdminOrganizationExpensesQueryVariables
>;
export const StipendExpensesByViewForReportingDocument = gql`
  query StipendExpensesByViewForReporting(
    $filters: AdminStipendExpenseFilterInput
    $pagination: OffsetPaginationInput
  ) {
    stipendExpensesByView(filters: $filters, pagination: $pagination) {
      ... on QueryStipendExpensesByViewSuccess {
        data {
          hasMore
          stipendExpenses {
            amount
            merchantName
            notes
            paymentMethod
            receiptFileUrl
            stipendIconUrl
            stipendName
            approvedOrRejectedAt
            stipendIconUrl
            approvedOrRejectedBy {
              displayName
            }
            transactionDate
            user {
              displayName
              employee {
                workEmail
                department {
                  name
                }
              }
            }
            status
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useStipendExpensesByViewForReportingQuery__
 *
 * To run a query within a React component, call `useStipendExpensesByViewForReportingQuery` and pass it any options that fit your needs.
 * When your component renders, `useStipendExpensesByViewForReportingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStipendExpensesByViewForReportingQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useStipendExpensesByViewForReportingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StipendExpensesByViewForReportingQuery,
    StipendExpensesByViewForReportingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    StipendExpensesByViewForReportingQuery,
    StipendExpensesByViewForReportingQueryVariables
  >(StipendExpensesByViewForReportingDocument, options);
}
export function useStipendExpensesByViewForReportingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StipendExpensesByViewForReportingQuery,
    StipendExpensesByViewForReportingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    StipendExpensesByViewForReportingQuery,
    StipendExpensesByViewForReportingQueryVariables
  >(StipendExpensesByViewForReportingDocument, options);
}
export function useStipendExpensesByViewForReportingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    StipendExpensesByViewForReportingQuery,
    StipendExpensesByViewForReportingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    StipendExpensesByViewForReportingQuery,
    StipendExpensesByViewForReportingQueryVariables
  >(StipendExpensesByViewForReportingDocument, options);
}
export type StipendExpensesByViewForReportingQueryHookResult = ReturnType<
  typeof useStipendExpensesByViewForReportingQuery
>;
export type StipendExpensesByViewForReportingLazyQueryHookResult = ReturnType<
  typeof useStipendExpensesByViewForReportingLazyQuery
>;
export type StipendExpensesByViewForReportingSuspenseQueryHookResult =
  ReturnType<typeof useStipendExpensesByViewForReportingSuspenseQuery>;
export type StipendExpensesByViewForReportingQueryResult = Apollo.QueryResult<
  StipendExpensesByViewForReportingQuery,
  StipendExpensesByViewForReportingQueryVariables
>;
export const InitiateAuthenticationDocument = gql`
  mutation InitiateAuthentication(
    $email: String!
    $redirectUri: String!
    $state: String
  ) {
    initiateAuthentication(
      email: $email
      redirectUri: $redirectUri
      state: $state
    ) {
      ... on MutationInitiateAuthenticationSuccess {
        data {
          authenticationUrl
          isOTPSent
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
export type InitiateAuthenticationMutationFn = Apollo.MutationFunction<
  InitiateAuthenticationMutation,
  InitiateAuthenticationMutationVariables
>;

/**
 * __useInitiateAuthenticationMutation__
 *
 * To run a mutation, you first call `useInitiateAuthenticationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateAuthenticationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateAuthenticationMutation, { data, loading, error }] = useInitiateAuthenticationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      redirectUri: // value for 'redirectUri'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useInitiateAuthenticationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InitiateAuthenticationMutation,
    InitiateAuthenticationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InitiateAuthenticationMutation,
    InitiateAuthenticationMutationVariables
  >(InitiateAuthenticationDocument, options);
}
export type InitiateAuthenticationMutationHookResult = ReturnType<
  typeof useInitiateAuthenticationMutation
>;
export type InitiateAuthenticationMutationResult =
  Apollo.MutationResult<InitiateAuthenticationMutation>;
export type InitiateAuthenticationMutationOptions = Apollo.BaseMutationOptions<
  InitiateAuthenticationMutation,
  InitiateAuthenticationMutationVariables
>;
export const VerifyAuthCodeDocument = gql`
  mutation VerifyAuthCode($code: String!) {
    verifyAuthCode(code: $code, source: web) {
      ... on MutationVerifyAuthCodeSuccess {
        data {
          accessToken
          refreshToken
          accessTokenExpiresAt
          refreshTokenExpiresAt
        }
      }
    }
  }
`;
export type VerifyAuthCodeMutationFn = Apollo.MutationFunction<
  VerifyAuthCodeMutation,
  VerifyAuthCodeMutationVariables
>;

/**
 * __useVerifyAuthCodeMutation__
 *
 * To run a mutation, you first call `useVerifyAuthCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAuthCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAuthCodeMutation, { data, loading, error }] = useVerifyAuthCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyAuthCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyAuthCodeMutation,
    VerifyAuthCodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    VerifyAuthCodeMutation,
    VerifyAuthCodeMutationVariables
  >(VerifyAuthCodeDocument, options);
}
export type VerifyAuthCodeMutationHookResult = ReturnType<
  typeof useVerifyAuthCodeMutation
>;
export type VerifyAuthCodeMutationResult =
  Apollo.MutationResult<VerifyAuthCodeMutation>;
export type VerifyAuthCodeMutationOptions = Apollo.BaseMutationOptions<
  VerifyAuthCodeMutation,
  VerifyAuthCodeMutationVariables
>;
export const VerifyOtpCodeDocument = gql`
  mutation VerifyOtpCode($email: String!, $code: String!) {
    verifyOTPCode(
      email: $email
      code: $code
      source: onboarding
      shouldUserExist: false
    ) {
      ... on MutationVerifyOTPCodeSuccess {
        data {
          accessToken
          accessTokenExpiresAt
          refreshToken
          refreshTokenExpiresAt
        }
      }
    }
  }
`;
export type VerifyOtpCodeMutationFn = Apollo.MutationFunction<
  VerifyOtpCodeMutation,
  VerifyOtpCodeMutationVariables
>;

/**
 * __useVerifyOtpCodeMutation__
 *
 * To run a mutation, you first call `useVerifyOtpCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyOtpCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyOtpCodeMutation, { data, loading, error }] = useVerifyOtpCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyOtpCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyOtpCodeMutation,
    VerifyOtpCodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    VerifyOtpCodeMutation,
    VerifyOtpCodeMutationVariables
  >(VerifyOtpCodeDocument, options);
}
export type VerifyOtpCodeMutationHookResult = ReturnType<
  typeof useVerifyOtpCodeMutation
>;
export type VerifyOtpCodeMutationResult =
  Apollo.MutationResult<VerifyOtpCodeMutation>;
export type VerifyOtpCodeMutationOptions = Apollo.BaseMutationOptions<
  VerifyOtpCodeMutation,
  VerifyOtpCodeMutationVariables
>;
export const RefreshAccessTokenDocument = gql`
  mutation RefreshAccessToken {
    refreshAccessToken {
      ... on MutationRefreshAccessTokenSuccess {
        data {
          accessToken
          accessTokenExpiresAt
          refreshToken
          refreshTokenExpiresAt
        }
      }
    }
  }
`;
export type RefreshAccessTokenMutationFn = Apollo.MutationFunction<
  RefreshAccessTokenMutation,
  RefreshAccessTokenMutationVariables
>;

/**
 * __useRefreshAccessTokenMutation__
 *
 * To run a mutation, you first call `useRefreshAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshAccessTokenMutation, { data, loading, error }] = useRefreshAccessTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshAccessTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefreshAccessTokenMutation,
    RefreshAccessTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RefreshAccessTokenMutation,
    RefreshAccessTokenMutationVariables
  >(RefreshAccessTokenDocument, options);
}
export type RefreshAccessTokenMutationHookResult = ReturnType<
  typeof useRefreshAccessTokenMutation
>;
export type RefreshAccessTokenMutationResult =
  Apollo.MutationResult<RefreshAccessTokenMutation>;
export type RefreshAccessTokenMutationOptions = Apollo.BaseMutationOptions<
  RefreshAccessTokenMutation,
  RefreshAccessTokenMutationVariables
>;
export const InvalidateRefreshTokenDocument = gql`
  mutation InvalidateRefreshToken {
    invalidateRefreshToken {
      __typename
    }
  }
`;
export type InvalidateRefreshTokenMutationFn = Apollo.MutationFunction<
  InvalidateRefreshTokenMutation,
  InvalidateRefreshTokenMutationVariables
>;

/**
 * __useInvalidateRefreshTokenMutation__
 *
 * To run a mutation, you first call `useInvalidateRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvalidateRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invalidateRefreshTokenMutation, { data, loading, error }] = useInvalidateRefreshTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useInvalidateRefreshTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InvalidateRefreshTokenMutation,
    InvalidateRefreshTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InvalidateRefreshTokenMutation,
    InvalidateRefreshTokenMutationVariables
  >(InvalidateRefreshTokenDocument, options);
}
export type InvalidateRefreshTokenMutationHookResult = ReturnType<
  typeof useInvalidateRefreshTokenMutation
>;
export type InvalidateRefreshTokenMutationResult =
  Apollo.MutationResult<InvalidateRefreshTokenMutation>;
export type InvalidateRefreshTokenMutationOptions = Apollo.BaseMutationOptions<
  InvalidateRefreshTokenMutation,
  InvalidateRefreshTokenMutationVariables
>;
export const AuthenticalUrlDocument = gql`
  query AuthenticalUrl(
    $redirectUri: String!
    $email: String
    $state: String
    $provider: AuthProvider
  ) {
    authenticationUrl(
      redirectUri: $redirectUri
      email: $email
      state: $state
      provider: $provider
    ) {
      ... on QueryAuthenticationUrlSuccess {
        data
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useAuthenticalUrlQuery__
 *
 * To run a query within a React component, call `useAuthenticalUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthenticalUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthenticalUrlQuery({
 *   variables: {
 *      redirectUri: // value for 'redirectUri'
 *      email: // value for 'email'
 *      state: // value for 'state'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useAuthenticalUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    AuthenticalUrlQuery,
    AuthenticalUrlQueryVariables
  > &
    (
      | { variables: AuthenticalUrlQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AuthenticalUrlQuery, AuthenticalUrlQueryVariables>(
    AuthenticalUrlDocument,
    options,
  );
}
export function useAuthenticalUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AuthenticalUrlQuery,
    AuthenticalUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AuthenticalUrlQuery, AuthenticalUrlQueryVariables>(
    AuthenticalUrlDocument,
    options,
  );
}
export function useAuthenticalUrlSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AuthenticalUrlQuery,
    AuthenticalUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AuthenticalUrlQuery,
    AuthenticalUrlQueryVariables
  >(AuthenticalUrlDocument, options);
}
export type AuthenticalUrlQueryHookResult = ReturnType<
  typeof useAuthenticalUrlQuery
>;
export type AuthenticalUrlLazyQueryHookResult = ReturnType<
  typeof useAuthenticalUrlLazyQuery
>;
export type AuthenticalUrlSuspenseQueryHookResult = ReturnType<
  typeof useAuthenticalUrlSuspenseQuery
>;
export type AuthenticalUrlQueryResult = Apollo.QueryResult<
  AuthenticalUrlQuery,
  AuthenticalUrlQueryVariables
>;
export const AccountDocument = gql`
  query Account {
    account {
      ... on QueryAccountSuccess {
        data {
          currentBalance
          creditLimit
          dueDateUtc
          dueAmount
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useAccountQuery__
 *
 * To run a query within a React component, call `useAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountQuery(
  baseOptions?: Apollo.QueryHookOptions<AccountQuery, AccountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AccountQuery, AccountQueryVariables>(
    AccountDocument,
    options,
  );
}
export function useAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccountQuery,
    AccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AccountQuery, AccountQueryVariables>(
    AccountDocument,
    options,
  );
}
export function useAccountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AccountQuery,
    AccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AccountQuery, AccountQueryVariables>(
    AccountDocument,
    options,
  );
}
export type AccountQueryHookResult = ReturnType<typeof useAccountQuery>;
export type AccountLazyQueryHookResult = ReturnType<typeof useAccountLazyQuery>;
export type AccountSuspenseQueryHookResult = ReturnType<
  typeof useAccountSuspenseQuery
>;
export type AccountQueryResult = Apollo.QueryResult<
  AccountQuery,
  AccountQueryVariables
>;
export const TotalPointsDocument = gql`
  query TotalPoints {
    totalPoints {
      ... on QueryTotalPointsSuccess {
        data
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useTotalPointsQuery__
 *
 * To run a query within a React component, call `useTotalPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalPointsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTotalPointsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TotalPointsQuery,
    TotalPointsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TotalPointsQuery, TotalPointsQueryVariables>(
    TotalPointsDocument,
    options,
  );
}
export function useTotalPointsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TotalPointsQuery,
    TotalPointsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TotalPointsQuery, TotalPointsQueryVariables>(
    TotalPointsDocument,
    options,
  );
}
export function useTotalPointsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TotalPointsQuery,
    TotalPointsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TotalPointsQuery, TotalPointsQueryVariables>(
    TotalPointsDocument,
    options,
  );
}
export type TotalPointsQueryHookResult = ReturnType<typeof useTotalPointsQuery>;
export type TotalPointsLazyQueryHookResult = ReturnType<
  typeof useTotalPointsLazyQuery
>;
export type TotalPointsSuspenseQueryHookResult = ReturnType<
  typeof useTotalPointsSuspenseQuery
>;
export type TotalPointsQueryResult = Apollo.QueryResult<
  TotalPointsQuery,
  TotalPointsQueryVariables
>;
export const CardArtDocument = gql`
  query CardArt {
    cardArt {
      ... on QueryCardArtSuccess {
        data {
          frontImageUrl
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useCardArtQuery__
 *
 * To run a query within a React component, call `useCardArtQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardArtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardArtQuery({
 *   variables: {
 *   },
 * });
 */
export function useCardArtQuery(
  baseOptions?: Apollo.QueryHookOptions<CardArtQuery, CardArtQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CardArtQuery, CardArtQueryVariables>(
    CardArtDocument,
    options,
  );
}
export function useCardArtLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CardArtQuery,
    CardArtQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CardArtQuery, CardArtQueryVariables>(
    CardArtDocument,
    options,
  );
}
export function useCardArtSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CardArtQuery,
    CardArtQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CardArtQuery, CardArtQueryVariables>(
    CardArtDocument,
    options,
  );
}
export type CardArtQueryHookResult = ReturnType<typeof useCardArtQuery>;
export type CardArtLazyQueryHookResult = ReturnType<typeof useCardArtLazyQuery>;
export type CardArtSuspenseQueryHookResult = ReturnType<
  typeof useCardArtSuspenseQuery
>;
export type CardArtQueryResult = Apollo.QueryResult<
  CardArtQuery,
  CardArtQueryVariables
>;
export const PrimaryCardDocument = gql`
  query PrimaryCard {
    primaryCard {
      ... on QueryPrimaryCardSuccess {
        data {
          last4Digits
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __usePrimaryCardQuery__
 *
 * To run a query within a React component, call `usePrimaryCardQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrimaryCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrimaryCardQuery({
 *   variables: {
 *   },
 * });
 */
export function usePrimaryCardQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PrimaryCardQuery,
    PrimaryCardQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PrimaryCardQuery, PrimaryCardQueryVariables>(
    PrimaryCardDocument,
    options,
  );
}
export function usePrimaryCardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PrimaryCardQuery,
    PrimaryCardQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PrimaryCardQuery, PrimaryCardQueryVariables>(
    PrimaryCardDocument,
    options,
  );
}
export function usePrimaryCardSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PrimaryCardQuery,
    PrimaryCardQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PrimaryCardQuery, PrimaryCardQueryVariables>(
    PrimaryCardDocument,
    options,
  );
}
export type PrimaryCardQueryHookResult = ReturnType<typeof usePrimaryCardQuery>;
export type PrimaryCardLazyQueryHookResult = ReturnType<
  typeof usePrimaryCardLazyQuery
>;
export type PrimaryCardSuspenseQueryHookResult = ReturnType<
  typeof usePrimaryCardSuspenseQuery
>;
export type PrimaryCardQueryResult = Apollo.QueryResult<
  PrimaryCardQuery,
  PrimaryCardQueryVariables
>;
export const TransactionsDocument = gql`
  query Transactions {
    transactions(pagination: { offset: 0, pageSize: 10 }) {
      ... on QueryTransactionsSuccess {
        data {
          allTransactions {
            ... on Transaction {
              displayTitle
              displayDollarAmount
              displayFlair
              transactedAt
              hypercardCategoryIconUrl
              creditIndicator
              transactionStatus: status
              transactionType: type
            }
            ... on PaymentTransaction {
              displayTitle
              paymentStatus: status
              paymentType: type
              displayDollarAmount
              displayFlair
              transactedAt
              hypercardCategoryIconUrl
            }
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useTransactionsQuery__
 *
 * To run a query within a React component, call `useTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransactionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TransactionsQuery,
    TransactionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TransactionsQuery, TransactionsQueryVariables>(
    TransactionsDocument,
    options,
  );
}
export function useTransactionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TransactionsQuery,
    TransactionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TransactionsQuery, TransactionsQueryVariables>(
    TransactionsDocument,
    options,
  );
}
export function useTransactionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TransactionsQuery,
    TransactionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TransactionsQuery, TransactionsQueryVariables>(
    TransactionsDocument,
    options,
  );
}
export type TransactionsQueryHookResult = ReturnType<
  typeof useTransactionsQuery
>;
export type TransactionsLazyQueryHookResult = ReturnType<
  typeof useTransactionsLazyQuery
>;
export type TransactionsSuspenseQueryHookResult = ReturnType<
  typeof useTransactionsSuspenseQuery
>;
export type TransactionsQueryResult = Apollo.QueryResult<
  TransactionsQuery,
  TransactionsQueryVariables
>;
export const OffersDocument = gql`
  query Offers($categories: [OfferCategory!]) {
    offers(categories: $categories) {
      ... on QueryOffersSuccess {
        data {
          offers {
            title
            details
            iconImageUrl
            isUsageLimitReached
            hypercardMerchant {
              logoImageUrl
            }
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useOffersQuery__
 *
 * To run a query within a React component, call `useOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffersQuery({
 *   variables: {
 *      categories: // value for 'categories'
 *   },
 * });
 */
export function useOffersQuery(
  baseOptions?: Apollo.QueryHookOptions<OffersQuery, OffersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OffersQuery, OffersQueryVariables>(
    OffersDocument,
    options,
  );
}
export function useOffersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OffersQuery, OffersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OffersQuery, OffersQueryVariables>(
    OffersDocument,
    options,
  );
}
export function useOffersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OffersQuery,
    OffersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<OffersQuery, OffersQueryVariables>(
    OffersDocument,
    options,
  );
}
export type OffersQueryHookResult = ReturnType<typeof useOffersQuery>;
export type OffersLazyQueryHookResult = ReturnType<typeof useOffersLazyQuery>;
export type OffersSuspenseQueryHookResult = ReturnType<
  typeof useOffersSuspenseQuery
>;
export type OffersQueryResult = Apollo.QueryResult<
  OffersQuery,
  OffersQueryVariables
>;
export const ReferralOfferDocument = gql`
  query ReferralOffer {
    referralOffer {
      ... on QueryReferralOfferSuccess {
        data {
          caption
          category
          details
          flair
          iconImageUrl
          isUsageLimitReached
          landingPageUrl
          longDetails
          maxUsageCount
          rewardRuleId
          shortRewardDescriptor
          terms
          title
          trigger
          usageCount
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useReferralOfferQuery__
 *
 * To run a query within a React component, call `useReferralOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralOfferQuery({
 *   variables: {
 *   },
 * });
 */
export function useReferralOfferQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ReferralOfferQuery,
    ReferralOfferQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReferralOfferQuery, ReferralOfferQueryVariables>(
    ReferralOfferDocument,
    options,
  );
}
export function useReferralOfferLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReferralOfferQuery,
    ReferralOfferQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReferralOfferQuery, ReferralOfferQueryVariables>(
    ReferralOfferDocument,
    options,
  );
}
export function useReferralOfferSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ReferralOfferQuery,
    ReferralOfferQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ReferralOfferQuery,
    ReferralOfferQueryVariables
  >(ReferralOfferDocument, options);
}
export type ReferralOfferQueryHookResult = ReturnType<
  typeof useReferralOfferQuery
>;
export type ReferralOfferLazyQueryHookResult = ReturnType<
  typeof useReferralOfferLazyQuery
>;
export type ReferralOfferSuspenseQueryHookResult = ReturnType<
  typeof useReferralOfferSuspenseQuery
>;
export type ReferralOfferQueryResult = Apollo.QueryResult<
  ReferralOfferQuery,
  ReferralOfferQueryVariables
>;
export const AdminReimbursementsTimeSavedInSecondsDocument = gql`
  query AdminReimbursementsTimeSavedInSeconds(
    $createdAfter: DateTime
    $createdBefore: DateTime
  ) {
    adminReimbursementsTimeSavedInSeconds(
      filters: { createdAfter: $createdAfter, createdBefore: $createdBefore }
    ) {
      ... on QueryAdminReimbursementsTimeSavedInSecondsSuccess {
        data
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useAdminReimbursementsTimeSavedInSecondsQuery__
 *
 * To run a query within a React component, call `useAdminReimbursementsTimeSavedInSecondsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminReimbursementsTimeSavedInSecondsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminReimbursementsTimeSavedInSecondsQuery({
 *   variables: {
 *      createdAfter: // value for 'createdAfter'
 *      createdBefore: // value for 'createdBefore'
 *   },
 * });
 */
export function useAdminReimbursementsTimeSavedInSecondsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminReimbursementsTimeSavedInSecondsQuery,
    AdminReimbursementsTimeSavedInSecondsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminReimbursementsTimeSavedInSecondsQuery,
    AdminReimbursementsTimeSavedInSecondsQueryVariables
  >(AdminReimbursementsTimeSavedInSecondsDocument, options);
}
export function useAdminReimbursementsTimeSavedInSecondsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminReimbursementsTimeSavedInSecondsQuery,
    AdminReimbursementsTimeSavedInSecondsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminReimbursementsTimeSavedInSecondsQuery,
    AdminReimbursementsTimeSavedInSecondsQueryVariables
  >(AdminReimbursementsTimeSavedInSecondsDocument, options);
}
export function useAdminReimbursementsTimeSavedInSecondsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminReimbursementsTimeSavedInSecondsQuery,
    AdminReimbursementsTimeSavedInSecondsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminReimbursementsTimeSavedInSecondsQuery,
    AdminReimbursementsTimeSavedInSecondsQueryVariables
  >(AdminReimbursementsTimeSavedInSecondsDocument, options);
}
export type AdminReimbursementsTimeSavedInSecondsQueryHookResult = ReturnType<
  typeof useAdminReimbursementsTimeSavedInSecondsQuery
>;
export type AdminReimbursementsTimeSavedInSecondsLazyQueryHookResult =
  ReturnType<typeof useAdminReimbursementsTimeSavedInSecondsLazyQuery>;
export type AdminReimbursementsTimeSavedInSecondsSuspenseQueryHookResult =
  ReturnType<typeof useAdminReimbursementsTimeSavedInSecondsSuspenseQuery>;
export type AdminReimbursementsTimeSavedInSecondsQueryResult =
  Apollo.QueryResult<
    AdminReimbursementsTimeSavedInSecondsQuery,
    AdminReimbursementsTimeSavedInSecondsQueryVariables
  >;
export const FeatureFlagsDocument = gql`
  query FeatureFlags($organizationId: String!) {
    organizationalFeatureFlags(organizationId: $organizationId) {
      ... on QueryOrganizationalFeatureFlagsSuccess {
        data {
          hypercardDelegatesShown
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useFeatureFlagsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FeatureFlagsQuery,
    FeatureFlagsQueryVariables
  > &
    (
      | { variables: FeatureFlagsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(
    FeatureFlagsDocument,
    options,
  );
}
export function useFeatureFlagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FeatureFlagsQuery,
    FeatureFlagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(
    FeatureFlagsDocument,
    options,
  );
}
export function useFeatureFlagsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FeatureFlagsQuery,
    FeatureFlagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(
    FeatureFlagsDocument,
    options,
  );
}
export type FeatureFlagsQueryHookResult = ReturnType<
  typeof useFeatureFlagsQuery
>;
export type FeatureFlagsLazyQueryHookResult = ReturnType<
  typeof useFeatureFlagsLazyQuery
>;
export type FeatureFlagsSuspenseQueryHookResult = ReturnType<
  typeof useFeatureFlagsSuspenseQuery
>;
export type FeatureFlagsQueryResult = Apollo.QueryResult<
  FeatureFlagsQuery,
  FeatureFlagsQueryVariables
>;
export const CurrentUserDocument = gql`
  query CurrentUser {
    currentUser {
      ... on QueryCurrentUserSuccess {
        data {
          firstName
          lastName
          displayName
          roles
          employeeDisplayRole
          userId
          employee {
            employeeId
            workEmail
            awxBeneficiaryId
            manager {
              firstName
              lastName
            }
            department {
              name
              id
            }
            delegateUsers {
              userId
              firstName
              lastName
              displayName
              employee {
                employeeId
                workEmail
              }
            }
            impersonatableDelegateUsers {
              userId
              displayName
              employee {
                employeeId
              }
            }
            employmentStartDate
            organization {
              organizationId
              name
              homePageCardImageUrl
              cardApplicationPageUrl
            }
          }
          cardholder {
            personalEmail
            phoneNumber
            residentialAddress {
              line1
              line2
              city
              postalCode
              state
            }
            delegateHasTransactionAccess
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CurrentUserQuery,
    CurrentUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(
    CurrentUserDocument,
    options,
  );
}
export function useCurrentUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CurrentUserQuery,
    CurrentUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(
    CurrentUserDocument,
    options,
  );
}
export function useCurrentUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CurrentUserQuery,
    CurrentUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(
    CurrentUserDocument,
    options,
  );
}
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<
  typeof useCurrentUserLazyQuery
>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<
  typeof useCurrentUserSuspenseQuery
>;
export type CurrentUserQueryResult = Apollo.QueryResult<
  CurrentUserQuery,
  CurrentUserQueryVariables
>;
export const CardholderDocument = gql`
  query Cardholder {
    cardholder {
      ... on QueryCardholderSuccess {
        data {
          cardholderId
          nameOnCard
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useCardholderQuery__
 *
 * To run a query within a React component, call `useCardholderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardholderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardholderQuery({
 *   variables: {
 *   },
 * });
 */
export function useCardholderQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CardholderQuery,
    CardholderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CardholderQuery, CardholderQueryVariables>(
    CardholderDocument,
    options,
  );
}
export function useCardholderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CardholderQuery,
    CardholderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CardholderQuery, CardholderQueryVariables>(
    CardholderDocument,
    options,
  );
}
export function useCardholderSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CardholderQuery,
    CardholderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CardholderQuery, CardholderQueryVariables>(
    CardholderDocument,
    options,
  );
}
export type CardholderQueryHookResult = ReturnType<typeof useCardholderQuery>;
export type CardholderLazyQueryHookResult = ReturnType<
  typeof useCardholderLazyQuery
>;
export type CardholderSuspenseQueryHookResult = ReturnType<
  typeof useCardholderSuspenseQuery
>;
export type CardholderQueryResult = Apollo.QueryResult<
  CardholderQuery,
  CardholderQueryVariables
>;
export const ActiveAutoPaymentDocument = gql`
  query ActiveAutoPayment {
    activeAutoPayment {
      ... on QueryActiveAutoPaymentSuccess {
        data {
          amount
          paymentDate
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useActiveAutoPaymentQuery__
 *
 * To run a query within a React component, call `useActiveAutoPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveAutoPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveAutoPaymentQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveAutoPaymentQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ActiveAutoPaymentQuery,
    ActiveAutoPaymentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ActiveAutoPaymentQuery,
    ActiveAutoPaymentQueryVariables
  >(ActiveAutoPaymentDocument, options);
}
export function useActiveAutoPaymentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActiveAutoPaymentQuery,
    ActiveAutoPaymentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ActiveAutoPaymentQuery,
    ActiveAutoPaymentQueryVariables
  >(ActiveAutoPaymentDocument, options);
}
export function useActiveAutoPaymentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ActiveAutoPaymentQuery,
    ActiveAutoPaymentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ActiveAutoPaymentQuery,
    ActiveAutoPaymentQueryVariables
  >(ActiveAutoPaymentDocument, options);
}
export type ActiveAutoPaymentQueryHookResult = ReturnType<
  typeof useActiveAutoPaymentQuery
>;
export type ActiveAutoPaymentLazyQueryHookResult = ReturnType<
  typeof useActiveAutoPaymentLazyQuery
>;
export type ActiveAutoPaymentSuspenseQueryHookResult = ReturnType<
  typeof useActiveAutoPaymentSuspenseQuery
>;
export type ActiveAutoPaymentQueryResult = Apollo.QueryResult<
  ActiveAutoPaymentQuery,
  ActiveAutoPaymentQueryVariables
>;
export const RemoveExpenseFromReportDocument = gql`
  mutation RemoveExpenseFromReport($expenseId: Int!, $reportId: Int!) {
    removeExpenseFromReport(expenseId: $expenseId, reportId: $reportId) {
      ... on MutationRemoveExpenseFromReportSuccess {
        data {
          id
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
export type RemoveExpenseFromReportMutationFn = Apollo.MutationFunction<
  RemoveExpenseFromReportMutation,
  RemoveExpenseFromReportMutationVariables
>;

/**
 * __useRemoveExpenseFromReportMutation__
 *
 * To run a mutation, you first call `useRemoveExpenseFromReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExpenseFromReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeExpenseFromReportMutation, { data, loading, error }] = useRemoveExpenseFromReportMutation({
 *   variables: {
 *      expenseId: // value for 'expenseId'
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useRemoveExpenseFromReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveExpenseFromReportMutation,
    RemoveExpenseFromReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveExpenseFromReportMutation,
    RemoveExpenseFromReportMutationVariables
  >(RemoveExpenseFromReportDocument, options);
}
export type RemoveExpenseFromReportMutationHookResult = ReturnType<
  typeof useRemoveExpenseFromReportMutation
>;
export type RemoveExpenseFromReportMutationResult =
  Apollo.MutationResult<RemoveExpenseFromReportMutation>;
export type RemoveExpenseFromReportMutationOptions = Apollo.BaseMutationOptions<
  RemoveExpenseFromReportMutation,
  RemoveExpenseFromReportMutationVariables
>;
export const UpsertExpenseReportDocument = gql`
  mutation UpsertExpenseReport(
    $reportId: Int!
    $title: String!
    $notes: String
  ) {
    upsertExpenseReport(
      reportId: $reportId
      input: { title: $title, notes: $notes }
    ) {
      ... on MutationUpsertExpenseReportSuccess {
        data {
          id
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
export type UpsertExpenseReportMutationFn = Apollo.MutationFunction<
  UpsertExpenseReportMutation,
  UpsertExpenseReportMutationVariables
>;

/**
 * __useUpsertExpenseReportMutation__
 *
 * To run a mutation, you first call `useUpsertExpenseReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertExpenseReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertExpenseReportMutation, { data, loading, error }] = useUpsertExpenseReportMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      title: // value for 'title'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpsertExpenseReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertExpenseReportMutation,
    UpsertExpenseReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertExpenseReportMutation,
    UpsertExpenseReportMutationVariables
  >(UpsertExpenseReportDocument, options);
}
export type UpsertExpenseReportMutationHookResult = ReturnType<
  typeof useUpsertExpenseReportMutation
>;
export type UpsertExpenseReportMutationResult =
  Apollo.MutationResult<UpsertExpenseReportMutation>;
export type UpsertExpenseReportMutationOptions = Apollo.BaseMutationOptions<
  UpsertExpenseReportMutation,
  UpsertExpenseReportMutationVariables
>;
export const SubmitDraftExpenseReportDocument = gql`
  mutation SubmitDraftExpenseReport(
    $reportId: Int!
    $skipPolicyCheck: Boolean!
  ) {
    submitDraftExpenseReport(id: $reportId, skipPolicyCheck: $skipPolicyCheck) {
      ... on MutationSubmitDraftExpenseReportSuccess {
        data {
          ... on SubmittedReportResult {
            autoApprovalMetadata {
              reason
            }
            report {
              isAutoApproved
              id
            }
          }
          ... on ReportPolicyCheckerResult {
            policyViolations {
              expenseId
              reason
            }
          }
        }
      }
      ... on BaseError {
        code
        message
      }
      ... on Error {
        code
        message
      }
    }
  }
`;
export type SubmitDraftExpenseReportMutationFn = Apollo.MutationFunction<
  SubmitDraftExpenseReportMutation,
  SubmitDraftExpenseReportMutationVariables
>;

/**
 * __useSubmitDraftExpenseReportMutation__
 *
 * To run a mutation, you first call `useSubmitDraftExpenseReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitDraftExpenseReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitDraftExpenseReportMutation, { data, loading, error }] = useSubmitDraftExpenseReportMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      skipPolicyCheck: // value for 'skipPolicyCheck'
 *   },
 * });
 */
export function useSubmitDraftExpenseReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitDraftExpenseReportMutation,
    SubmitDraftExpenseReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitDraftExpenseReportMutation,
    SubmitDraftExpenseReportMutationVariables
  >(SubmitDraftExpenseReportDocument, options);
}
export type SubmitDraftExpenseReportMutationHookResult = ReturnType<
  typeof useSubmitDraftExpenseReportMutation
>;
export type SubmitDraftExpenseReportMutationResult =
  Apollo.MutationResult<SubmitDraftExpenseReportMutation>;
export type SubmitDraftExpenseReportMutationOptions =
  Apollo.BaseMutationOptions<
    SubmitDraftExpenseReportMutation,
    SubmitDraftExpenseReportMutationVariables
  >;
export const CreateLeafReportDocument = gql`
  mutation CreateLeafReport($title: String!, $notes: String) {
    upsertExpenseReport(input: { title: $title, notes: $notes }) {
      ... on MutationUpsertExpenseReportSuccess {
        data {
          id
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
export type CreateLeafReportMutationFn = Apollo.MutationFunction<
  CreateLeafReportMutation,
  CreateLeafReportMutationVariables
>;

/**
 * __useCreateLeafReportMutation__
 *
 * To run a mutation, you first call `useCreateLeafReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeafReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeafReportMutation, { data, loading, error }] = useCreateLeafReportMutation({
 *   variables: {
 *      title: // value for 'title'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useCreateLeafReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateLeafReportMutation,
    CreateLeafReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateLeafReportMutation,
    CreateLeafReportMutationVariables
  >(CreateLeafReportDocument, options);
}
export type CreateLeafReportMutationHookResult = ReturnType<
  typeof useCreateLeafReportMutation
>;
export type CreateLeafReportMutationResult =
  Apollo.MutationResult<CreateLeafReportMutation>;
export type CreateLeafReportMutationOptions = Apollo.BaseMutationOptions<
  CreateLeafReportMutation,
  CreateLeafReportMutationVariables
>;
export const AddExpenseToReportDocument = gql`
  mutation AddExpenseToReport(
    $idempotencyKey: String!
    $reportId: Int!
    $notes: String
    $expenseCategoryGLId: Int
    $amount: Float!
    $merchantName: String!
    $receiptFileData: String
    $transactionDate: Date!
    $attendeeEmails: [String!]
    $transactionId: Int
    $customFieldEntries: [ExpenseCustomFieldEntryUpsertInput!]
  ) {
    addExpenseToReport(
      input: {
        idempotencyKey: $idempotencyKey
        amount: $amount
        expenseCategoryGLId: $expenseCategoryGLId
        merchantName: $merchantName
        notes: $notes
        transactionDate: $transactionDate
        transactionId: $transactionId
        attendeeEmails: $attendeeEmails
        customFieldEntries: $customFieldEntries
      }
      receiptFileData: $receiptFileData
      reportId: $reportId
    ) {
      ... on MutationAddExpenseToReportSuccess {
        data {
          id
          reportId
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
export type AddExpenseToReportMutationFn = Apollo.MutationFunction<
  AddExpenseToReportMutation,
  AddExpenseToReportMutationVariables
>;

/**
 * __useAddExpenseToReportMutation__
 *
 * To run a mutation, you first call `useAddExpenseToReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExpenseToReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExpenseToReportMutation, { data, loading, error }] = useAddExpenseToReportMutation({
 *   variables: {
 *      idempotencyKey: // value for 'idempotencyKey'
 *      reportId: // value for 'reportId'
 *      notes: // value for 'notes'
 *      expenseCategoryGLId: // value for 'expenseCategoryGLId'
 *      amount: // value for 'amount'
 *      merchantName: // value for 'merchantName'
 *      receiptFileData: // value for 'receiptFileData'
 *      transactionDate: // value for 'transactionDate'
 *      attendeeEmails: // value for 'attendeeEmails'
 *      transactionId: // value for 'transactionId'
 *      customFieldEntries: // value for 'customFieldEntries'
 *   },
 * });
 */
export function useAddExpenseToReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddExpenseToReportMutation,
    AddExpenseToReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddExpenseToReportMutation,
    AddExpenseToReportMutationVariables
  >(AddExpenseToReportDocument, options);
}
export type AddExpenseToReportMutationHookResult = ReturnType<
  typeof useAddExpenseToReportMutation
>;
export type AddExpenseToReportMutationResult =
  Apollo.MutationResult<AddExpenseToReportMutation>;
export type AddExpenseToReportMutationOptions = Apollo.BaseMutationOptions<
  AddExpenseToReportMutation,
  AddExpenseToReportMutationVariables
>;
export const ApproveOrRejectExpenseReportDocument = gql`
  mutation ApproveOrRejectExpenseReport(
    $approvedExpenseIds: [Int!]!
    $employeeId: String!
    $employerNotes: String
    $reportId: Int!
  ) {
    approveOrRejectExpenseReport(
      approvedExpenseIds: $approvedExpenseIds
      employeeId: $employeeId
      employerNotes: $employerNotes
      reportId: $reportId
    ) {
      ... on MutationApproveOrRejectExpenseReportSuccess {
        data {
          id
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
export type ApproveOrRejectExpenseReportMutationFn = Apollo.MutationFunction<
  ApproveOrRejectExpenseReportMutation,
  ApproveOrRejectExpenseReportMutationVariables
>;

/**
 * __useApproveOrRejectExpenseReportMutation__
 *
 * To run a mutation, you first call `useApproveOrRejectExpenseReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveOrRejectExpenseReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveOrRejectExpenseReportMutation, { data, loading, error }] = useApproveOrRejectExpenseReportMutation({
 *   variables: {
 *      approvedExpenseIds: // value for 'approvedExpenseIds'
 *      employeeId: // value for 'employeeId'
 *      employerNotes: // value for 'employerNotes'
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useApproveOrRejectExpenseReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApproveOrRejectExpenseReportMutation,
    ApproveOrRejectExpenseReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApproveOrRejectExpenseReportMutation,
    ApproveOrRejectExpenseReportMutationVariables
  >(ApproveOrRejectExpenseReportDocument, options);
}
export type ApproveOrRejectExpenseReportMutationHookResult = ReturnType<
  typeof useApproveOrRejectExpenseReportMutation
>;
export type ApproveOrRejectExpenseReportMutationResult =
  Apollo.MutationResult<ApproveOrRejectExpenseReportMutation>;
export type ApproveOrRejectExpenseReportMutationOptions =
  Apollo.BaseMutationOptions<
    ApproveOrRejectExpenseReportMutation,
    ApproveOrRejectExpenseReportMutationVariables
  >;
export const UpdateExpenseDocument = gql`
  mutation UpdateExpense(
    $expenseId: Int!
    $amount: Float!
    $attendeeEmails: [String!]
    $merchantName: String!
    $notes: String
    $transactionDate: Date!
    $receiptFileData: String
    $reportId: Int!
    $expenseCategoryGLId: Int
    $customFieldEntries: [ExpenseCustomFieldEntryUpsertInput!]
  ) {
    updateExpense(
      expenseId: $expenseId
      input: {
        amount: $amount
        attendeeEmails: $attendeeEmails
        merchantName: $merchantName
        notes: $notes
        transactionDate: $transactionDate
        expenseCategoryGLId: $expenseCategoryGLId
        customFieldEntries: $customFieldEntries
      }
      receiptFileData: $receiptFileData
      reportId: $reportId
    ) {
      ... on MutationUpdateExpenseSuccess {
        data {
          id
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
export type UpdateExpenseMutationFn = Apollo.MutationFunction<
  UpdateExpenseMutation,
  UpdateExpenseMutationVariables
>;

/**
 * __useUpdateExpenseMutation__
 *
 * To run a mutation, you first call `useUpdateExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpenseMutation, { data, loading, error }] = useUpdateExpenseMutation({
 *   variables: {
 *      expenseId: // value for 'expenseId'
 *      amount: // value for 'amount'
 *      attendeeEmails: // value for 'attendeeEmails'
 *      merchantName: // value for 'merchantName'
 *      notes: // value for 'notes'
 *      transactionDate: // value for 'transactionDate'
 *      receiptFileData: // value for 'receiptFileData'
 *      reportId: // value for 'reportId'
 *      expenseCategoryGLId: // value for 'expenseCategoryGLId'
 *      customFieldEntries: // value for 'customFieldEntries'
 *   },
 * });
 */
export function useUpdateExpenseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateExpenseMutation,
    UpdateExpenseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateExpenseMutation,
    UpdateExpenseMutationVariables
  >(UpdateExpenseDocument, options);
}
export type UpdateExpenseMutationHookResult = ReturnType<
  typeof useUpdateExpenseMutation
>;
export type UpdateExpenseMutationResult =
  Apollo.MutationResult<UpdateExpenseMutation>;
export type UpdateExpenseMutationOptions = Apollo.BaseMutationOptions<
  UpdateExpenseMutation,
  UpdateExpenseMutationVariables
>;
export const ParseExpenseReceiptDocument = gql`
  mutation ParseExpenseReceipt($receiptFileData: String!) {
    parseReceiptWithOCR(receiptFileData: $receiptFileData) {
      ... on MutationParseReceiptWithOCRSuccess {
        data {
          amount
          merchantName
          transactionDate
          expenseCategoryGLId
          customFields {
            booleanValue
            customFieldEntityId
            customFieldEntityType
            customFieldListOptionId
            rawValue
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
export type ParseExpenseReceiptMutationFn = Apollo.MutationFunction<
  ParseExpenseReceiptMutation,
  ParseExpenseReceiptMutationVariables
>;

/**
 * __useParseExpenseReceiptMutation__
 *
 * To run a mutation, you first call `useParseExpenseReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParseExpenseReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [parseExpenseReceiptMutation, { data, loading, error }] = useParseExpenseReceiptMutation({
 *   variables: {
 *      receiptFileData: // value for 'receiptFileData'
 *   },
 * });
 */
export function useParseExpenseReceiptMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ParseExpenseReceiptMutation,
    ParseExpenseReceiptMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ParseExpenseReceiptMutation,
    ParseExpenseReceiptMutationVariables
  >(ParseExpenseReceiptDocument, options);
}
export type ParseExpenseReceiptMutationHookResult = ReturnType<
  typeof useParseExpenseReceiptMutation
>;
export type ParseExpenseReceiptMutationResult =
  Apollo.MutationResult<ParseExpenseReceiptMutation>;
export type ParseExpenseReceiptMutationOptions = Apollo.BaseMutationOptions<
  ParseExpenseReceiptMutation,
  ParseExpenseReceiptMutationVariables
>;
export const DeleteReportDocument = gql`
  mutation DeleteReport($id: Int!) {
    deleteDraftExpenseReport(id: $id) {
      ... on MutationDeleteDraftExpenseReportSuccess {
        data
      }
      ... on BaseError {
        code
        message
      }
      ... on ValidationError {
        code
        message
      }
    }
  }
`;
export type DeleteReportMutationFn = Apollo.MutationFunction<
  DeleteReportMutation,
  DeleteReportMutationVariables
>;

/**
 * __useDeleteReportMutation__
 *
 * To run a mutation, you first call `useDeleteReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportMutation, { data, loading, error }] = useDeleteReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteReportMutation,
    DeleteReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteReportMutation,
    DeleteReportMutationVariables
  >(DeleteReportDocument, options);
}
export type DeleteReportMutationHookResult = ReturnType<
  typeof useDeleteReportMutation
>;
export type DeleteReportMutationResult =
  Apollo.MutationResult<DeleteReportMutation>;
export type DeleteReportMutationOptions = Apollo.BaseMutationOptions<
  DeleteReportMutation,
  DeleteReportMutationVariables
>;
export const ExpenseReportsByViewDocument = gql`
  query ExpenseReportsByView(
    $searchText: String
    $expenseReportStatus: [ExpenseReportStatus!]
    $offset: Int
    $pageSize: Int
  ) {
    expenseReportsByView(
      pagination: { offset: $offset, pageSize: $pageSize }
      filters: {
        searchText: $searchText
        expenseReportStatus: $expenseReportStatus
      }
    ) {
      ... on QueryExpenseReportsByViewSuccess {
        data {
          hasMore
          nextPageOffset
          reports {
            id
            createdAt
            displayStatus
            displayTotalDollarAmount
            employeeId
            employerNotes
            isAutoApproved
            designatedApprover {
              displayName
            }
            approvedOrRejectedBy {
              displayName
            }
            expenses {
              expenseCategory {
                id
                categoryName
              }
              expenseCategoryGLId
              amount
              attendeeEmails
              createdAt
              id
              merchantName
              notes
              receiptFileUrl
              reportId
              transactionDate
              report {
                status
                displayStatus
                title
                isAutoApproved
              }
              status
              transactionCategoryIconUrl
              transactionId
              updatedAt
              customFieldEntries {
                customFieldEntityId
                rawValue
                booleanValue
                customFieldListOptionId
                type: customFieldEntityType
              }
            }
            user {
              firstName
              lastName
            }
            isInstantReimbursed
            notes
            status
            statusIconUrl
            title
            updatedAt
            displayPayoutMethod
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useExpenseReportsByViewQuery__
 *
 * To run a query within a React component, call `useExpenseReportsByViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseReportsByViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseReportsByViewQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      expenseReportStatus: // value for 'expenseReportStatus'
 *      offset: // value for 'offset'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useExpenseReportsByViewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ExpenseReportsByViewQuery,
    ExpenseReportsByViewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ExpenseReportsByViewQuery,
    ExpenseReportsByViewQueryVariables
  >(ExpenseReportsByViewDocument, options);
}
export function useExpenseReportsByViewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExpenseReportsByViewQuery,
    ExpenseReportsByViewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExpenseReportsByViewQuery,
    ExpenseReportsByViewQueryVariables
  >(ExpenseReportsByViewDocument, options);
}
export function useExpenseReportsByViewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExpenseReportsByViewQuery,
    ExpenseReportsByViewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExpenseReportsByViewQuery,
    ExpenseReportsByViewQueryVariables
  >(ExpenseReportsByViewDocument, options);
}
export type ExpenseReportsByViewQueryHookResult = ReturnType<
  typeof useExpenseReportsByViewQuery
>;
export type ExpenseReportsByViewLazyQueryHookResult = ReturnType<
  typeof useExpenseReportsByViewLazyQuery
>;
export type ExpenseReportsByViewSuspenseQueryHookResult = ReturnType<
  typeof useExpenseReportsByViewSuspenseQuery
>;
export type ExpenseReportsByViewQueryResult = Apollo.QueryResult<
  ExpenseReportsByViewQuery,
  ExpenseReportsByViewQueryVariables
>;
export const ExpenseReportDocument = gql`
  query ExpenseReport($reportId: Int!) {
    expenseReport(id: $reportId) {
      ... on QueryExpenseReportSuccess {
        data {
          id
          createdAt
          displayStatus
          displayTotalDollarAmount
          designatedApprover {
            displayName
          }
          employerNotes
          expenses {
            amount
            expenseCategory {
              id
              categoryName
            }
            expenseCategoryGLId
            attendeeEmails
            createdAt
            transactionDate
            id
            merchantName
            notes
            receiptFileUrl
            reportId
            report {
              id
              title
              status
              displayStatus
              isAutoApproved
              displayTotalDollarAmount
              updatedAt
              approvedOrRejectedBy {
                displayName
              }
            }
            customFieldEntries {
              customFieldEntityId
              rawValue
              booleanValue
              customFieldListOptionId
              type: customFieldEntityType
              customFieldEntity {
                name
                listOptions {
                  id
                  name
                  value
                }
              }
            }
            status
            transactionCategoryIconUrl
            transactionId
            updatedAt
          }
          user {
            firstName
            lastName
          }
          isInstantReimbursed
          notes
          status
          statusIconUrl
          title
          updatedAt
          displayPayoutMethod
          isAutoApproved
          displayStatus
        }
      }
      ... on BaseError {
        message
      }
    }
  }
`;

/**
 * __useExpenseReportQuery__
 *
 * To run a query within a React component, call `useExpenseReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseReportQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useExpenseReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExpenseReportQuery,
    ExpenseReportQueryVariables
  > &
    (
      | { variables: ExpenseReportQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExpenseReportQuery, ExpenseReportQueryVariables>(
    ExpenseReportDocument,
    options,
  );
}
export function useExpenseReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExpenseReportQuery,
    ExpenseReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExpenseReportQuery, ExpenseReportQueryVariables>(
    ExpenseReportDocument,
    options,
  );
}
export function useExpenseReportSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExpenseReportQuery,
    ExpenseReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExpenseReportQuery,
    ExpenseReportQueryVariables
  >(ExpenseReportDocument, options);
}
export type ExpenseReportQueryHookResult = ReturnType<
  typeof useExpenseReportQuery
>;
export type ExpenseReportLazyQueryHookResult = ReturnType<
  typeof useExpenseReportLazyQuery
>;
export type ExpenseReportSuspenseQueryHookResult = ReturnType<
  typeof useExpenseReportSuspenseQuery
>;
export type ExpenseReportQueryResult = Apollo.QueryResult<
  ExpenseReportQuery,
  ExpenseReportQueryVariables
>;
export const OrganizationDocument = gql`
  query Organization {
    organization {
      ... on QueryOrganizationSuccess {
        data {
          cardApplicationPageUrl
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OrganizationQuery,
    OrganizationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(
    OrganizationDocument,
    options,
  );
}
export function useOrganizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrganizationQuery,
    OrganizationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(
    OrganizationDocument,
    options,
  );
}
export function useOrganizationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OrganizationQuery,
    OrganizationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<OrganizationQuery, OrganizationQueryVariables>(
    OrganizationDocument,
    options,
  );
}
export type OrganizationQueryHookResult = ReturnType<
  typeof useOrganizationQuery
>;
export type OrganizationLazyQueryHookResult = ReturnType<
  typeof useOrganizationLazyQuery
>;
export type OrganizationSuspenseQueryHookResult = ReturnType<
  typeof useOrganizationSuspenseQuery
>;
export type OrganizationQueryResult = Apollo.QueryResult<
  OrganizationQuery,
  OrganizationQueryVariables
>;
export const GetDebitTransactionsDocument = gql`
  query GetDebitTransactions(
    $status: [TransactionStatus!]
    $merchantName: String
    $type: [TransactionType!]
  ) {
    transactions(
      filters: {
        creditIndicator: debit
        status: $status
        merchantName: $merchantName
        type: $type
      }
    ) {
      ... on QueryTransactionsSuccess {
        __typename
        data {
          hasMore
          nextPageOffset
          allTransactions {
            ... on Transaction {
              displayTitle
              displayDollarAmount
              transactedAt
              id
              amountInDollars
              expenseCategoryGLId
              type
              latestExpense {
                id
                status
                reportId
                report {
                  title
                }
                updatedAt
              }
              latestStipendExpense {
                stipendExpenseId
                status
                stipendName
                createdAt
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetDebitTransactionsQuery__
 *
 * To run a query within a React component, call `useGetDebitTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDebitTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDebitTransactionsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      merchantName: // value for 'merchantName'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetDebitTransactionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDebitTransactionsQuery,
    GetDebitTransactionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDebitTransactionsQuery,
    GetDebitTransactionsQueryVariables
  >(GetDebitTransactionsDocument, options);
}
export function useGetDebitTransactionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDebitTransactionsQuery,
    GetDebitTransactionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDebitTransactionsQuery,
    GetDebitTransactionsQueryVariables
  >(GetDebitTransactionsDocument, options);
}
export function useGetDebitTransactionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDebitTransactionsQuery,
    GetDebitTransactionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDebitTransactionsQuery,
    GetDebitTransactionsQueryVariables
  >(GetDebitTransactionsDocument, options);
}
export type GetDebitTransactionsQueryHookResult = ReturnType<
  typeof useGetDebitTransactionsQuery
>;
export type GetDebitTransactionsLazyQueryHookResult = ReturnType<
  typeof useGetDebitTransactionsLazyQuery
>;
export type GetDebitTransactionsSuspenseQueryHookResult = ReturnType<
  typeof useGetDebitTransactionsSuspenseQuery
>;
export type GetDebitTransactionsQueryResult = Apollo.QueryResult<
  GetDebitTransactionsQuery,
  GetDebitTransactionsQueryVariables
>;
export const UpdateEmployeeDocument = gql`
  mutation UpdateEmployee(
    $firstName: String!
    $lastName: String!
    $departmentId: Int!
    $managerEmployeeProfileId: String
    $userId: String!
    $roles: [UserRole!]!
  ) {
    updateEmployee(
      input: {
        employeeProfile: {
          departmentId: $departmentId
          managerEmployeeProfileId: $managerEmployeeProfileId
        }
        firstName: $firstName
        lastName: $lastName
        roles: $roles
      }
      userId: $userId
    ) {
      ... on MutationUpdateEmployeeSuccess {
        data {
          userId
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<
  UpdateEmployeeMutation,
  UpdateEmployeeMutationVariables
>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      departmentId: // value for 'departmentId'
 *      managerEmployeeProfileId: // value for 'managerEmployeeProfileId'
 *      userId: // value for 'userId'
 *      roles: // value for 'roles'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEmployeeMutation,
    UpdateEmployeeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateEmployeeMutation,
    UpdateEmployeeMutationVariables
  >(UpdateEmployeeDocument, options);
}
export type UpdateEmployeeMutationHookResult = ReturnType<
  typeof useUpdateEmployeeMutation
>;
export type UpdateEmployeeMutationResult =
  Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<
  UpdateEmployeeMutation,
  UpdateEmployeeMutationVariables
>;
export const AdminUpsertDepartmentDocument = gql`
  mutation AdminUpsertDepartment(
    $isShown: Boolean
    $name: String!
    $uuid: String!
  ) {
    adminUpsertDepartment(
      input: { isShown: $isShown, name: $name, uuid: $uuid }
    ) {
      ... on MutationAdminUpsertDepartmentSuccess {
        data {
          id
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
export type AdminUpsertDepartmentMutationFn = Apollo.MutationFunction<
  AdminUpsertDepartmentMutation,
  AdminUpsertDepartmentMutationVariables
>;

/**
 * __useAdminUpsertDepartmentMutation__
 *
 * To run a mutation, you first call `useAdminUpsertDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpsertDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpsertDepartmentMutation, { data, loading, error }] = useAdminUpsertDepartmentMutation({
 *   variables: {
 *      isShown: // value for 'isShown'
 *      name: // value for 'name'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useAdminUpsertDepartmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminUpsertDepartmentMutation,
    AdminUpsertDepartmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminUpsertDepartmentMutation,
    AdminUpsertDepartmentMutationVariables
  >(AdminUpsertDepartmentDocument, options);
}
export type AdminUpsertDepartmentMutationHookResult = ReturnType<
  typeof useAdminUpsertDepartmentMutation
>;
export type AdminUpsertDepartmentMutationResult =
  Apollo.MutationResult<AdminUpsertDepartmentMutation>;
export type AdminUpsertDepartmentMutationOptions = Apollo.BaseMutationOptions<
  AdminUpsertDepartmentMutation,
  AdminUpsertDepartmentMutationVariables
>;
export const UpdateEmployeesToDepartmentDocument = gql`
  mutation UpdateEmployeesToDepartment(
    $departmentId: Int!
    $userIds: [String!]!
  ) {
    updateEmployeesToDepartment(
      departmentId: $departmentId
      userIds: $userIds
    ) {
      ... on MutationUpdateEmployeesToDepartmentSuccess {
        data
      }
      ... on BaseError {
        message
      }
    }
  }
`;
export type UpdateEmployeesToDepartmentMutationFn = Apollo.MutationFunction<
  UpdateEmployeesToDepartmentMutation,
  UpdateEmployeesToDepartmentMutationVariables
>;

/**
 * __useUpdateEmployeesToDepartmentMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeesToDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeesToDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeesToDepartmentMutation, { data, loading, error }] = useUpdateEmployeesToDepartmentMutation({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useUpdateEmployeesToDepartmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEmployeesToDepartmentMutation,
    UpdateEmployeesToDepartmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateEmployeesToDepartmentMutation,
    UpdateEmployeesToDepartmentMutationVariables
  >(UpdateEmployeesToDepartmentDocument, options);
}
export type UpdateEmployeesToDepartmentMutationHookResult = ReturnType<
  typeof useUpdateEmployeesToDepartmentMutation
>;
export type UpdateEmployeesToDepartmentMutationResult =
  Apollo.MutationResult<UpdateEmployeesToDepartmentMutation>;
export type UpdateEmployeesToDepartmentMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateEmployeesToDepartmentMutation,
    UpdateEmployeesToDepartmentMutationVariables
  >;
export const AdminUpsertExpenseCategoryGlPairingDocument = gql`
  mutation AdminUpsertExpenseCategoryGLPairing(
    $categoryName: String!
    $glAccount: String!
    $isShown: Boolean!
    $uuid: String!
  ) {
    adminUpsertExpenseCategoryGLPairing(
      input: {
        categoryName: $categoryName
        glAccount: $glAccount
        isShown: $isShown
        uuid: $uuid
      }
    ) {
      ... on MutationAdminUpsertExpenseCategoryGLPairingSuccess {
        data {
          id
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
export type AdminUpsertExpenseCategoryGlPairingMutationFn =
  Apollo.MutationFunction<
    AdminUpsertExpenseCategoryGlPairingMutation,
    AdminUpsertExpenseCategoryGlPairingMutationVariables
  >;

/**
 * __useAdminUpsertExpenseCategoryGlPairingMutation__
 *
 * To run a mutation, you first call `useAdminUpsertExpenseCategoryGlPairingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpsertExpenseCategoryGlPairingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpsertExpenseCategoryGlPairingMutation, { data, loading, error }] = useAdminUpsertExpenseCategoryGlPairingMutation({
 *   variables: {
 *      categoryName: // value for 'categoryName'
 *      glAccount: // value for 'glAccount'
 *      isShown: // value for 'isShown'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useAdminUpsertExpenseCategoryGlPairingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminUpsertExpenseCategoryGlPairingMutation,
    AdminUpsertExpenseCategoryGlPairingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminUpsertExpenseCategoryGlPairingMutation,
    AdminUpsertExpenseCategoryGlPairingMutationVariables
  >(AdminUpsertExpenseCategoryGlPairingDocument, options);
}
export type AdminUpsertExpenseCategoryGlPairingMutationHookResult = ReturnType<
  typeof useAdminUpsertExpenseCategoryGlPairingMutation
>;
export type AdminUpsertExpenseCategoryGlPairingMutationResult =
  Apollo.MutationResult<AdminUpsertExpenseCategoryGlPairingMutation>;
export type AdminUpsertExpenseCategoryGlPairingMutationOptions =
  Apollo.BaseMutationOptions<
    AdminUpsertExpenseCategoryGlPairingMutation,
    AdminUpsertExpenseCategoryGlPairingMutationVariables
  >;
export const UpsertPolicyDocument = gql`
  mutation UpsertPolicy(
    $uuid: String
    $policy: String!
    $name: String!
    $isActive: Boolean
    $departmentIds: [Int!]
  ) {
    upsertPolicy(
      input: {
        policy: $policy
        uuid: $uuid
        name: $name
        isActive: $isActive
        departmentIds: $departmentIds
      }
    ) {
      ... on MutationUpsertPolicySuccess {
        data {
          id
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
export type UpsertPolicyMutationFn = Apollo.MutationFunction<
  UpsertPolicyMutation,
  UpsertPolicyMutationVariables
>;

/**
 * __useUpsertPolicyMutation__
 *
 * To run a mutation, you first call `useUpsertPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPolicyMutation, { data, loading, error }] = useUpsertPolicyMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      policy: // value for 'policy'
 *      name: // value for 'name'
 *      isActive: // value for 'isActive'
 *      departmentIds: // value for 'departmentIds'
 *   },
 * });
 */
export function useUpsertPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertPolicyMutation,
    UpsertPolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertPolicyMutation,
    UpsertPolicyMutationVariables
  >(UpsertPolicyDocument, options);
}
export type UpsertPolicyMutationHookResult = ReturnType<
  typeof useUpsertPolicyMutation
>;
export type UpsertPolicyMutationResult =
  Apollo.MutationResult<UpsertPolicyMutation>;
export type UpsertPolicyMutationOptions = Apollo.BaseMutationOptions<
  UpsertPolicyMutation,
  UpsertPolicyMutationVariables
>;
export const InviteEmployeeDocument = gql`
  mutation InviteEmployee(
    $firstName: String!
    $lastName: String!
    $workEmail: String!
    $departmentId: Int!
    $managerEmployeeProfileId: String
    $roles: [UserRole!]!
  ) {
    inviteEmployee(
      input: {
        employeeProfile: {
          workEmail: $workEmail
          departmentId: $departmentId
          managerEmployeeProfileId: $managerEmployeeProfileId
        }
        firstName: $firstName
        lastName: $lastName
        roles: $roles
      }
    ) {
      ... on MutationInviteEmployeeSuccess {
        data {
          userId
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
export type InviteEmployeeMutationFn = Apollo.MutationFunction<
  InviteEmployeeMutation,
  InviteEmployeeMutationVariables
>;

/**
 * __useInviteEmployeeMutation__
 *
 * To run a mutation, you first call `useInviteEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteEmployeeMutation, { data, loading, error }] = useInviteEmployeeMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      workEmail: // value for 'workEmail'
 *      departmentId: // value for 'departmentId'
 *      managerEmployeeProfileId: // value for 'managerEmployeeProfileId'
 *      roles: // value for 'roles'
 *   },
 * });
 */
export function useInviteEmployeeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InviteEmployeeMutation,
    InviteEmployeeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InviteEmployeeMutation,
    InviteEmployeeMutationVariables
  >(InviteEmployeeDocument, options);
}
export type InviteEmployeeMutationHookResult = ReturnType<
  typeof useInviteEmployeeMutation
>;
export type InviteEmployeeMutationResult =
  Apollo.MutationResult<InviteEmployeeMutation>;
export type InviteEmployeeMutationOptions = Apollo.BaseMutationOptions<
  InviteEmployeeMutation,
  InviteEmployeeMutationVariables
>;
export const AwxCreateAndAuthorizeAccountDocument = gql`
  mutation AwxCreateAndAuthorizeAccount(
    $codeChallenge: String!
    $email: String!
  ) {
    awxCreateAndAuthorizeAccount(codeChallenge: $codeChallenge, email: $email) {
      ... on MutationAwxCreateAndAuthorizeAccountSuccess {
        data {
          authorizationCode
        }
      }
    }
  }
`;
export type AwxCreateAndAuthorizeAccountMutationFn = Apollo.MutationFunction<
  AwxCreateAndAuthorizeAccountMutation,
  AwxCreateAndAuthorizeAccountMutationVariables
>;

/**
 * __useAwxCreateAndAuthorizeAccountMutation__
 *
 * To run a mutation, you first call `useAwxCreateAndAuthorizeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAwxCreateAndAuthorizeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [awxCreateAndAuthorizeAccountMutation, { data, loading, error }] = useAwxCreateAndAuthorizeAccountMutation({
 *   variables: {
 *      codeChallenge: // value for 'codeChallenge'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAwxCreateAndAuthorizeAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AwxCreateAndAuthorizeAccountMutation,
    AwxCreateAndAuthorizeAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AwxCreateAndAuthorizeAccountMutation,
    AwxCreateAndAuthorizeAccountMutationVariables
  >(AwxCreateAndAuthorizeAccountDocument, options);
}
export type AwxCreateAndAuthorizeAccountMutationHookResult = ReturnType<
  typeof useAwxCreateAndAuthorizeAccountMutation
>;
export type AwxCreateAndAuthorizeAccountMutationResult =
  Apollo.MutationResult<AwxCreateAndAuthorizeAccountMutation>;
export type AwxCreateAndAuthorizeAccountMutationOptions =
  Apollo.BaseMutationOptions<
    AwxCreateAndAuthorizeAccountMutation,
    AwxCreateAndAuthorizeAccountMutationVariables
  >;
export const AwxAuthorizeBeneficiaryAccountDocument = gql`
  mutation AwxAuthorizeBeneficiaryAccount($codeChallenge: String!) {
    awxAuthorizeBeneficiaryAccount(codeChallenge: $codeChallenge) {
      ... on MutationAwxAuthorizeBeneficiaryAccountSuccess {
        data {
          authorizationCode
        }
      }
    }
  }
`;
export type AwxAuthorizeBeneficiaryAccountMutationFn = Apollo.MutationFunction<
  AwxAuthorizeBeneficiaryAccountMutation,
  AwxAuthorizeBeneficiaryAccountMutationVariables
>;

/**
 * __useAwxAuthorizeBeneficiaryAccountMutation__
 *
 * To run a mutation, you first call `useAwxAuthorizeBeneficiaryAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAwxAuthorizeBeneficiaryAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [awxAuthorizeBeneficiaryAccountMutation, { data, loading, error }] = useAwxAuthorizeBeneficiaryAccountMutation({
 *   variables: {
 *      codeChallenge: // value for 'codeChallenge'
 *   },
 * });
 */
export function useAwxAuthorizeBeneficiaryAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AwxAuthorizeBeneficiaryAccountMutation,
    AwxAuthorizeBeneficiaryAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AwxAuthorizeBeneficiaryAccountMutation,
    AwxAuthorizeBeneficiaryAccountMutationVariables
  >(AwxAuthorizeBeneficiaryAccountDocument, options);
}
export type AwxAuthorizeBeneficiaryAccountMutationHookResult = ReturnType<
  typeof useAwxAuthorizeBeneficiaryAccountMutation
>;
export type AwxAuthorizeBeneficiaryAccountMutationResult =
  Apollo.MutationResult<AwxAuthorizeBeneficiaryAccountMutation>;
export type AwxAuthorizeBeneficiaryAccountMutationOptions =
  Apollo.BaseMutationOptions<
    AwxAuthorizeBeneficiaryAccountMutation,
    AwxAuthorizeBeneficiaryAccountMutationVariables
  >;
export const ConnectLinkedBankAccountDocument = gql`
  mutation ConnectLinkedBankAccount(
    $publicToken: String!
    $institutionId: String!
    $institutionName: String!
    $accountId: String!
    $accountName: String!
    $accountMask: String!
    $signatoryEmail: String!
  ) {
    awxConnectLinkedAccount(
      input: {
        publicToken: $publicToken
        institutionId: $institutionId
        institutionName: $institutionName
        accountId: $accountId
        accountName: $accountName
        accountMask: $accountMask
        signatoryEmail: $signatoryEmail
      }
    ) {
      ... on MutationAwxConnectLinkedAccountSuccess {
        data {
          awxLinkedAccount {
            id
            status
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
export type ConnectLinkedBankAccountMutationFn = Apollo.MutationFunction<
  ConnectLinkedBankAccountMutation,
  ConnectLinkedBankAccountMutationVariables
>;

/**
 * __useConnectLinkedBankAccountMutation__
 *
 * To run a mutation, you first call `useConnectLinkedBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectLinkedBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectLinkedBankAccountMutation, { data, loading, error }] = useConnectLinkedBankAccountMutation({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *      institutionId: // value for 'institutionId'
 *      institutionName: // value for 'institutionName'
 *      accountId: // value for 'accountId'
 *      accountName: // value for 'accountName'
 *      accountMask: // value for 'accountMask'
 *      signatoryEmail: // value for 'signatoryEmail'
 *   },
 * });
 */
export function useConnectLinkedBankAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConnectLinkedBankAccountMutation,
    ConnectLinkedBankAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConnectLinkedBankAccountMutation,
    ConnectLinkedBankAccountMutationVariables
  >(ConnectLinkedBankAccountDocument, options);
}
export type ConnectLinkedBankAccountMutationHookResult = ReturnType<
  typeof useConnectLinkedBankAccountMutation
>;
export type ConnectLinkedBankAccountMutationResult =
  Apollo.MutationResult<ConnectLinkedBankAccountMutation>;
export type ConnectLinkedBankAccountMutationOptions =
  Apollo.BaseMutationOptions<
    ConnectLinkedBankAccountMutation,
    ConnectLinkedBankAccountMutationVariables
  >;
export const UpsertAwxBeneficiaryAccountDocument = gql`
  mutation UpsertAwxBeneficiaryAccount($input: UpsertBeneficiaryInput!) {
    upsertAwxBeneficiaryAccount(input: $input) {
      ... on MutationUpsertAwxBeneficiaryAccountSuccess {
        data {
          nickname
          beneficiary {
            bankDetails {
              accountName
              accountNumberLastFour
              bankCountryCode
              localClearingSystem
            }
          }
          beneficiaryId
        }
      }
    }
  }
`;
export type UpsertAwxBeneficiaryAccountMutationFn = Apollo.MutationFunction<
  UpsertAwxBeneficiaryAccountMutation,
  UpsertAwxBeneficiaryAccountMutationVariables
>;

/**
 * __useUpsertAwxBeneficiaryAccountMutation__
 *
 * To run a mutation, you first call `useUpsertAwxBeneficiaryAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAwxBeneficiaryAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAwxBeneficiaryAccountMutation, { data, loading, error }] = useUpsertAwxBeneficiaryAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertAwxBeneficiaryAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertAwxBeneficiaryAccountMutation,
    UpsertAwxBeneficiaryAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertAwxBeneficiaryAccountMutation,
    UpsertAwxBeneficiaryAccountMutationVariables
  >(UpsertAwxBeneficiaryAccountDocument, options);
}
export type UpsertAwxBeneficiaryAccountMutationHookResult = ReturnType<
  typeof useUpsertAwxBeneficiaryAccountMutation
>;
export type UpsertAwxBeneficiaryAccountMutationResult =
  Apollo.MutationResult<UpsertAwxBeneficiaryAccountMutation>;
export type UpsertAwxBeneficiaryAccountMutationOptions =
  Apollo.BaseMutationOptions<
    UpsertAwxBeneficiaryAccountMutation,
    UpsertAwxBeneficiaryAccountMutationVariables
  >;
export const SuspendLinkedAccountDocument = gql`
  mutation SuspendLinkedAccount {
    suspendLinkedAccount {
      ... on MutationSuspendLinkedAccountSuccess {
        data
      }
    }
  }
`;
export type SuspendLinkedAccountMutationFn = Apollo.MutationFunction<
  SuspendLinkedAccountMutation,
  SuspendLinkedAccountMutationVariables
>;

/**
 * __useSuspendLinkedAccountMutation__
 *
 * To run a mutation, you first call `useSuspendLinkedAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendLinkedAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendLinkedAccountMutation, { data, loading, error }] = useSuspendLinkedAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useSuspendLinkedAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SuspendLinkedAccountMutation,
    SuspendLinkedAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SuspendLinkedAccountMutation,
    SuspendLinkedAccountMutationVariables
  >(SuspendLinkedAccountDocument, options);
}
export type SuspendLinkedAccountMutationHookResult = ReturnType<
  typeof useSuspendLinkedAccountMutation
>;
export type SuspendLinkedAccountMutationResult =
  Apollo.MutationResult<SuspendLinkedAccountMutation>;
export type SuspendLinkedAccountMutationOptions = Apollo.BaseMutationOptions<
  SuspendLinkedAccountMutation,
  SuspendLinkedAccountMutationVariables
>;
export const DeleteBeneficiaryDocument = gql`
  mutation DeleteBeneficiary {
    deleteAwxBeneficiaryAccount {
      ... on MutationDeleteAwxBeneficiaryAccountSuccess {
        data
      }
    }
  }
`;
export type DeleteBeneficiaryMutationFn = Apollo.MutationFunction<
  DeleteBeneficiaryMutation,
  DeleteBeneficiaryMutationVariables
>;

/**
 * __useDeleteBeneficiaryMutation__
 *
 * To run a mutation, you first call `useDeleteBeneficiaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBeneficiaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBeneficiaryMutation, { data, loading, error }] = useDeleteBeneficiaryMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteBeneficiaryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteBeneficiaryMutation,
    DeleteBeneficiaryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteBeneficiaryMutation,
    DeleteBeneficiaryMutationVariables
  >(DeleteBeneficiaryDocument, options);
}
export type DeleteBeneficiaryMutationHookResult = ReturnType<
  typeof useDeleteBeneficiaryMutation
>;
export type DeleteBeneficiaryMutationResult =
  Apollo.MutationResult<DeleteBeneficiaryMutation>;
export type DeleteBeneficiaryMutationOptions = Apollo.BaseMutationOptions<
  DeleteBeneficiaryMutation,
  DeleteBeneficiaryMutationVariables
>;
export const RegisterNotifyMeForFeatureDocument = gql`
  mutation RegisterNotifyMeForFeature($feature: UserFeatureNotification!) {
    registerNotifyMeForFeature(feature: $feature) {
      ... on MutationRegisterNotifyMeForFeatureSuccess {
        data
      }
    }
  }
`;
export type RegisterNotifyMeForFeatureMutationFn = Apollo.MutationFunction<
  RegisterNotifyMeForFeatureMutation,
  RegisterNotifyMeForFeatureMutationVariables
>;

/**
 * __useRegisterNotifyMeForFeatureMutation__
 *
 * To run a mutation, you first call `useRegisterNotifyMeForFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterNotifyMeForFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerNotifyMeForFeatureMutation, { data, loading, error }] = useRegisterNotifyMeForFeatureMutation({
 *   variables: {
 *      feature: // value for 'feature'
 *   },
 * });
 */
export function useRegisterNotifyMeForFeatureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterNotifyMeForFeatureMutation,
    RegisterNotifyMeForFeatureMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterNotifyMeForFeatureMutation,
    RegisterNotifyMeForFeatureMutationVariables
  >(RegisterNotifyMeForFeatureDocument, options);
}
export type RegisterNotifyMeForFeatureMutationHookResult = ReturnType<
  typeof useRegisterNotifyMeForFeatureMutation
>;
export type RegisterNotifyMeForFeatureMutationResult =
  Apollo.MutationResult<RegisterNotifyMeForFeatureMutation>;
export type RegisterNotifyMeForFeatureMutationOptions =
  Apollo.BaseMutationOptions<
    RegisterNotifyMeForFeatureMutation,
    RegisterNotifyMeForFeatureMutationVariables
  >;
export const TestExpensePolicyDocument = gql`
  mutation TestExpensePolicy($input: TestExpensePolicyInput!) {
    testExpensePolicy(input: $input) {
      ... on MutationTestExpensePolicySuccess {
        data {
          __typename
          isAutoApproved
          reason
        }
      }
    }
  }
`;
export type TestExpensePolicyMutationFn = Apollo.MutationFunction<
  TestExpensePolicyMutation,
  TestExpensePolicyMutationVariables
>;

/**
 * __useTestExpensePolicyMutation__
 *
 * To run a mutation, you first call `useTestExpensePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestExpensePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testExpensePolicyMutation, { data, loading, error }] = useTestExpensePolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTestExpensePolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TestExpensePolicyMutation,
    TestExpensePolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TestExpensePolicyMutation,
    TestExpensePolicyMutationVariables
  >(TestExpensePolicyDocument, options);
}
export type TestExpensePolicyMutationHookResult = ReturnType<
  typeof useTestExpensePolicyMutation
>;
export type TestExpensePolicyMutationResult =
  Apollo.MutationResult<TestExpensePolicyMutation>;
export type TestExpensePolicyMutationOptions = Apollo.BaseMutationOptions<
  TestExpensePolicyMutation,
  TestExpensePolicyMutationVariables
>;
export const SubmitFeedbackDocument = gql`
  mutation SubmitFeedback($feedback: String!) {
    submitFeedback(feedback: $feedback) {
      ... on MutationSubmitFeedbackSuccess {
        data
      }
      ... on Error {
        message
      }
    }
  }
`;
export type SubmitFeedbackMutationFn = Apollo.MutationFunction<
  SubmitFeedbackMutation,
  SubmitFeedbackMutationVariables
>;

/**
 * __useSubmitFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFeedbackMutation, { data, loading, error }] = useSubmitFeedbackMutation({
 *   variables: {
 *      feedback: // value for 'feedback'
 *   },
 * });
 */
export function useSubmitFeedbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitFeedbackMutation,
    SubmitFeedbackMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitFeedbackMutation,
    SubmitFeedbackMutationVariables
  >(SubmitFeedbackDocument, options);
}
export type SubmitFeedbackMutationHookResult = ReturnType<
  typeof useSubmitFeedbackMutation
>;
export type SubmitFeedbackMutationResult =
  Apollo.MutationResult<SubmitFeedbackMutation>;
export type SubmitFeedbackMutationOptions = Apollo.BaseMutationOptions<
  SubmitFeedbackMutation,
  SubmitFeedbackMutationVariables
>;
export const TerminateEmployeeProfileDocument = gql`
  mutation TerminateEmployeeProfile($userId: String!) {
    terminateEmployeeProfile(userId: $userId) {
      ... on MutationTerminateEmployeeProfileSuccess {
        data {
          employee {
            manager {
              userId
              firstName
              lastName
              employee {
                employeeId
              }
            }
            status
            displayStatus
            employmentStartDate
            department {
              name
              id
            }
            workEmail
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
export type TerminateEmployeeProfileMutationFn = Apollo.MutationFunction<
  TerminateEmployeeProfileMutation,
  TerminateEmployeeProfileMutationVariables
>;

/**
 * __useTerminateEmployeeProfileMutation__
 *
 * To run a mutation, you first call `useTerminateEmployeeProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTerminateEmployeeProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [terminateEmployeeProfileMutation, { data, loading, error }] = useTerminateEmployeeProfileMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useTerminateEmployeeProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TerminateEmployeeProfileMutation,
    TerminateEmployeeProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TerminateEmployeeProfileMutation,
    TerminateEmployeeProfileMutationVariables
  >(TerminateEmployeeProfileDocument, options);
}
export type TerminateEmployeeProfileMutationHookResult = ReturnType<
  typeof useTerminateEmployeeProfileMutation
>;
export type TerminateEmployeeProfileMutationResult =
  Apollo.MutationResult<TerminateEmployeeProfileMutation>;
export type TerminateEmployeeProfileMutationOptions =
  Apollo.BaseMutationOptions<
    TerminateEmployeeProfileMutation,
    TerminateEmployeeProfileMutationVariables
  >;
export const UpdateCurrentUserEmployeeDelegatesDocument = gql`
  mutation UpdateCurrentUserEmployeeDelegates(
    $delegateEmployeeProfileIds: [String!]!
  ) {
    updateCurrentUserEmployeeDelegates(
      delegateEmployeeProfileIds: $delegateEmployeeProfileIds
    ) {
      ... on MutationUpdateCurrentUserEmployeeDelegatesSuccess {
        data {
          employee {
            delegateUsers {
              userId
              firstName
              lastName
              displayName
              employee {
                employeeId
              }
            }
            impersonatableDelegateUsers {
              userId
              firstName
              lastName
              employee {
                employeeId
              }
            }
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
export type UpdateCurrentUserEmployeeDelegatesMutationFn =
  Apollo.MutationFunction<
    UpdateCurrentUserEmployeeDelegatesMutation,
    UpdateCurrentUserEmployeeDelegatesMutationVariables
  >;

/**
 * __useUpdateCurrentUserEmployeeDelegatesMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentUserEmployeeDelegatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentUserEmployeeDelegatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentUserEmployeeDelegatesMutation, { data, loading, error }] = useUpdateCurrentUserEmployeeDelegatesMutation({
 *   variables: {
 *      delegateEmployeeProfileIds: // value for 'delegateEmployeeProfileIds'
 *   },
 * });
 */
export function useUpdateCurrentUserEmployeeDelegatesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCurrentUserEmployeeDelegatesMutation,
    UpdateCurrentUserEmployeeDelegatesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCurrentUserEmployeeDelegatesMutation,
    UpdateCurrentUserEmployeeDelegatesMutationVariables
  >(UpdateCurrentUserEmployeeDelegatesDocument, options);
}
export type UpdateCurrentUserEmployeeDelegatesMutationHookResult = ReturnType<
  typeof useUpdateCurrentUserEmployeeDelegatesMutation
>;
export type UpdateCurrentUserEmployeeDelegatesMutationResult =
  Apollo.MutationResult<UpdateCurrentUserEmployeeDelegatesMutation>;
export type UpdateCurrentUserEmployeeDelegatesMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateCurrentUserEmployeeDelegatesMutation,
    UpdateCurrentUserEmployeeDelegatesMutationVariables
  >;
export const UpdateDelegateTransactionAccessDocument = gql`
  mutation UpdateDelegateTransactionAccess(
    $toggleDelegateTransactionAccess: Boolean!
  ) {
    updateDelegateTransactionAccess(
      toggleDelegateTransactionAccess: $toggleDelegateTransactionAccess
    ) {
      ... on MutationUpdateDelegateTransactionAccessSuccess {
        data
      }
      ... on Error {
        message
      }
    }
  }
`;
export type UpdateDelegateTransactionAccessMutationFn = Apollo.MutationFunction<
  UpdateDelegateTransactionAccessMutation,
  UpdateDelegateTransactionAccessMutationVariables
>;

/**
 * __useUpdateDelegateTransactionAccessMutation__
 *
 * To run a mutation, you first call `useUpdateDelegateTransactionAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDelegateTransactionAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDelegateTransactionAccessMutation, { data, loading, error }] = useUpdateDelegateTransactionAccessMutation({
 *   variables: {
 *      toggleDelegateTransactionAccess: // value for 'toggleDelegateTransactionAccess'
 *   },
 * });
 */
export function useUpdateDelegateTransactionAccessMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDelegateTransactionAccessMutation,
    UpdateDelegateTransactionAccessMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDelegateTransactionAccessMutation,
    UpdateDelegateTransactionAccessMutationVariables
  >(UpdateDelegateTransactionAccessDocument, options);
}
export type UpdateDelegateTransactionAccessMutationHookResult = ReturnType<
  typeof useUpdateDelegateTransactionAccessMutation
>;
export type UpdateDelegateTransactionAccessMutationResult =
  Apollo.MutationResult<UpdateDelegateTransactionAccessMutation>;
export type UpdateDelegateTransactionAccessMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateDelegateTransactionAccessMutation,
    UpdateDelegateTransactionAccessMutationVariables
  >;
export const UpsertCustomFieldListOptionDocument = gql`
  mutation UpsertCustomFieldListOption($input: CustomFieldListOptionInput!) {
    upsertCustomFieldListOption(input: $input) {
      ... on MutationUpsertCustomFieldListOptionSuccess {
        data {
          createdAt
          customFieldEntityId
          id
          isDeleted
          name
          parentFieldOptionUuid
          updatedAt
          uuid
          value
        }
      }
    }
  }
`;
export type UpsertCustomFieldListOptionMutationFn = Apollo.MutationFunction<
  UpsertCustomFieldListOptionMutation,
  UpsertCustomFieldListOptionMutationVariables
>;

/**
 * __useUpsertCustomFieldListOptionMutation__
 *
 * To run a mutation, you first call `useUpsertCustomFieldListOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCustomFieldListOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCustomFieldListOptionMutation, { data, loading, error }] = useUpsertCustomFieldListOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCustomFieldListOptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertCustomFieldListOptionMutation,
    UpsertCustomFieldListOptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertCustomFieldListOptionMutation,
    UpsertCustomFieldListOptionMutationVariables
  >(UpsertCustomFieldListOptionDocument, options);
}
export type UpsertCustomFieldListOptionMutationHookResult = ReturnType<
  typeof useUpsertCustomFieldListOptionMutation
>;
export type UpsertCustomFieldListOptionMutationResult =
  Apollo.MutationResult<UpsertCustomFieldListOptionMutation>;
export type UpsertCustomFieldListOptionMutationOptions =
  Apollo.BaseMutationOptions<
    UpsertCustomFieldListOptionMutation,
    UpsertCustomFieldListOptionMutationVariables
  >;
export const UpsertCustomFieldDocument = gql`
  mutation UpsertCustomField($input: CustomFieldEntityInput!) {
    upsertCustomField(input: $input) {
      ... on MutationUpsertCustomFieldSuccess {
        data {
          createdAt
        }
      }
    }
  }
`;
export type UpsertCustomFieldMutationFn = Apollo.MutationFunction<
  UpsertCustomFieldMutation,
  UpsertCustomFieldMutationVariables
>;

/**
 * __useUpsertCustomFieldMutation__
 *
 * To run a mutation, you first call `useUpsertCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCustomFieldMutation, { data, loading, error }] = useUpsertCustomFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCustomFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertCustomFieldMutation,
    UpsertCustomFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertCustomFieldMutation,
    UpsertCustomFieldMutationVariables
  >(UpsertCustomFieldDocument, options);
}
export type UpsertCustomFieldMutationHookResult = ReturnType<
  typeof useUpsertCustomFieldMutation
>;
export type UpsertCustomFieldMutationResult =
  Apollo.MutationResult<UpsertCustomFieldMutation>;
export type UpsertCustomFieldMutationOptions = Apollo.BaseMutationOptions<
  UpsertCustomFieldMutation,
  UpsertCustomFieldMutationVariables
>;
export const RecentExpenseActivitiesDocument = gql`
  query RecentExpenseActivities($employeeId: String!) {
    recentExpenseActivities(employeeId: $employeeId) {
      ... on QueryRecentExpenseActivitiesSuccess {
        data {
          ... on Expense {
            amount
            transactionCategoryIconUrl
            merchantName
            transactionDate
          }
          ... on StipendExpense {
            amount
            transactionCategoryIconUrl
            stipendName
            transactionDate
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useRecentExpenseActivitiesQuery__
 *
 * To run a query within a React component, call `useRecentExpenseActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentExpenseActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentExpenseActivitiesQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useRecentExpenseActivitiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    RecentExpenseActivitiesQuery,
    RecentExpenseActivitiesQueryVariables
  > &
    (
      | { variables: RecentExpenseActivitiesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RecentExpenseActivitiesQuery,
    RecentExpenseActivitiesQueryVariables
  >(RecentExpenseActivitiesDocument, options);
}
export function useRecentExpenseActivitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecentExpenseActivitiesQuery,
    RecentExpenseActivitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RecentExpenseActivitiesQuery,
    RecentExpenseActivitiesQueryVariables
  >(RecentExpenseActivitiesDocument, options);
}
export function useRecentExpenseActivitiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RecentExpenseActivitiesQuery,
    RecentExpenseActivitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RecentExpenseActivitiesQuery,
    RecentExpenseActivitiesQueryVariables
  >(RecentExpenseActivitiesDocument, options);
}
export type RecentExpenseActivitiesQueryHookResult = ReturnType<
  typeof useRecentExpenseActivitiesQuery
>;
export type RecentExpenseActivitiesLazyQueryHookResult = ReturnType<
  typeof useRecentExpenseActivitiesLazyQuery
>;
export type RecentExpenseActivitiesSuspenseQueryHookResult = ReturnType<
  typeof useRecentExpenseActivitiesSuspenseQuery
>;
export type RecentExpenseActivitiesQueryResult = Apollo.QueryResult<
  RecentExpenseActivitiesQuery,
  RecentExpenseActivitiesQueryVariables
>;
export const AdminExpenseCategoriesDocument = gql`
  query AdminExpenseCategories {
    adminExpenseCategories {
      ... on QueryAdminExpenseCategoriesSuccess {
        data {
          categories {
            id
            categoryName
            isShown
            glAccount
            uuid
            updatedAt
            createdAt
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useAdminExpenseCategoriesQuery__
 *
 * To run a query within a React component, call `useAdminExpenseCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminExpenseCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminExpenseCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminExpenseCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminExpenseCategoriesQuery,
    AdminExpenseCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminExpenseCategoriesQuery,
    AdminExpenseCategoriesQueryVariables
  >(AdminExpenseCategoriesDocument, options);
}
export function useAdminExpenseCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminExpenseCategoriesQuery,
    AdminExpenseCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminExpenseCategoriesQuery,
    AdminExpenseCategoriesQueryVariables
  >(AdminExpenseCategoriesDocument, options);
}
export function useAdminExpenseCategoriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminExpenseCategoriesQuery,
    AdminExpenseCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminExpenseCategoriesQuery,
    AdminExpenseCategoriesQueryVariables
  >(AdminExpenseCategoriesDocument, options);
}
export type AdminExpenseCategoriesQueryHookResult = ReturnType<
  typeof useAdminExpenseCategoriesQuery
>;
export type AdminExpenseCategoriesLazyQueryHookResult = ReturnType<
  typeof useAdminExpenseCategoriesLazyQuery
>;
export type AdminExpenseCategoriesSuspenseQueryHookResult = ReturnType<
  typeof useAdminExpenseCategoriesSuspenseQuery
>;
export type AdminExpenseCategoriesQueryResult = Apollo.QueryResult<
  AdminExpenseCategoriesQuery,
  AdminExpenseCategoriesQueryVariables
>;
export const VisibleExpenseCategoriesDocument = gql`
  query VisibleExpenseCategories {
    visibleExpenseCategories {
      ... on QueryVisibleExpenseCategoriesSuccess {
        data {
          categories {
            id
            categoryName
            uuid
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useVisibleExpenseCategoriesQuery__
 *
 * To run a query within a React component, call `useVisibleExpenseCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisibleExpenseCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisibleExpenseCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useVisibleExpenseCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    VisibleExpenseCategoriesQuery,
    VisibleExpenseCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    VisibleExpenseCategoriesQuery,
    VisibleExpenseCategoriesQueryVariables
  >(VisibleExpenseCategoriesDocument, options);
}
export function useVisibleExpenseCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VisibleExpenseCategoriesQuery,
    VisibleExpenseCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    VisibleExpenseCategoriesQuery,
    VisibleExpenseCategoriesQueryVariables
  >(VisibleExpenseCategoriesDocument, options);
}
export function useVisibleExpenseCategoriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VisibleExpenseCategoriesQuery,
    VisibleExpenseCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    VisibleExpenseCategoriesQuery,
    VisibleExpenseCategoriesQueryVariables
  >(VisibleExpenseCategoriesDocument, options);
}
export type VisibleExpenseCategoriesQueryHookResult = ReturnType<
  typeof useVisibleExpenseCategoriesQuery
>;
export type VisibleExpenseCategoriesLazyQueryHookResult = ReturnType<
  typeof useVisibleExpenseCategoriesLazyQuery
>;
export type VisibleExpenseCategoriesSuspenseQueryHookResult = ReturnType<
  typeof useVisibleExpenseCategoriesSuspenseQuery
>;
export type VisibleExpenseCategoriesQueryResult = Apollo.QueryResult<
  VisibleExpenseCategoriesQuery,
  VisibleExpenseCategoriesQueryVariables
>;
export const ExpensePoliciesDocument = gql`
  query ExpensePolicies {
    expensePolicies {
      ... on QueryExpensePoliciesSuccess {
        data {
          policies {
            id
            name
            uuid
            policy
            isActive
            departmentIds
            departments {
              name
              id
              uuid
            }
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useExpensePoliciesQuery__
 *
 * To run a query within a React component, call `useExpensePoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpensePoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpensePoliciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useExpensePoliciesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ExpensePoliciesQuery,
    ExpensePoliciesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExpensePoliciesQuery, ExpensePoliciesQueryVariables>(
    ExpensePoliciesDocument,
    options,
  );
}
export function useExpensePoliciesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExpensePoliciesQuery,
    ExpensePoliciesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExpensePoliciesQuery,
    ExpensePoliciesQueryVariables
  >(ExpensePoliciesDocument, options);
}
export function useExpensePoliciesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExpensePoliciesQuery,
    ExpensePoliciesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExpensePoliciesQuery,
    ExpensePoliciesQueryVariables
  >(ExpensePoliciesDocument, options);
}
export type ExpensePoliciesQueryHookResult = ReturnType<
  typeof useExpensePoliciesQuery
>;
export type ExpensePoliciesLazyQueryHookResult = ReturnType<
  typeof useExpensePoliciesLazyQuery
>;
export type ExpensePoliciesSuspenseQueryHookResult = ReturnType<
  typeof useExpensePoliciesSuspenseQuery
>;
export type ExpensePoliciesQueryResult = Apollo.QueryResult<
  ExpensePoliciesQuery,
  ExpensePoliciesQueryVariables
>;
export const OrganizationUsersDocument = gql`
  query OrganizationUsers(
    $offset: Int
    $pageSize: Int
    $name: String
    $departmentIds: [Int!]
    $exceptUserIds: [String!]
  ) {
    organizationUsers(
      pagination: { offset: $offset, pageSize: $pageSize }
      filters: {
        name: $name
        departmentIds: $departmentIds
        exceptUserIds: $exceptUserIds
      }
    ) {
      ... on QueryOrganizationUsersSuccess {
        data {
          hasMore
          nextPageOffset
          users {
            userId
            employee {
              employeeId
              workEmail
              status
              displayStatus
              department {
                name
              }
              manager {
                firstName
                lastName
                displayName
              }
            }
            displayName
            employeeDisplayRole
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationUsersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      pageSize: // value for 'pageSize'
 *      name: // value for 'name'
 *      departmentIds: // value for 'departmentIds'
 *      exceptUserIds: // value for 'exceptUserIds'
 *   },
 * });
 */
export function useOrganizationUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OrganizationUsersQuery,
    OrganizationUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OrganizationUsersQuery,
    OrganizationUsersQueryVariables
  >(OrganizationUsersDocument, options);
}
export function useOrganizationUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrganizationUsersQuery,
    OrganizationUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OrganizationUsersQuery,
    OrganizationUsersQueryVariables
  >(OrganizationUsersDocument, options);
}
export function useOrganizationUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OrganizationUsersQuery,
    OrganizationUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OrganizationUsersQuery,
    OrganizationUsersQueryVariables
  >(OrganizationUsersDocument, options);
}
export type OrganizationUsersQueryHookResult = ReturnType<
  typeof useOrganizationUsersQuery
>;
export type OrganizationUsersLazyQueryHookResult = ReturnType<
  typeof useOrganizationUsersLazyQuery
>;
export type OrganizationUsersSuspenseQueryHookResult = ReturnType<
  typeof useOrganizationUsersSuspenseQuery
>;
export type OrganizationUsersQueryResult = Apollo.QueryResult<
  OrganizationUsersQuery,
  OrganizationUsersQueryVariables
>;
export const OrganizationUserDocument = gql`
  query OrganizationUser($userId: String!) {
    organizationUser(userId: $userId) {
      ... on QueryOrganizationUserSuccess {
        data {
          displayName
          firstName
          lastName
          employeeDisplayRole
          employee {
            manager {
              userId
              firstName
              lastName
              employee {
                employeeId
              }
            }
            status
            displayStatus
            employmentStartDate
            department {
              name
              id
            }
            workEmail
          }
          roles
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useOrganizationUserQuery__
 *
 * To run a query within a React component, call `useOrganizationUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useOrganizationUserQuery(
  baseOptions: Apollo.QueryHookOptions<
    OrganizationUserQuery,
    OrganizationUserQueryVariables
  > &
    (
      | { variables: OrganizationUserQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OrganizationUserQuery, OrganizationUserQueryVariables>(
    OrganizationUserDocument,
    options,
  );
}
export function useOrganizationUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrganizationUserQuery,
    OrganizationUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OrganizationUserQuery,
    OrganizationUserQueryVariables
  >(OrganizationUserDocument, options);
}
export function useOrganizationUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OrganizationUserQuery,
    OrganizationUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OrganizationUserQuery,
    OrganizationUserQueryVariables
  >(OrganizationUserDocument, options);
}
export type OrganizationUserQueryHookResult = ReturnType<
  typeof useOrganizationUserQuery
>;
export type OrganizationUserLazyQueryHookResult = ReturnType<
  typeof useOrganizationUserLazyQuery
>;
export type OrganizationUserSuspenseQueryHookResult = ReturnType<
  typeof useOrganizationUserSuspenseQuery
>;
export type OrganizationUserQueryResult = Apollo.QueryResult<
  OrganizationUserQuery,
  OrganizationUserQueryVariables
>;
export const AdminAwxOrganizationStateDocument = gql`
  query AdminAwxOrganizationState {
    awxOrganizationState {
      ... on QueryAwxOrganizationStateSuccess {
        data {
          connectedAccountId
          connectedAccountStatus
          createdAt
          linkedAccountId
          linkedAccountStatus
          organizationId
          rfiStatus
          isEligibleToAddBeneficiary
          updatedAt
        }
      }
    }
  }
`;

/**
 * __useAdminAwxOrganizationStateQuery__
 *
 * To run a query within a React component, call `useAdminAwxOrganizationStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminAwxOrganizationStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminAwxOrganizationStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminAwxOrganizationStateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminAwxOrganizationStateQuery,
    AdminAwxOrganizationStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminAwxOrganizationStateQuery,
    AdminAwxOrganizationStateQueryVariables
  >(AdminAwxOrganizationStateDocument, options);
}
export function useAdminAwxOrganizationStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminAwxOrganizationStateQuery,
    AdminAwxOrganizationStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminAwxOrganizationStateQuery,
    AdminAwxOrganizationStateQueryVariables
  >(AdminAwxOrganizationStateDocument, options);
}
export function useAdminAwxOrganizationStateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminAwxOrganizationStateQuery,
    AdminAwxOrganizationStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminAwxOrganizationStateQuery,
    AdminAwxOrganizationStateQueryVariables
  >(AdminAwxOrganizationStateDocument, options);
}
export type AdminAwxOrganizationStateQueryHookResult = ReturnType<
  typeof useAdminAwxOrganizationStateQuery
>;
export type AdminAwxOrganizationStateLazyQueryHookResult = ReturnType<
  typeof useAdminAwxOrganizationStateLazyQuery
>;
export type AdminAwxOrganizationStateSuspenseQueryHookResult = ReturnType<
  typeof useAdminAwxOrganizationStateSuspenseQuery
>;
export type AdminAwxOrganizationStateQueryResult = Apollo.QueryResult<
  AdminAwxOrganizationStateQuery,
  AdminAwxOrganizationStateQueryVariables
>;
export const AchPlaidAuthLinkTokenDocument = gql`
  query ACHPlaidAuthLinkToken {
    achAuthLinkToken {
      ... on QueryAchAuthLinkTokenSuccess {
        data
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useAchPlaidAuthLinkTokenQuery__
 *
 * To run a query within a React component, call `useAchPlaidAuthLinkTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useAchPlaidAuthLinkTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAchPlaidAuthLinkTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useAchPlaidAuthLinkTokenQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AchPlaidAuthLinkTokenQuery,
    AchPlaidAuthLinkTokenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AchPlaidAuthLinkTokenQuery,
    AchPlaidAuthLinkTokenQueryVariables
  >(AchPlaidAuthLinkTokenDocument, options);
}
export function useAchPlaidAuthLinkTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AchPlaidAuthLinkTokenQuery,
    AchPlaidAuthLinkTokenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AchPlaidAuthLinkTokenQuery,
    AchPlaidAuthLinkTokenQueryVariables
  >(AchPlaidAuthLinkTokenDocument, options);
}
export function useAchPlaidAuthLinkTokenSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AchPlaidAuthLinkTokenQuery,
    AchPlaidAuthLinkTokenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AchPlaidAuthLinkTokenQuery,
    AchPlaidAuthLinkTokenQueryVariables
  >(AchPlaidAuthLinkTokenDocument, options);
}
export type AchPlaidAuthLinkTokenQueryHookResult = ReturnType<
  typeof useAchPlaidAuthLinkTokenQuery
>;
export type AchPlaidAuthLinkTokenLazyQueryHookResult = ReturnType<
  typeof useAchPlaidAuthLinkTokenLazyQuery
>;
export type AchPlaidAuthLinkTokenSuspenseQueryHookResult = ReturnType<
  typeof useAchPlaidAuthLinkTokenSuspenseQuery
>;
export type AchPlaidAuthLinkTokenQueryResult = Apollo.QueryResult<
  AchPlaidAuthLinkTokenQuery,
  AchPlaidAuthLinkTokenQueryVariables
>;
export const AdminDepartmentsDocument = gql`
  query AdminDepartments {
    departments {
      ... on QueryDepartmentsSuccess {
        data {
          departments {
            name
            id
            displaySpendThisMonth
            displaySubtitle
            uuid
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useAdminDepartmentsQuery__
 *
 * To run a query within a React component, call `useAdminDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminDepartmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminDepartmentsQuery,
    AdminDepartmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminDepartmentsQuery, AdminDepartmentsQueryVariables>(
    AdminDepartmentsDocument,
    options,
  );
}
export function useAdminDepartmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminDepartmentsQuery,
    AdminDepartmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminDepartmentsQuery,
    AdminDepartmentsQueryVariables
  >(AdminDepartmentsDocument, options);
}
export function useAdminDepartmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminDepartmentsQuery,
    AdminDepartmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminDepartmentsQuery,
    AdminDepartmentsQueryVariables
  >(AdminDepartmentsDocument, options);
}
export type AdminDepartmentsQueryHookResult = ReturnType<
  typeof useAdminDepartmentsQuery
>;
export type AdminDepartmentsLazyQueryHookResult = ReturnType<
  typeof useAdminDepartmentsLazyQuery
>;
export type AdminDepartmentsSuspenseQueryHookResult = ReturnType<
  typeof useAdminDepartmentsSuspenseQuery
>;
export type AdminDepartmentsQueryResult = Apollo.QueryResult<
  AdminDepartmentsQuery,
  AdminDepartmentsQueryVariables
>;
export const ConnectedLinkedAccountDocument = gql`
  query ConnectedLinkedAccount {
    linkedAccount {
      ... on QueryLinkedAccountSuccess {
        data {
          awxLinkedAccount {
            status
            usBank {
              accountName
              accountNumberLastFour
            }
          }
          institutionName
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useConnectedLinkedAccountQuery__
 *
 * To run a query within a React component, call `useConnectedLinkedAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedLinkedAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedLinkedAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useConnectedLinkedAccountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConnectedLinkedAccountQuery,
    ConnectedLinkedAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConnectedLinkedAccountQuery,
    ConnectedLinkedAccountQueryVariables
  >(ConnectedLinkedAccountDocument, options);
}
export function useConnectedLinkedAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConnectedLinkedAccountQuery,
    ConnectedLinkedAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConnectedLinkedAccountQuery,
    ConnectedLinkedAccountQueryVariables
  >(ConnectedLinkedAccountDocument, options);
}
export function useConnectedLinkedAccountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ConnectedLinkedAccountQuery,
    ConnectedLinkedAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ConnectedLinkedAccountQuery,
    ConnectedLinkedAccountQueryVariables
  >(ConnectedLinkedAccountDocument, options);
}
export type ConnectedLinkedAccountQueryHookResult = ReturnType<
  typeof useConnectedLinkedAccountQuery
>;
export type ConnectedLinkedAccountLazyQueryHookResult = ReturnType<
  typeof useConnectedLinkedAccountLazyQuery
>;
export type ConnectedLinkedAccountSuspenseQueryHookResult = ReturnType<
  typeof useConnectedLinkedAccountSuspenseQuery
>;
export type ConnectedLinkedAccountQueryResult = Apollo.QueryResult<
  ConnectedLinkedAccountQuery,
  ConnectedLinkedAccountQueryVariables
>;
export const BeneficiaryDocument = gql`
  query Beneficiary {
    beneficiary {
      ... on QueryBeneficiarySuccess {
        data {
          nickname
          beneficiary {
            bankDetails {
              accountName
              accountNumberLastFour
              bankCountryCode
              localClearingSystem
            }
          }
        }
      }
    }
  }
`;

/**
 * __useBeneficiaryQuery__
 *
 * To run a query within a React component, call `useBeneficiaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeneficiaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeneficiaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useBeneficiaryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BeneficiaryQuery,
    BeneficiaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BeneficiaryQuery, BeneficiaryQueryVariables>(
    BeneficiaryDocument,
    options,
  );
}
export function useBeneficiaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BeneficiaryQuery,
    BeneficiaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BeneficiaryQuery, BeneficiaryQueryVariables>(
    BeneficiaryDocument,
    options,
  );
}
export function useBeneficiarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    BeneficiaryQuery,
    BeneficiaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<BeneficiaryQuery, BeneficiaryQueryVariables>(
    BeneficiaryDocument,
    options,
  );
}
export type BeneficiaryQueryHookResult = ReturnType<typeof useBeneficiaryQuery>;
export type BeneficiaryLazyQueryHookResult = ReturnType<
  typeof useBeneficiaryLazyQuery
>;
export type BeneficiarySuspenseQueryHookResult = ReturnType<
  typeof useBeneficiarySuspenseQuery
>;
export type BeneficiaryQueryResult = Apollo.QueryResult<
  BeneficiaryQuery,
  BeneficiaryQueryVariables
>;
export const ActiveEmployeeProfileRecommendationsDocument = gql`
  query ActiveEmployeeProfileRecommendations(
    $offset: Int
    $pageSize: Int
    $searchText: String
  ) {
    activeEmployeeProfileRecommendations(
      pagination: { offset: $offset, pageSize: $pageSize }
      searchText: $searchText
    ) {
      ... on QueryActiveEmployeeProfileRecommendationsSuccess {
        data {
          employees {
            id
            lastName
            firstName
            workEmail
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useActiveEmployeeProfileRecommendationsQuery__
 *
 * To run a query within a React component, call `useActiveEmployeeProfileRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveEmployeeProfileRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveEmployeeProfileRecommendationsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      pageSize: // value for 'pageSize'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useActiveEmployeeProfileRecommendationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ActiveEmployeeProfileRecommendationsQuery,
    ActiveEmployeeProfileRecommendationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ActiveEmployeeProfileRecommendationsQuery,
    ActiveEmployeeProfileRecommendationsQueryVariables
  >(ActiveEmployeeProfileRecommendationsDocument, options);
}
export function useActiveEmployeeProfileRecommendationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActiveEmployeeProfileRecommendationsQuery,
    ActiveEmployeeProfileRecommendationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ActiveEmployeeProfileRecommendationsQuery,
    ActiveEmployeeProfileRecommendationsQueryVariables
  >(ActiveEmployeeProfileRecommendationsDocument, options);
}
export function useActiveEmployeeProfileRecommendationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ActiveEmployeeProfileRecommendationsQuery,
    ActiveEmployeeProfileRecommendationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ActiveEmployeeProfileRecommendationsQuery,
    ActiveEmployeeProfileRecommendationsQueryVariables
  >(ActiveEmployeeProfileRecommendationsDocument, options);
}
export type ActiveEmployeeProfileRecommendationsQueryHookResult = ReturnType<
  typeof useActiveEmployeeProfileRecommendationsQuery
>;
export type ActiveEmployeeProfileRecommendationsLazyQueryHookResult =
  ReturnType<typeof useActiveEmployeeProfileRecommendationsLazyQuery>;
export type ActiveEmployeeProfileRecommendationsSuspenseQueryHookResult =
  ReturnType<typeof useActiveEmployeeProfileRecommendationsSuspenseQuery>;
export type ActiveEmployeeProfileRecommendationsQueryResult =
  Apollo.QueryResult<
    ActiveEmployeeProfileRecommendationsQuery,
    ActiveEmployeeProfileRecommendationsQueryVariables
  >;
export const CustomFieldsDocument = gql`
  query CustomFields($searchText: String, $state: [CustomFieldEntityState!]) {
    visibleCustomFields(filters: { searchText: $searchText, state: $state }) {
      ... on QueryVisibleCustomFieldsSuccess {
        data {
          customFields {
            createdAt
            id
            name
            organizationId
            parentEntityUuid
            state
            type
            updatedAt
            uuid
            listOptions {
              createdAt
              customFieldEntityId
              id
              isDeleted
              name
              parentFieldOptionUuid
              updatedAt
              uuid
              value
            }
          }
        }
      }
    }
  }
`;

/**
 * __useCustomFieldsQuery__
 *
 * To run a query within a React component, call `useCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomFieldsQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useCustomFieldsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomFieldsQuery,
    CustomFieldsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CustomFieldsQuery, CustomFieldsQueryVariables>(
    CustomFieldsDocument,
    options,
  );
}
export function useCustomFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomFieldsQuery,
    CustomFieldsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CustomFieldsQuery, CustomFieldsQueryVariables>(
    CustomFieldsDocument,
    options,
  );
}
export function useCustomFieldsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CustomFieldsQuery,
    CustomFieldsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CustomFieldsQuery, CustomFieldsQueryVariables>(
    CustomFieldsDocument,
    options,
  );
}
export type CustomFieldsQueryHookResult = ReturnType<
  typeof useCustomFieldsQuery
>;
export type CustomFieldsLazyQueryHookResult = ReturnType<
  typeof useCustomFieldsLazyQuery
>;
export type CustomFieldsSuspenseQueryHookResult = ReturnType<
  typeof useCustomFieldsSuspenseQuery
>;
export type CustomFieldsQueryResult = Apollo.QueryResult<
  CustomFieldsQuery,
  CustomFieldsQueryVariables
>;
export const CustomFieldListOptionsDocument = gql`
  query CustomFieldListOptions(
    $customFieldEntityId: Int!
    $searchText: String
    $parentFieldOptionUuid: String
  ) {
    customFieldVisibleListOptions(
      customFieldEntityId: $customFieldEntityId
      filters: {
        parentFieldOptionUuid: $parentFieldOptionUuid
        searchText: $searchText
      }
    ) {
      ... on QueryCustomFieldVisibleListOptionsSuccess {
        data {
          listOptions {
            createdAt
            customFieldEntityId
            id
            isDeleted
            name
            parentFieldOptionUuid
            updatedAt
            uuid
            value
          }
        }
      }
    }
  }
`;

/**
 * __useCustomFieldListOptionsQuery__
 *
 * To run a query within a React component, call `useCustomFieldListOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldListOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomFieldListOptionsQuery({
 *   variables: {
 *      customFieldEntityId: // value for 'customFieldEntityId'
 *      searchText: // value for 'searchText'
 *      parentFieldOptionUuid: // value for 'parentFieldOptionUuid'
 *   },
 * });
 */
export function useCustomFieldListOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CustomFieldListOptionsQuery,
    CustomFieldListOptionsQueryVariables
  > &
    (
      | { variables: CustomFieldListOptionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomFieldListOptionsQuery,
    CustomFieldListOptionsQueryVariables
  >(CustomFieldListOptionsDocument, options);
}
export function useCustomFieldListOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomFieldListOptionsQuery,
    CustomFieldListOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomFieldListOptionsQuery,
    CustomFieldListOptionsQueryVariables
  >(CustomFieldListOptionsDocument, options);
}
export function useCustomFieldListOptionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CustomFieldListOptionsQuery,
    CustomFieldListOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CustomFieldListOptionsQuery,
    CustomFieldListOptionsQueryVariables
  >(CustomFieldListOptionsDocument, options);
}
export type CustomFieldListOptionsQueryHookResult = ReturnType<
  typeof useCustomFieldListOptionsQuery
>;
export type CustomFieldListOptionsLazyQueryHookResult = ReturnType<
  typeof useCustomFieldListOptionsLazyQuery
>;
export type CustomFieldListOptionsSuspenseQueryHookResult = ReturnType<
  typeof useCustomFieldListOptionsSuspenseQuery
>;
export type CustomFieldListOptionsQueryResult = Apollo.QueryResult<
  CustomFieldListOptionsQuery,
  CustomFieldListOptionsQueryVariables
>;
export const AdminCustomFieldsDocument = gql`
  query AdminCustomFields($searchText: String) {
    adminCustomFields(filters: { searchText: $searchText }) {
      ... on QueryAdminCustomFieldsSuccess {
        data {
          customFields {
            createdAt
            id
            name
            organizationId
            parentEntityUuid
            state
            type
            updatedAt
            uuid
            listOptions {
              createdAt
              customFieldEntityId
              id
              isDeleted
              name
              parentFieldOptionUuid
              updatedAt
              uuid
              value
            }
          }
        }
      }
    }
  }
`;

/**
 * __useAdminCustomFieldsQuery__
 *
 * To run a query within a React component, call `useAdminCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCustomFieldsQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useAdminCustomFieldsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminCustomFieldsQuery,
    AdminCustomFieldsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminCustomFieldsQuery,
    AdminCustomFieldsQueryVariables
  >(AdminCustomFieldsDocument, options);
}
export function useAdminCustomFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminCustomFieldsQuery,
    AdminCustomFieldsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminCustomFieldsQuery,
    AdminCustomFieldsQueryVariables
  >(AdminCustomFieldsDocument, options);
}
export function useAdminCustomFieldsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminCustomFieldsQuery,
    AdminCustomFieldsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminCustomFieldsQuery,
    AdminCustomFieldsQueryVariables
  >(AdminCustomFieldsDocument, options);
}
export type AdminCustomFieldsQueryHookResult = ReturnType<
  typeof useAdminCustomFieldsQuery
>;
export type AdminCustomFieldsLazyQueryHookResult = ReturnType<
  typeof useAdminCustomFieldsLazyQuery
>;
export type AdminCustomFieldsSuspenseQueryHookResult = ReturnType<
  typeof useAdminCustomFieldsSuspenseQuery
>;
export type AdminCustomFieldsQueryResult = Apollo.QueryResult<
  AdminCustomFieldsQuery,
  AdminCustomFieldsQueryVariables
>;
export const AdminCustomFieldListOptionsDocument = gql`
  query AdminCustomFieldListOptions(
    $customFieldEntityId: Int!
    $searchText: String
  ) {
    adminCustomFieldListOptions(
      customFieldEntityId: $customFieldEntityId
      filters: { searchText: $searchText }
    ) {
      ... on QueryAdminCustomFieldListOptionsSuccess {
        data {
          listOptions {
            createdAt
            customFieldEntityId
            id
            isDeleted
            name
            parentFieldOptionUuid
            updatedAt
            uuid
            value
          }
        }
      }
    }
  }
`;

/**
 * __useAdminCustomFieldListOptionsQuery__
 *
 * To run a query within a React component, call `useAdminCustomFieldListOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCustomFieldListOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCustomFieldListOptionsQuery({
 *   variables: {
 *      customFieldEntityId: // value for 'customFieldEntityId'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useAdminCustomFieldListOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminCustomFieldListOptionsQuery,
    AdminCustomFieldListOptionsQueryVariables
  > &
    (
      | { variables: AdminCustomFieldListOptionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminCustomFieldListOptionsQuery,
    AdminCustomFieldListOptionsQueryVariables
  >(AdminCustomFieldListOptionsDocument, options);
}
export function useAdminCustomFieldListOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminCustomFieldListOptionsQuery,
    AdminCustomFieldListOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminCustomFieldListOptionsQuery,
    AdminCustomFieldListOptionsQueryVariables
  >(AdminCustomFieldListOptionsDocument, options);
}
export function useAdminCustomFieldListOptionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminCustomFieldListOptionsQuery,
    AdminCustomFieldListOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminCustomFieldListOptionsQuery,
    AdminCustomFieldListOptionsQueryVariables
  >(AdminCustomFieldListOptionsDocument, options);
}
export type AdminCustomFieldListOptionsQueryHookResult = ReturnType<
  typeof useAdminCustomFieldListOptionsQuery
>;
export type AdminCustomFieldListOptionsLazyQueryHookResult = ReturnType<
  typeof useAdminCustomFieldListOptionsLazyQuery
>;
export type AdminCustomFieldListOptionsSuspenseQueryHookResult = ReturnType<
  typeof useAdminCustomFieldListOptionsSuspenseQuery
>;
export type AdminCustomFieldListOptionsQueryResult = Apollo.QueryResult<
  AdminCustomFieldListOptionsQuery,
  AdminCustomFieldListOptionsQueryVariables
>;
export const ProcessExpenseReportDownloadAndGetUrlDocument = gql`
  mutation ProcessExpenseReportDownloadAndGetUrl(
    $filters: AdminExpenseReportFilterInput
  ) {
    processExpenseReportDownloadAndGetUrl(filters: $filters) {
      ... on MutationProcessExpenseReportDownloadAndGetUrlSuccess {
        data
      }
      ... on Error {
        message
      }
    }
  }
`;
export type ProcessExpenseReportDownloadAndGetUrlMutationFn =
  Apollo.MutationFunction<
    ProcessExpenseReportDownloadAndGetUrlMutation,
    ProcessExpenseReportDownloadAndGetUrlMutationVariables
  >;

/**
 * __useProcessExpenseReportDownloadAndGetUrlMutation__
 *
 * To run a mutation, you first call `useProcessExpenseReportDownloadAndGetUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessExpenseReportDownloadAndGetUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processExpenseReportDownloadAndGetUrlMutation, { data, loading, error }] = useProcessExpenseReportDownloadAndGetUrlMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProcessExpenseReportDownloadAndGetUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ProcessExpenseReportDownloadAndGetUrlMutation,
    ProcessExpenseReportDownloadAndGetUrlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ProcessExpenseReportDownloadAndGetUrlMutation,
    ProcessExpenseReportDownloadAndGetUrlMutationVariables
  >(ProcessExpenseReportDownloadAndGetUrlDocument, options);
}
export type ProcessExpenseReportDownloadAndGetUrlMutationHookResult =
  ReturnType<typeof useProcessExpenseReportDownloadAndGetUrlMutation>;
export type ProcessExpenseReportDownloadAndGetUrlMutationResult =
  Apollo.MutationResult<ProcessExpenseReportDownloadAndGetUrlMutation>;
export type ProcessExpenseReportDownloadAndGetUrlMutationOptions =
  Apollo.BaseMutationOptions<
    ProcessExpenseReportDownloadAndGetUrlMutation,
    ProcessExpenseReportDownloadAndGetUrlMutationVariables
  >;
export const SubmitStipendExpenseDocument = gql`
  mutation SubmitStipendExpense(
    $stipendWalletId: Int!
    $notes: String
    $amount: Float!
    $merchantName: String!
    $transactionDate: Date!
    $receiptFileData: String
  ) {
    submitStipendExpenseV2(
      input: {
        amount: $amount
        merchantName: $merchantName
        notes: $notes
        transactionDate: $transactionDate
      }
      receiptFileData: $receiptFileData
      stipendWalletId: $stipendWalletId
    ) {
      ... on MutationSubmitStipendExpenseV2Success {
        data {
          ... on SubmittedStipendExpenseResult {
            autoApprovalMetadata {
              isAutoApproved
              reason
            }
            expense {
              stipendWalletId
              stipendExpenseId
            }
          }
          ... on StipendExpensePolicyCheckerResult {
            reason
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
export type SubmitStipendExpenseMutationFn = Apollo.MutationFunction<
  SubmitStipendExpenseMutation,
  SubmitStipendExpenseMutationVariables
>;

/**
 * __useSubmitStipendExpenseMutation__
 *
 * To run a mutation, you first call `useSubmitStipendExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitStipendExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitStipendExpenseMutation, { data, loading, error }] = useSubmitStipendExpenseMutation({
 *   variables: {
 *      stipendWalletId: // value for 'stipendWalletId'
 *      notes: // value for 'notes'
 *      amount: // value for 'amount'
 *      merchantName: // value for 'merchantName'
 *      transactionDate: // value for 'transactionDate'
 *      receiptFileData: // value for 'receiptFileData'
 *   },
 * });
 */
export function useSubmitStipendExpenseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitStipendExpenseMutation,
    SubmitStipendExpenseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitStipendExpenseMutation,
    SubmitStipendExpenseMutationVariables
  >(SubmitStipendExpenseDocument, options);
}
export type SubmitStipendExpenseMutationHookResult = ReturnType<
  typeof useSubmitStipendExpenseMutation
>;
export type SubmitStipendExpenseMutationResult =
  Apollo.MutationResult<SubmitStipendExpenseMutation>;
export type SubmitStipendExpenseMutationOptions = Apollo.BaseMutationOptions<
  SubmitStipendExpenseMutation,
  SubmitStipendExpenseMutationVariables
>;
export const ApproveOrRejectStipendExpenseDocument = gql`
  mutation approveOrRejectStipendExpense(
    $stipendExpenseId: String!
    $isApproved: Boolean!
    $employeeId: String!
    $employerNotes: String
  ) {
    approveOrRejectStipendExpense(
      stipendExpenseId: $stipendExpenseId
      isApproved: $isApproved
      employeeId: $employeeId
      employerNotes: $employerNotes
    ) {
      ... on MutationApproveOrRejectStipendExpenseSuccess {
        data {
          stipendExpenseId
          status
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
export type ApproveOrRejectStipendExpenseMutationFn = Apollo.MutationFunction<
  ApproveOrRejectStipendExpenseMutation,
  ApproveOrRejectStipendExpenseMutationVariables
>;

/**
 * __useApproveOrRejectStipendExpenseMutation__
 *
 * To run a mutation, you first call `useApproveOrRejectStipendExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveOrRejectStipendExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveOrRejectStipendExpenseMutation, { data, loading, error }] = useApproveOrRejectStipendExpenseMutation({
 *   variables: {
 *      stipendExpenseId: // value for 'stipendExpenseId'
 *      isApproved: // value for 'isApproved'
 *      employeeId: // value for 'employeeId'
 *      employerNotes: // value for 'employerNotes'
 *   },
 * });
 */
export function useApproveOrRejectStipendExpenseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApproveOrRejectStipendExpenseMutation,
    ApproveOrRejectStipendExpenseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApproveOrRejectStipendExpenseMutation,
    ApproveOrRejectStipendExpenseMutationVariables
  >(ApproveOrRejectStipendExpenseDocument, options);
}
export type ApproveOrRejectStipendExpenseMutationHookResult = ReturnType<
  typeof useApproveOrRejectStipendExpenseMutation
>;
export type ApproveOrRejectStipendExpenseMutationResult =
  Apollo.MutationResult<ApproveOrRejectStipendExpenseMutation>;
export type ApproveOrRejectStipendExpenseMutationOptions =
  Apollo.BaseMutationOptions<
    ApproveOrRejectStipendExpenseMutation,
    ApproveOrRejectStipendExpenseMutationVariables
  >;
export const CreateStipendRuleDocument = gql`
  mutation CreateStipendRule($input: CreateStipendRuleInput!) {
    createStipendRule(input: $input) {
      ... on MutationCreateStipendRuleSuccess {
        data {
          name
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
export type CreateStipendRuleMutationFn = Apollo.MutationFunction<
  CreateStipendRuleMutation,
  CreateStipendRuleMutationVariables
>;

/**
 * __useCreateStipendRuleMutation__
 *
 * To run a mutation, you first call `useCreateStipendRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStipendRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStipendRuleMutation, { data, loading, error }] = useCreateStipendRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStipendRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateStipendRuleMutation,
    CreateStipendRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateStipendRuleMutation,
    CreateStipendRuleMutationVariables
  >(CreateStipendRuleDocument, options);
}
export type CreateStipendRuleMutationHookResult = ReturnType<
  typeof useCreateStipendRuleMutation
>;
export type CreateStipendRuleMutationResult =
  Apollo.MutationResult<CreateStipendRuleMutation>;
export type CreateStipendRuleMutationOptions = Apollo.BaseMutationOptions<
  CreateStipendRuleMutation,
  CreateStipendRuleMutationVariables
>;
export const UpdateStipendRuleDocument = gql`
  mutation UpdateStipendRule(
    $input: UpdateStipendRuleInput!
    $stipendRuleId: Int!
  ) {
    updateStipendRule(input: $input, stipendRuleId: $stipendRuleId) {
      ... on MutationUpdateStipendRuleSuccess {
        data {
          name
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
export type UpdateStipendRuleMutationFn = Apollo.MutationFunction<
  UpdateStipendRuleMutation,
  UpdateStipendRuleMutationVariables
>;

/**
 * __useUpdateStipendRuleMutation__
 *
 * To run a mutation, you first call `useUpdateStipendRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStipendRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStipendRuleMutation, { data, loading, error }] = useUpdateStipendRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *      stipendRuleId: // value for 'stipendRuleId'
 *   },
 * });
 */
export function useUpdateStipendRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateStipendRuleMutation,
    UpdateStipendRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateStipendRuleMutation,
    UpdateStipendRuleMutationVariables
  >(UpdateStipendRuleDocument, options);
}
export type UpdateStipendRuleMutationHookResult = ReturnType<
  typeof useUpdateStipendRuleMutation
>;
export type UpdateStipendRuleMutationResult =
  Apollo.MutationResult<UpdateStipendRuleMutation>;
export type UpdateStipendRuleMutationOptions = Apollo.BaseMutationOptions<
  UpdateStipendRuleMutation,
  UpdateStipendRuleMutationVariables
>;
export const ValidateStipendRuleDocument = gql`
  mutation ValidateStipendRule($input: CreateStipendRuleInput!) {
    validateStipendRule(input: $input) {
      ... on MutationValidateStipendRuleSuccess {
        data {
          isValid
          message
        }
      }
      ... on Error {
        message
      }
    }
  }
`;
export type ValidateStipendRuleMutationFn = Apollo.MutationFunction<
  ValidateStipendRuleMutation,
  ValidateStipendRuleMutationVariables
>;

/**
 * __useValidateStipendRuleMutation__
 *
 * To run a mutation, you first call `useValidateStipendRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateStipendRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateStipendRuleMutation, { data, loading, error }] = useValidateStipendRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateStipendRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateStipendRuleMutation,
    ValidateStipendRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateStipendRuleMutation,
    ValidateStipendRuleMutationVariables
  >(ValidateStipendRuleDocument, options);
}
export type ValidateStipendRuleMutationHookResult = ReturnType<
  typeof useValidateStipendRuleMutation
>;
export type ValidateStipendRuleMutationResult =
  Apollo.MutationResult<ValidateStipendRuleMutation>;
export type ValidateStipendRuleMutationOptions = Apollo.BaseMutationOptions<
  ValidateStipendRuleMutation,
  ValidateStipendRuleMutationVariables
>;
export const StipendWalletsDocument = gql`
  query StipendWallets($filters: StipendWalletsFilterInput) {
    stipendWallets(filters: $filters) {
      ... on QueryStipendWalletsSuccess {
        data {
          wallets {
            id
            createdAt
            startsAt
            expiresAt
            expenses {
              user {
                firstName
                lastName
              }
              approvedOrRejectedBy {
                displayName
              }
              stipendExpenseId
              amount
              transactionDate
              createdAt
              merchantName
              notes
              displayPayoutMethod
              status
              stipendName
              stipendWalletId
              transactionDate
              receiptFileUrl
              isAutoApproved
              employerNotes
              designatedApprover {
                displayName
              }
            }
            pendingBalance
            remainingBalance
            startingBalance
            stipendDetail {
              category
              createdAt
              cycleStartDate
              cycleEndDate
              frequency
              id
              isBalanceForwardable
              isSingleUsage
              longDetails
              isEnabled
              name
              terms
            }
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useStipendWalletsQuery__
 *
 * To run a query within a React component, call `useStipendWalletsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStipendWalletsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStipendWalletsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useStipendWalletsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StipendWalletsQuery,
    StipendWalletsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StipendWalletsQuery, StipendWalletsQueryVariables>(
    StipendWalletsDocument,
    options,
  );
}
export function useStipendWalletsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StipendWalletsQuery,
    StipendWalletsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StipendWalletsQuery, StipendWalletsQueryVariables>(
    StipendWalletsDocument,
    options,
  );
}
export function useStipendWalletsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    StipendWalletsQuery,
    StipendWalletsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    StipendWalletsQuery,
    StipendWalletsQueryVariables
  >(StipendWalletsDocument, options);
}
export type StipendWalletsQueryHookResult = ReturnType<
  typeof useStipendWalletsQuery
>;
export type StipendWalletsLazyQueryHookResult = ReturnType<
  typeof useStipendWalletsLazyQuery
>;
export type StipendWalletsSuspenseQueryHookResult = ReturnType<
  typeof useStipendWalletsSuspenseQuery
>;
export type StipendWalletsQueryResult = Apollo.QueryResult<
  StipendWalletsQuery,
  StipendWalletsQueryVariables
>;
export const StipendExpensesByViewDocument = gql`
  query StipendExpensesByView(
    $stipendExpenseStatus: [StipendExpenseStatus!]
    $offset: Int!
    $pageSize: Int!
  ) {
    stipendExpensesByView(
      filters: { stipendExpenseStatus: $stipendExpenseStatus }
      pagination: { offset: $offset, pageSize: $pageSize }
    ) {
      ... on QueryStipendExpensesByViewSuccess {
        data {
          hasMore
          nextPageOffset
          stipendExpenses {
            stipendExpenseId
            merchantName
            transactionDate
            amount
            receiptFileUrl
            stipendName
            notes
            status
            stipendName
            employeeId
            isAutoApproved
            designatedApprover {
              displayName
            }
            user {
              firstName
              lastName
            }
            displayPayoutMethod
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useStipendExpensesByViewQuery__
 *
 * To run a query within a React component, call `useStipendExpensesByViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useStipendExpensesByViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStipendExpensesByViewQuery({
 *   variables: {
 *      stipendExpenseStatus: // value for 'stipendExpenseStatus'
 *      offset: // value for 'offset'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useStipendExpensesByViewQuery(
  baseOptions: Apollo.QueryHookOptions<
    StipendExpensesByViewQuery,
    StipendExpensesByViewQueryVariables
  > &
    (
      | { variables: StipendExpensesByViewQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    StipendExpensesByViewQuery,
    StipendExpensesByViewQueryVariables
  >(StipendExpensesByViewDocument, options);
}
export function useStipendExpensesByViewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StipendExpensesByViewQuery,
    StipendExpensesByViewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    StipendExpensesByViewQuery,
    StipendExpensesByViewQueryVariables
  >(StipendExpensesByViewDocument, options);
}
export function useStipendExpensesByViewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    StipendExpensesByViewQuery,
    StipendExpensesByViewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    StipendExpensesByViewQuery,
    StipendExpensesByViewQueryVariables
  >(StipendExpensesByViewDocument, options);
}
export type StipendExpensesByViewQueryHookResult = ReturnType<
  typeof useStipendExpensesByViewQuery
>;
export type StipendExpensesByViewLazyQueryHookResult = ReturnType<
  typeof useStipendExpensesByViewLazyQuery
>;
export type StipendExpensesByViewSuspenseQueryHookResult = ReturnType<
  typeof useStipendExpensesByViewSuspenseQuery
>;
export type StipendExpensesByViewQueryResult = Apollo.QueryResult<
  StipendExpensesByViewQuery,
  StipendExpensesByViewQueryVariables
>;
export const StipendRulesDocument = gql`
  query StipendRules(
    $filters: StipendRuleFilterInput
    $pagination: OffsetPaginationInput
  ) {
    stipendRules(filters: $filters, pagination: $pagination) {
      ... on QueryStipendRulesSuccess {
        data {
          stipendRules {
            id
            departmentIds
            departments {
              id
              name
            }
            iconUrl
            name
            isEnabled
            amountClaimed
            numberOfClaims
            amount
            longDetails
            category
            frequency
            terms
            isBalanceForwardable
            isSingleUsage
            createdAt
            startsAt
            expiresAt
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

/**
 * __useStipendRulesQuery__
 *
 * To run a query within a React component, call `useStipendRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStipendRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStipendRulesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useStipendRulesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StipendRulesQuery,
    StipendRulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StipendRulesQuery, StipendRulesQueryVariables>(
    StipendRulesDocument,
    options,
  );
}
export function useStipendRulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StipendRulesQuery,
    StipendRulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StipendRulesQuery, StipendRulesQueryVariables>(
    StipendRulesDocument,
    options,
  );
}
export function useStipendRulesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    StipendRulesQuery,
    StipendRulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<StipendRulesQuery, StipendRulesQueryVariables>(
    StipendRulesDocument,
    options,
  );
}
export type StipendRulesQueryHookResult = ReturnType<
  typeof useStipendRulesQuery
>;
export type StipendRulesLazyQueryHookResult = ReturnType<
  typeof useStipendRulesLazyQuery
>;
export type StipendRulesSuspenseQueryHookResult = ReturnType<
  typeof useStipendRulesSuspenseQuery
>;
export type StipendRulesQueryResult = Apollo.QueryResult<
  StipendRulesQuery,
  StipendRulesQueryVariables
>;
export const AdminSpendAnalyticsPerStipendDocument = gql`
  query AdminSpendAnalyticsPerStipend(
    $createdAfter: DateTime!
    $createdBefore: DateTime!
    $stipendExpenseStatus: [StipendExpenseStatus!]
  ) {
    adminSpendAnalyticsPerStipend(
      filters: {
        createdAfter: $createdAfter
        createdBefore: $createdBefore
        stipendExpenseStatus: $stipendExpenseStatus
      }
    ) {
      ... on QueryAdminSpendAnalyticsPerStipendSuccess {
        data {
          ruleId
          stipendExpenseCount
          totalExpenseAmount
          stipendDetail {
            category
            createdAt
            cycleEndDate
            cycleStartDate
            frequency
            iconUrl
            id
            isBalanceForwardable
            isSingleUsage
            longDetails
            name
            terms
          }
        }
      }
    }
  }
`;

/**
 * __useAdminSpendAnalyticsPerStipendQuery__
 *
 * To run a query within a React component, call `useAdminSpendAnalyticsPerStipendQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSpendAnalyticsPerStipendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSpendAnalyticsPerStipendQuery({
 *   variables: {
 *      createdAfter: // value for 'createdAfter'
 *      createdBefore: // value for 'createdBefore'
 *      stipendExpenseStatus: // value for 'stipendExpenseStatus'
 *   },
 * });
 */
export function useAdminSpendAnalyticsPerStipendQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminSpendAnalyticsPerStipendQuery,
    AdminSpendAnalyticsPerStipendQueryVariables
  > &
    (
      | {
          variables: AdminSpendAnalyticsPerStipendQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminSpendAnalyticsPerStipendQuery,
    AdminSpendAnalyticsPerStipendQueryVariables
  >(AdminSpendAnalyticsPerStipendDocument, options);
}
export function useAdminSpendAnalyticsPerStipendLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminSpendAnalyticsPerStipendQuery,
    AdminSpendAnalyticsPerStipendQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminSpendAnalyticsPerStipendQuery,
    AdminSpendAnalyticsPerStipendQueryVariables
  >(AdminSpendAnalyticsPerStipendDocument, options);
}
export function useAdminSpendAnalyticsPerStipendSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminSpendAnalyticsPerStipendQuery,
    AdminSpendAnalyticsPerStipendQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminSpendAnalyticsPerStipendQuery,
    AdminSpendAnalyticsPerStipendQueryVariables
  >(AdminSpendAnalyticsPerStipendDocument, options);
}
export type AdminSpendAnalyticsPerStipendQueryHookResult = ReturnType<
  typeof useAdminSpendAnalyticsPerStipendQuery
>;
export type AdminSpendAnalyticsPerStipendLazyQueryHookResult = ReturnType<
  typeof useAdminSpendAnalyticsPerStipendLazyQuery
>;
export type AdminSpendAnalyticsPerStipendSuspenseQueryHookResult = ReturnType<
  typeof useAdminSpendAnalyticsPerStipendSuspenseQuery
>;
export type AdminSpendAnalyticsPerStipendQueryResult = Apollo.QueryResult<
  AdminSpendAnalyticsPerStipendQuery,
  AdminSpendAnalyticsPerStipendQueryVariables
>;

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    Error: ["BaseError", "ValidationError"],
    ExpenseUnionItem: ["Expense", "StipendExpense"],
    GraphAnalyticGroupedEntity: [
      "Department",
      "ExpenseCategoryGLPairing",
      "User",
    ],
    MutationActivateCardResult: [
      "BaseError",
      "MutationActivateCardSuccess",
      "ValidationError",
    ],
    MutationAddExpenseToReportResult: [
      "BaseError",
      "MutationAddExpenseToReportSuccess",
      "ValidationError",
    ],
    MutationAdminUpdateOrganizationalFeatureFlagResult: [
      "BaseError",
      "MutationAdminUpdateOrganizationalFeatureFlagSuccess",
      "ValidationError",
    ],
    MutationAdminUpsertDepartmentResult: [
      "BaseError",
      "MutationAdminUpsertDepartmentSuccess",
      "ValidationError",
    ],
    MutationAdminUpsertExpenseCategoryGLPairingResult: [
      "BaseError",
      "MutationAdminUpsertExpenseCategoryGLPairingSuccess",
      "ValidationError",
    ],
    MutationAdminUpsertMileageResult: [
      "BaseError",
      "MutationAdminUpsertMileageSuccess",
      "ValidationError",
    ],
    MutationApproveOrRejectExpenseReportResult: [
      "BaseError",
      "MutationApproveOrRejectExpenseReportSuccess",
      "ValidationError",
    ],
    MutationApproveOrRejectStipendExpenseResult: [
      "BaseError",
      "MutationApproveOrRejectStipendExpenseSuccess",
      "ValidationError",
    ],
    MutationAwxAuthorizeBeneficiaryAccountResult: [
      "BaseError",
      "MutationAwxAuthorizeBeneficiaryAccountSuccess",
      "ValidationError",
    ],
    MutationAwxConnectLinkedAccountResult: [
      "BaseError",
      "MutationAwxConnectLinkedAccountSuccess",
      "ValidationError",
    ],
    MutationAwxCreateAndAuthorizeAccountResult: [
      "BaseError",
      "MutationAwxCreateAndAuthorizeAccountSuccess",
      "ValidationError",
    ],
    MutationCompletePersonalEmailUpdateResult: [
      "BaseError",
      "MutationCompletePersonalEmailUpdateSuccess",
      "ValidationError",
    ],
    MutationCreateACHPaymentMethodResult: [
      "BaseError",
      "MutationCreateACHPaymentMethodSuccess",
      "ValidationError",
    ],
    MutationCreateDisputeResult: [
      "BaseError",
      "MutationCreateDisputeSuccess",
      "ValidationError",
    ],
    MutationCreateGiftCardOrderResult: [
      "BaseError",
      "MutationCreateGiftCardOrderSuccess",
      "ValidationError",
    ],
    MutationCreateHypercardGiftCardOrderResult: [
      "BaseError",
      "MutationCreateHypercardGiftCardOrderSuccess",
      "ValidationError",
    ],
    MutationCreateInstantPaymentResult: [
      "BaseError",
      "MutationCreateInstantPaymentSuccess",
      "ValidationError",
    ],
    MutationCreateStipendRuleResult: [
      "BaseError",
      "MutationCreateStipendRuleSuccess",
      "ValidationError",
    ],
    MutationDeleteAwxBeneficiaryAccountResult: [
      "BaseError",
      "MutationDeleteAwxBeneficiaryAccountSuccess",
      "ValidationError",
    ],
    MutationDeleteDraftExpenseReportResult: [
      "BaseError",
      "MutationDeleteDraftExpenseReportSuccess",
      "ValidationError",
    ],
    MutationDeletePaymentMethodResult: [
      "BaseError",
      "MutationDeletePaymentMethodSuccess",
      "ValidationError",
    ],
    MutationHideGiftCardFromWalletResult: [
      "BaseError",
      "MutationHideGiftCardFromWalletSuccess",
      "ValidationError",
    ],
    MutationInitializeCardSwitchResult: [
      "BaseError",
      "MutationInitializeCardSwitchSuccess",
      "ValidationError",
    ],
    MutationInitiateAuthenticationResult: [
      "BaseError",
      "MutationInitiateAuthenticationSuccess",
      "ValidationError",
    ],
    MutationInvalidateRefreshTokenResult: [
      "BaseError",
      "MutationInvalidateRefreshTokenSuccess",
      "ValidationError",
    ],
    MutationInviteEmployeeResult: [
      "BaseError",
      "MutationInviteEmployeeSuccess",
      "ValidationError",
    ],
    MutationParseReceiptWithOCRResult: [
      "BaseError",
      "MutationParseReceiptWithOCRSuccess",
      "ValidationError",
    ],
    MutationProcessExpenseReportDownloadAndGetUrlResult: [
      "BaseError",
      "MutationProcessExpenseReportDownloadAndGetUrlSuccess",
      "ValidationError",
    ],
    MutationProvisionAppleWalletResult: [
      "BaseError",
      "MutationProvisionAppleWalletSuccess",
      "ValidationError",
    ],
    MutationProvisionGoogleWalletResult: [
      "BaseError",
      "MutationProvisionGoogleWalletSuccess",
      "ValidationError",
    ],
    MutationRedeemPointsForCashbackResult: [
      "BaseError",
      "MutationRedeemPointsForCashbackSuccess",
      "ValidationError",
    ],
    MutationReferColleaguesResult: [
      "BaseError",
      "MutationReferColleaguesSuccess",
      "ValidationError",
    ],
    MutationRefreshAccessTokenResult: [
      "BaseError",
      "MutationRefreshAccessTokenSuccess",
      "ValidationError",
    ],
    MutationRegisterNotifyMeForFeatureResult: [
      "BaseError",
      "MutationRegisterNotifyMeForFeatureSuccess",
      "ValidationError",
    ],
    MutationRegisterOfferAnalyticResult: [
      "BaseError",
      "MutationRegisterOfferAnalyticSuccess",
      "ValidationError",
    ],
    MutationRemoveAutoPaymentScheduleResult: [
      "BaseError",
      "MutationRemoveAutoPaymentScheduleSuccess",
      "ValidationError",
    ],
    MutationRemoveExpenseFromReportResult: [
      "BaseError",
      "MutationRemoveExpenseFromReportSuccess",
      "ValidationError",
    ],
    MutationReplaceCardResult: [
      "BaseError",
      "MutationReplaceCardSuccess",
      "ValidationError",
    ],
    MutationSendEmailOTPResult: [
      "BaseError",
      "MutationSendEmailOTPSuccess",
      "ValidationError",
    ],
    MutationSimulateTransactionResult: [
      "BaseError",
      "MutationSimulateTransactionSuccess",
      "ValidationError",
    ],
    MutationStartEmployeeApplicationResult: [
      "BaseError",
      "MutationStartEmployeeApplicationSuccess",
      "ValidationError",
    ],
    MutationStartPersonalEmailUpdateResult: [
      "BaseError",
      "MutationStartPersonalEmailUpdateSuccess",
      "ValidationError",
    ],
    MutationStartWaitlistUserApplicationResult: [
      "BaseError",
      "MutationStartWaitlistUserApplicationSuccess",
      "ValidationError",
    ],
    MutationSubmitDraftExpenseReportResult: [
      "BaseError",
      "MutationSubmitDraftExpenseReportSuccess",
      "ValidationError",
    ],
    MutationSubmitEmployeeApplicationResult: [
      "BaseError",
      "MutationSubmitEmployeeApplicationSuccess",
      "ValidationError",
    ],
    MutationSubmitFeedbackResult: [
      "BaseError",
      "MutationSubmitFeedbackSuccess",
      "ValidationError",
    ],
    MutationSubmitStipendExpenseResult: [
      "BaseError",
      "MutationSubmitStipendExpenseSuccess",
      "ValidationError",
    ],
    MutationSubmitStipendExpenseV2Result: [
      "BaseError",
      "MutationSubmitStipendExpenseV2Success",
      "ValidationError",
    ],
    MutationSubmitWaitlistUserApplicationResult: [
      "BaseError",
      "MutationSubmitWaitlistUserApplicationSuccess",
      "ValidationError",
    ],
    MutationSuspendLinkedAccountResult: [
      "BaseError",
      "MutationSuspendLinkedAccountSuccess",
      "ValidationError",
    ],
    MutationTerminateEmployeeProfileResult: [
      "BaseError",
      "MutationTerminateEmployeeProfileSuccess",
      "ValidationError",
    ],
    MutationTestExpensePolicyResult: [
      "BaseError",
      "MutationTestExpensePolicySuccess",
      "ValidationError",
    ],
    MutationUnfreezeCreditBureauResult: [
      "BaseError",
      "MutationUnfreezeCreditBureauSuccess",
      "ValidationError",
    ],
    MutationUpdateCardPinResult: [
      "BaseError",
      "MutationUpdateCardPinSuccess",
      "ValidationError",
    ],
    MutationUpdateCurrentUserEmployeeDelegatesResult: [
      "BaseError",
      "MutationUpdateCurrentUserEmployeeDelegatesSuccess",
      "ValidationError",
    ],
    MutationUpdateDelegateTransactionAccessResult: [
      "BaseError",
      "MutationUpdateDelegateTransactionAccessSuccess",
      "ValidationError",
    ],
    MutationUpdateEmployeeResult: [
      "BaseError",
      "MutationUpdateEmployeeSuccess",
      "ValidationError",
    ],
    MutationUpdateEmployeesToDepartmentResult: [
      "BaseError",
      "MutationUpdateEmployeesToDepartmentSuccess",
      "ValidationError",
    ],
    MutationUpdateExpenseResult: [
      "BaseError",
      "MutationUpdateExpenseSuccess",
      "ValidationError",
    ],
    MutationUpdateFreezeStatusResult: [
      "BaseError",
      "MutationUpdateFreezeStatusSuccess",
      "ValidationError",
    ],
    MutationUpdateNotificationSettingsResult: [
      "BaseError",
      "MutationUpdateNotificationSettingsSuccess",
      "ValidationError",
    ],
    MutationUpdateProductAcceptanceResult: [
      "BaseError",
      "MutationUpdateProductAcceptanceSuccess",
      "ValidationError",
    ],
    MutationUpdateSAPConnectionResult: [
      "BaseError",
      "MutationUpdateSAPConnectionSuccess",
      "ValidationError",
    ],
    MutationUpdateStipendRuleResult: [
      "BaseError",
      "MutationUpdateStipendRuleSuccess",
      "ValidationError",
    ],
    MutationUpdateUserAddressResult: [
      "BaseError",
      "MutationUpdateUserAddressSuccess",
      "ValidationError",
    ],
    MutationUpdateUserPreferencesResult: [
      "BaseError",
      "MutationUpdateUserPreferencesSuccess",
      "ValidationError",
    ],
    MutationUpsertAndRemoveReportExpensesResult: [
      "BaseError",
      "MutationUpsertAndRemoveReportExpensesSuccess",
      "ValidationError",
    ],
    MutationUpsertAutoPaymentScheduleResult: [
      "BaseError",
      "MutationUpsertAutoPaymentScheduleSuccess",
      "ValidationError",
    ],
    MutationUpsertAwxBeneficiaryAccountResult: [
      "BaseError",
      "MutationUpsertAwxBeneficiaryAccountSuccess",
      "ValidationError",
    ],
    MutationUpsertCustomFieldListOptionResult: [
      "BaseError",
      "MutationUpsertCustomFieldListOptionSuccess",
      "ValidationError",
    ],
    MutationUpsertCustomFieldResult: [
      "BaseError",
      "MutationUpsertCustomFieldSuccess",
      "ValidationError",
    ],
    MutationUpsertExpenseReportResult: [
      "BaseError",
      "MutationUpsertExpenseReportSuccess",
      "ValidationError",
    ],
    MutationUpsertPolicyResult: [
      "BaseError",
      "MutationUpsertPolicySuccess",
      "ValidationError",
    ],
    MutationValidateSAPConnectionAndStoreTokenResult: [
      "BaseError",
      "MutationValidateSAPConnectionAndStoreTokenSuccess",
      "ValidationError",
    ],
    MutationValidateStipendRuleResult: [
      "BaseError",
      "MutationValidateStipendRuleSuccess",
      "ValidationError",
    ],
    MutationVerifyAuthCodeResult: [
      "BaseError",
      "MutationVerifyAuthCodeSuccess",
      "ValidationError",
    ],
    MutationVerifyOTPCodeResult: [
      "BaseError",
      "MutationVerifyOTPCodeSuccess",
      "ValidationError",
    ],
    MutationWithdrawDisputeResult: [
      "BaseError",
      "MutationWithdrawDisputeSuccess",
      "ValidationError",
    ],
    QueryAccountResult: ["BaseError", "QueryAccountSuccess", "ValidationError"],
    QueryAchAuthLinkTokenResult: [
      "BaseError",
      "QueryAchAuthLinkTokenSuccess",
      "ValidationError",
    ],
    QueryActiveAutoPaymentResult: [
      "BaseError",
      "QueryActiveAutoPaymentSuccess",
      "ValidationError",
    ],
    QueryActiveEmployeeProfileRecommendationsResult: [
      "BaseError",
      "QueryActiveEmployeeProfileRecommendationsSuccess",
      "ValidationError",
    ],
    QueryActivePointsMultiplierResult: [
      "BaseError",
      "QueryActivePointsMultiplierSuccess",
      "ValidationError",
    ],
    QueryAdminCustomFieldListOptionsResult: [
      "BaseError",
      "QueryAdminCustomFieldListOptionsSuccess",
      "ValidationError",
    ],
    QueryAdminCustomFieldsResult: [
      "BaseError",
      "QueryAdminCustomFieldsSuccess",
      "ValidationError",
    ],
    QueryAdminExpenseCategoriesResult: [
      "BaseError",
      "QueryAdminExpenseCategoriesSuccess",
      "ValidationError",
    ],
    QueryAdminExpenseSummaryByGroupResult: [
      "BaseError",
      "QueryAdminExpenseSummaryByGroupSuccess",
      "ValidationError",
    ],
    QueryAdminOrganizationExpensesResult: [
      "BaseError",
      "QueryAdminOrganizationExpensesSuccess",
      "ValidationError",
    ],
    QueryAdminReimbursementsTimeSavedInSecondsResult: [
      "BaseError",
      "QueryAdminReimbursementsTimeSavedInSecondsSuccess",
      "ValidationError",
    ],
    QueryAdminReportCountsPerStatusResult: [
      "BaseError",
      "QueryAdminReportCountsPerStatusSuccess",
      "ValidationError",
    ],
    QueryAdminReportGraphMetricsResult: [
      "BaseError",
      "QueryAdminReportGraphMetricsSuccess",
      "ValidationError",
    ],
    QueryAdminSpendAnalyticsPerStipendResult: [
      "BaseError",
      "QueryAdminSpendAnalyticsPerStipendSuccess",
      "ValidationError",
    ],
    QueryAdminStipendGraphMetricsResult: [
      "BaseError",
      "QueryAdminStipendGraphMetricsSuccess",
      "ValidationError",
    ],
    QueryAdminStipendSummaryResult: [
      "BaseError",
      "QueryAdminStipendSummarySuccess",
      "ValidationError",
    ],
    QueryAdminTopReimbursersForExpenseReportsResult: [
      "BaseError",
      "QueryAdminTopReimbursersForExpenseReportsSuccess",
      "ValidationError",
    ],
    QueryAdminTopReimbursersForStipendsResult: [
      "BaseError",
      "QueryAdminTopReimbursersForStipendsSuccess",
      "ValidationError",
    ],
    QueryApplicationContextResult: [
      "BaseError",
      "QueryApplicationContextSuccess",
      "ValidationError",
    ],
    QueryAuthenticationUrlResult: [
      "BaseError",
      "QueryAuthenticationUrlSuccess",
      "ValidationError",
    ],
    QueryAwxOrganizationStateResult: [
      "BaseError",
      "QueryAwxOrganizationStateSuccess",
      "ValidationError",
    ],
    QueryBeneficiaryResult: [
      "BaseError",
      "QueryBeneficiarySuccess",
      "ValidationError",
    ],
    QueryCardArtResult: ["BaseError", "QueryCardArtSuccess", "ValidationError"],
    QueryCardholderResult: [
      "BaseError",
      "QueryCardholderSuccess",
      "ValidationError",
    ],
    QueryCurrentUserResult: [
      "BaseError",
      "QueryCurrentUserSuccess",
      "ValidationError",
    ],
    QueryCustomFieldVisibleListOptionsResult: [
      "BaseError",
      "QueryCustomFieldVisibleListOptionsSuccess",
      "ValidationError",
    ],
    QueryDepartmentResult: [
      "BaseError",
      "QueryDepartmentSuccess",
      "ValidationError",
    ],
    QueryDepartmentsResult: [
      "BaseError",
      "QueryDepartmentsSuccess",
      "ValidationError",
    ],
    QueryEmployeeAttendeeRecommendationsResult: [
      "BaseError",
      "QueryEmployeeAttendeeRecommendationsSuccess",
      "ValidationError",
    ],
    QueryEmployeeReferralRecommendationsResult: [
      "BaseError",
      "QueryEmployeeReferralRecommendationsSuccess",
      "ValidationError",
    ],
    QueryExpensePoliciesResult: [
      "BaseError",
      "QueryExpensePoliciesSuccess",
      "ValidationError",
    ],
    QueryExpenseReportResult: [
      "BaseError",
      "QueryExpenseReportSuccess",
      "ValidationError",
    ],
    QueryExpenseReportsByViewResult: [
      "BaseError",
      "QueryExpenseReportsByViewSuccess",
      "ValidationError",
    ],
    QueryExpenseReportsResult: [
      "BaseError",
      "QueryExpenseReportsSuccess",
      "ValidationError",
    ],
    QueryFilterOptionsResult: [
      "BaseError",
      "QueryFilterOptionsSuccess",
      "ValidationError",
    ],
    QueryGiftCardCatalogResult: [
      "BaseError",
      "QueryGiftCardCatalogSuccess",
      "ValidationError",
    ],
    QueryGiftCardWalletResult: [
      "BaseError",
      "QueryGiftCardWalletSuccess",
      "ValidationError",
    ],
    QueryHypercardGiftCardCatalogResult: [
      "BaseError",
      "QueryHypercardGiftCardCatalogSuccess",
      "ValidationError",
    ],
    QueryIdpStatusCheckResult: [
      "BaseError",
      "QueryIdpStatusCheckSuccess",
      "ValidationError",
    ],
    QueryInsurancesResult: [
      "BaseError",
      "QueryInsurancesSuccess",
      "ValidationError",
    ],
    QueryLinkFeatureFlagsResult: [
      "BaseError",
      "QueryLinkFeatureFlagsSuccess",
      "ValidationError",
    ],
    QueryLinkedAccountResult: [
      "BaseError",
      "QueryLinkedAccountSuccess",
      "ValidationError",
    ],
    QueryMileageResult: ["BaseError", "QueryMileageSuccess", "ValidationError"],
    QueryMinimumStableVersionResult: [
      "BaseError",
      "QueryMinimumStableVersionSuccess",
      "ValidationError",
    ],
    QueryNetSavingsThisMonthResult: [
      "BaseError",
      "QueryNetSavingsThisMonthSuccess",
      "ValidationError",
    ],
    QueryNotificationSettingsResult: [
      "BaseError",
      "QueryNotificationSettingsSuccess",
      "ValidationError",
    ],
    QueryOffersResult: ["BaseError", "QueryOffersSuccess", "ValidationError"],
    QueryOrganizationCardDesignsResult: [
      "BaseError",
      "QueryOrganizationCardDesignsSuccess",
      "ValidationError",
    ],
    QueryOrganizationOnboardingContextByLandingPagePrefixResult: [
      "BaseError",
      "QueryOrganizationOnboardingContextByLandingPagePrefixSuccess",
      "ValidationError",
    ],
    QueryOrganizationResult: [
      "BaseError",
      "QueryOrganizationSuccess",
      "ValidationError",
    ],
    QueryOrganizationUserResult: [
      "BaseError",
      "QueryOrganizationUserSuccess",
      "ValidationError",
    ],
    QueryOrganizationUsersResult: [
      "BaseError",
      "QueryOrganizationUsersSuccess",
      "ValidationError",
    ],
    QueryOrganizationalFeatureFlagsResult: [
      "BaseError",
      "QueryOrganizationalFeatureFlagsSuccess",
      "ValidationError",
    ],
    QueryPaymentMethodsResult: [
      "BaseError",
      "QueryPaymentMethodsSuccess",
      "ValidationError",
    ],
    QueryPointToDollarConversionResult: [
      "BaseError",
      "QueryPointToDollarConversionSuccess",
      "ValidationError",
    ],
    QueryPrimaryCardResult: [
      "BaseError",
      "QueryPrimaryCardSuccess",
      "ValidationError",
    ],
    QueryRecentExpenseActivitiesResult: [
      "BaseError",
      "QueryRecentExpenseActivitiesSuccess",
      "ValidationError",
    ],
    QueryReferralOfferResult: [
      "BaseError",
      "QueryReferralOfferSuccess",
      "ValidationError",
    ],
    QueryRewardResult: ["BaseError", "QueryRewardSuccess", "ValidationError"],
    QueryRewardsResult: ["BaseError", "QueryRewardsSuccess", "ValidationError"],
    QueryStatementResult: [
      "BaseError",
      "QueryStatementSuccess",
      "ValidationError",
    ],
    QueryStatementsResult: [
      "BaseError",
      "QueryStatementsSuccess",
      "ValidationError",
    ],
    QueryStipendExpenseResult: [
      "BaseError",
      "QueryStipendExpenseSuccess",
      "ValidationError",
    ],
    QueryStipendExpensesByViewResult: [
      "BaseError",
      "QueryStipendExpensesByViewSuccess",
      "ValidationError",
    ],
    QueryStipendRulesResult: [
      "BaseError",
      "QueryStipendRulesSuccess",
      "ValidationError",
    ],
    QueryStipendWalletResult: [
      "BaseError",
      "QueryStipendWalletSuccess",
      "ValidationError",
    ],
    QueryStipendWalletsResult: [
      "BaseError",
      "QueryStipendWalletsSuccess",
      "ValidationError",
    ],
    QueryTotalPendingReimbursementAmountResult: [
      "BaseError",
      "QueryTotalPendingReimbursementAmountSuccess",
      "ValidationError",
    ],
    QueryTotalPointsResult: [
      "BaseError",
      "QueryTotalPointsSuccess",
      "ValidationError",
    ],
    QueryTotalReimbursedAmountResult: [
      "BaseError",
      "QueryTotalReimbursedAmountSuccess",
      "ValidationError",
    ],
    QueryTransactionResult: [
      "BaseError",
      "QueryTransactionSuccess",
      "ValidationError",
    ],
    QueryTransactionSumResult: [
      "BaseError",
      "QueryTransactionSumSuccess",
      "ValidationError",
    ],
    QueryTransactionsResult: [
      "BaseError",
      "QueryTransactionsSuccess",
      "ValidationError",
    ],
    QueryUserFeatureFlagsResult: [
      "BaseError",
      "QueryUserFeatureFlagsSuccess",
      "ValidationError",
    ],
    QueryVisibleCustomFieldsResult: [
      "BaseError",
      "QueryVisibleCustomFieldsSuccess",
      "ValidationError",
    ],
    QueryVisibleExpenseCategoriesResult: [
      "BaseError",
      "QueryVisibleExpenseCategoriesSuccess",
      "ValidationError",
    ],
    SubmitDraftExpenseReportResult: [
      "ReportPolicyCheckerResult",
      "SubmittedReportResult",
    ],
    SubmitStipendExpenseV2Result: [
      "StipendExpensePolicyCheckerResult",
      "SubmittedStipendExpenseResult",
    ],
    TransactionItem: ["PaymentTransaction", "Transaction"],
  },
};
export default result;
